<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :hot-key-create-path="'/sales-order-old/create'"
    :hot-key-grid-tab-index="isTablet ? 1 : 0"
    :hot-key-expand="expandGrid"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Sales Order"
        :baseView="baseView"
        :primaryLabel="model.Name"
        :secondaryLabel="model.CustomerName"
        v-if="baseView.mode != 'create' ? model.CustomerName : dataLoaded"
      />
    </template>

    <gc-tabs
      :tabs="tabs"
      :selected-index.sync="selectedIndex"
      v-if="this.applicationMode == 'GcorpRoam' ? true : false"
    />
    <div v-show="selectedIndex == 0">
      <DxToolbar
        ref="toolbar-header"
        class="view-toolbar sales-order-toolbar"
        id="so-header"
      >
        <DxItem
          widget="dxForm"
          location="before"
          :options="{
            formData: this.model,
            items: this.toolbarFormItems,
            validationGroup: this.formsConfig.validationGroup,
            labelLocation: 'left',
            customizeItem: customizeItem,
          }"
          locate-in-menu="auto"
          ref="so-toolbar-form"
          cssClass="header-item-form"
        ></DxItem>

        <DxItem #default location="after" locate-in-menu="auto">
          <gc-status-chip :status="statusFreindly" />
        </DxItem>
        <DxItem
          :options="toolbar.audit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        />
        <DxItem
          :options="toolbar.notes"
          location="after"
          locate-in-menu="auto"
          widget="dxDropDownButton"
        />
        <DxItem
          :options="toolbar.edit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
          :visible.sync="isEditVisible"
        />
        <DxItem
          :options="toolbar.menu"
          location="after"
          locate-in-menu="auto"
          widget="dxDropDownButton"
          v-if="baseView.mode != 'review'"
          ref="headerSaveMenu"
        />

        <template #agentTemplate="{ data }">
          <div class="toolbar-auto-complete">
            <span class="title">{{ data.Name }}</span>
            <span class="sub-title" style="color: grey">{{ data.Code }}</span>
          </div>
        </template>
        <DxItem
          :options="toolbar.status"
          location="after"
          locate-in-menu="auto"
          widget="dxDropDownButton"
          v-if="baseView.mode == 'review' || baseView.mode == 'create'"
        />
      </DxToolbar>
    </div>

    <DxPopup
      :visible.sync="gridTotalsVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Size Totals"
      :width="1000"
      :height="getGridTotalPopUpHeight"
      :showCloseButton="false"
    >
      <div>
        <dx-data-grid
          :data-source="gridTotalsDataSource"
          :ref="'grid-size-total-grid'"
          :columns="sizeTotalGridColumns"
          v-if="gridTotalsVisible"
          @content-ready="gridTotalsOnContentReady"
          :allow-column-reordering="false"
          :column-chooser="{ enabled: false }"
        >
          <DxSearchPanel :visible="false" />
        </dx-data-grid>
      </div>
      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>

    <DxPopup
      :visible.sync="lineCommentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Line Comment"
      :width="550"
      :height="400"
      :showCloseButton="false"
    >
      <form>
        <DxForm
          :ref="'line-comments-form'"
          :customizeItem="customizeLineCommentItem"
          :form-data.sync="lineCommentModel"
          :items="lineCommentItems"
          :label-location="formsConfig.labelPosition"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupLineCommentBackButtonClick"
        />
      </div>
    </DxPopup>

    <DxPopup
      :visible.sync="commentsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Sales Order Comments"
      :width="550"
      :height="620"
      :showCloseButton="false"
    >
      <form>
        <DxForm
          :ref="'comments-form'"
          :customizeItem="customizeItem"
          :form-data.sync="model"
          :items="commentItems"
          :scrolling-enabled="true"
          :height="450"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>
    <DxPopup
      :visible.sync="notesPopupVisible"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Order Notes"
      :width="750"
      :height="575"
      :showCloseButton="false"
      @hidden="onNotesPopupHidden"
    >
      <div>
        <dx-data-grid
          :ref="gridRefName"
          :data-source="orderNotesDataSourceConfig"
          :columns="columns"
          @toolbar-preparing="notesToolbarPreparing($event)"
          :height="416"
          :width="700"
          @editor-preparing="setMaxLength($event)"
          @row-click="onRowClick($event)"
          :allow-column-reordering="false"
          :column-chooser="{ enabled: false }"
        >
          <DxEditing
            :allow-deleting="baseView.mode != 'review'"
            :allow-updating="baseView.mode != 'review'"
            mode="cell"
          />
          <template #note-template="{ data }">
            <div class="gc-so-note-template">
              {{ data.data.Note }}
              <!-- <DxButton :disabled="!deleteEnabled" icon="trash" @click="onDeleteClick(data)" /> -->
            </div>
          </template>

          <!-- <dx-paging :page-size="3" /> -->
        </dx-data-grid>

        <div class="footer">
          <DxButton
            text="Back"
            type="default"
            styling-mode="contained"
            @click="popUpBackButtonClick"
          />
        </div>
      </div>
    </DxPopup>
    <!-- <div>Customer {{ model.CustomerCode }}</div> -->
    <div
      v-show="selectedIndex == 0 && !this.gridExpanded"
      class="view-card responsive-paddings sales-order-form"
    >
      <form v-if="dataLoaded">
        <DxForm
          :form-data.sync="model"
          :read-only="false"
          :show-colon-after-label="false"
          :show-required-mark="false"
          :show-validation-summary="false"
          validation-group="headerFormData"
          :label-location="formsConfig.labelPosition"
          :customizeItem="customizeItem"
          :items="headerFormItems"
          ref="so-header-form"
          @content-ready="headerFormOnContentReady"
        >
          <template #branchTemplate="{ data }">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary">{{ data.Description }}</span>
              <span class="auto-complete-secondary">{{ data.Code }}</span>
            </div>
          </template>

          <template #divisionTemplate="{ data }">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary">{{ data.Description }}</span>
              <span class="auto-complete-secondary">{{ data.Code }}</span>
            </div>
          </template>

          <template #soTemplate="{ data }">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary">{{ data.Description }}</span>
              <span class="auto-complete-secondary">{{ data.Code }}</span>
            </div>
          </template>

          <template #salesRepTemplate="{ data }">
            <div class="custom-auto-complete">
              <span class="auto-complete-primary"
                >{{ data.FirstName }} {{ data.Surname }}</span
              >
              <span class="auto-complete-secondary">{{ data.Code }}</span>
            </div>
          </template>

          <!-- SelectBox Template  -->
          <template #deliveryAddressTemplate="{ data }">
            <div class="custom-auto-complete data-grid">
              <span class="auto-complete-primary">{{ data.CompanyName }}</span>
              <div class="auto-complete-secondary no-padding">
                <span v-if="data.PhysicalAddressStreetLine1 != ''">
                  {{ data.PhysicalAddressStreetLine1 }}
                </span>
                <span v-if="data.PhysicalAddressStreetLine2 != ''">{{
                  data.PhysicalAddressStreetLine2
                }}</span>
                <span v-if="data.PhysicalAddressSuburb != ''">{{
                  data.PhysicalAddressSuburb
                }}</span>
                <span v-if="data.PhysicalAddressState != ''">{{
                  data.PhysicalAddressState
                }}</span>
                <span v-if="data.PhysicalAddressPostcode != ''">{{
                  data.PhysicalAddressPostcode
                }}</span>
              </div>
            </div>
          </template>
          <template #editAddressTemplate>
            <div class="edit-address-btn">
              <span @click="editDeliveryAddress">
                <a>{{ baseView.mode == "review" ? "View" : "Edit" }}</a>
              </span>
            </div>
          </template>
        </DxForm>
      </form>
    </div>

    <div
      v-show="isTablet ? selectedIndex == 1 : true"
      class="details-view sales-order-split-view"
    >
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
        :rightContainerWidth="isTablet ? 300 : 410"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="salesOrderDetailsDataSourceConfig"
            :ref="soDetailsGridRefName"
            :hover-state-enabled="false"
            :columns="soDetailsColumns"
            :reshape-on-push="true"
            @toolbar-preparing="onToolbarPreparingSoDetails($event)"
            @editing-start="onEditingStartSoDetails"
            :height="soDetailsGridHeight"
            @cell-click="onSoDetailsColumnHeaderClick"
            @initialized="onSoDetailsInitialized"
            @cell-prepared="onCellPrepared"
            @key-down="onKeyDown"
            @content-ready="soDetailsGridonContentReady"
            :column-chooser="{ enabled: false }"
            v-if="
              baseView.mode != 'create'
                ? dataLoaded
                : !isTablet
                ? dataLoaded
                : true
            "
          >
            <DxKeyboardNavigation />

            <DxEditing
              :allow-updating="true"
              :select-text-on-edit-start="true"
              start-edit-action="click"
              mode="batch"
            />

            <template #primaryImageGridTemplate="{ data }">
              <div class="image-cell" @click="clickOnImage(data)">
                <GcGridProductImage
                  :ItemCode="data.data.Model"
                  :HasPrimaryImage="data.data.HasPrimaryImage"
                  :Description="data.data.Description"
                />
              </div>
            </template>
            <template #primaryImageTemplate="{ data }">
              <div class="image-cell" @click="clickOnImage(data)">
                <GcGridProductImage
                  :ItemCode="data.data.ItemCode"
                  :HasPrimaryImage="data.data.HasPrimaryImage"
                  :Description="data.data.Description"
                />
              </div>
            </template>

            <template #promotionTemplate="{ data }">
              <div v-show="data.data.HasPromotion == true">
                <DxButton
                  icon="money"
                  :disabled="true"
                  class="promotional-indicator"
                />
              </div>
            </template>

            <template #availableLabel>
              <div class="gc-available-label">
                <div>avail</div>
              </div>
            </template>

            <template #qtyEditTemplate="{ data }">
              <div>
                <div
                  v-bind:class="{
                    'key-pad-focused': data.data.SalesUMQtyFocused,
                  }"
                >
                  <DxNumberBox
                    :value="data.value"
                    value-change-event="keyup"
                    @value-changed="
                      onSoDetailsViewQtyChangedDebounced($event, data)
                    "
                    :disabled="baseView.mode == 'review' ? true : false"
                    :format="getDecimalFormatByCode(7).Format"
                    class="gc-grid-number-box-editor"
                    @focus-in="onSoDetailsViewQtyFocused($event, data)"
                    :min="-99999999"
                    :max="99999999"
                    :step="0"
                  />
                </div>
              </div>
            </template>

            <template #discountTemplate="{ data }">
              <div>
                <div>
                  <DxNumberBox
                    :value="data.value"
                    @value-changed="onSoDetailsDiscountChanged($event, data)"
                    :disabled="
                      baseView.mode == 'review'
                        ? true
                        : !checkFeaturePermission(
                            'SalesOrderDetailEditDiscount',
                            'edit'
                          )
                    "
                    :format="getDecimalFormatByCode(6).Format"
                    class="gc-grid-number-box-editor"
                    :step="0"
                  />
                </div>
              </div>
            </template>

            <template #priceEditTemplate="{ data }">
              <div>
                <div>
                  <DxNumberBox
                    :value="data.value"
                    @value-changed="onSoDetailsPriceChanged($event, data)"
                    :disabled="
                      baseView.mode == 'review'
                        ? true
                        : !checkFeaturePermission(
                            'SalesOrderDetailEditPrice',
                            'edit'
                          )
                    "
                    :format="getDecimalFormatByCode(13).Format"
                    class="gc-grid-number-box-editor"
                    :min="-99999999"
                    :max="99999999"
                    :step="0"
                  />
                </div>
              </div>
            </template>

            <template #salesUMEditTemplate="{ data: cellInfo }">
              <div class="gc-auto-cmp-editor">
                <GcSalesUmDropdown
                  :on-value-changed="onSoDetailsSalesUMChanged"
                  :ref="'salesUM' + cellInfo.rowIndex"
                  :data-source="
                    getSalesUmDataSourceForItemCode(cellInfo.data.ItemCode)
                  "
                  :value="cellInfo.value"
                  :cell-info="cellInfo"
                  :focus-in="onSoDetailsViewSalesUMFocused"
                />
              </div>
            </template>

            <template #sizeQtyEditTemplate="{ data }">
              <div class="gc-editor-cell">
                <div
                  v-bind:class="{
                    'key-pad-focused':
                      data.data[`Size${data.column.name}QtyFocused`],
                  }"
                  v-if="data.data[`Size${data.column.name}ReadOnly`] !== true"
                >
                  <DxNumberBox
                    :value="data.value"
                    @value-changed="onGridListViewSizeQtyChanged($event, data)"
                    :disabled="baseView.mode == 'review' ? true : false"
                    :format="getDecimalFormatByCode(7).Format"
                    class="gc-grid-number-box-editor"
                    @focus-in="onGridListViewSizeQtyFocused($event, data)"
                    :step="0"
                  />
                </div>

                <div
                  class="gc-available-label-qty"
                  v-if="data.data[`Size${data.column.name}ReadOnly`] !== true"
                >
                  <div>
                    {{
                      data.data["Size" + data.column.name + "Available"]
                        | number("0,0.00", { thousandsSeparator: "," })
                    }}
                  </div>
                </div>
              </div>
            </template>

            <template #menu-cell-template="{ data }">
              <DxDropDownButton
                :items="[
                  { menuText: 'Line Comment', data: data },
                  { menuText: 'Item History', data: data },
                  {
                    menuText: 'Copy Line',
                    data: data,
                    visible: baseView.mode != 'review' ? true : false,
                  },
                  {
                    menuText: 'Item Price Update',
                    data: data,
                    visible: ItemPriceVisible,
                  },
                  {
                    menuText: 'GP Tool',
                    data: data,
                    visible:
                      baseView.mode != 'review' &&
                      hasGpToolAccess &&
                      data.data.Status !== 'C'
                        ? true
                        : false,
                  },
                  { menuText: 'Best Before Date', data: data },
                ]"
                keyExpr="menuText"
                displayExpr="menuText"
                :drop-down-options="{ width: 250 }"
                class="gc-dropdown-icon-button"
                :id="data.data.ItemCode"
                :icon="soDetailsLineContextMenu.icon"
                styling-mode="text"
                :show-arrow-icon="false"
                :onItemClick="onSoDetailsLineContextMenuItemClick"
                :visible="formsConfig.editableOption"
              />
            </template>

            <template #sales-um-template="{ data }">
              <div class="gc-auto-cmp">{{ data.data.SalesUM }}</div>
            </template>

            <template #statusTemplate>
              <gc-status-chip :status="statusFreindly" />
            </template>

            <template #available-template="{ data }">
              <div>
                <span
                  v-if="data.value < 0"
                  class="hyper-link"
                  @click="visibleStockLevel(data.data)"
                  >{{ data.text }}</span
                >
                <span
                  v-else
                  class="hyper-link color"
                  @click="visibleStockLevel(data.data)"
                >
                  {{ data.text }}</span
                >
              </div>
            </template>
          </dx-data-grid>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <dx-item
              location="before"
              widget="dxTabs"
              :options="filterPanelTabOptions"
              :selected-index.sync="sidebarTabSelectedIndex"
            ></dx-item>

            <DxItem
              :options="filterToolbar.clear"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="false"
            />

            <DxItem
              :options="filterToolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>

          <div v-show="sidebarTabSelectedIndex == 0">
            <div class="view-card responsive-paddings gc-advanced-filter">
              <DxScrollView
                id="filter-scrollview"
                :show-scrollbar="'always'"
                :scroll-by-content="true"
                :scroll-by-thumb="true"
              >
                <form>
                  <DxForm
                    :form-data.sync="advanceFilter.model"
                    :show-colon-after-label="false"
                    :show-required-mark="false"
                    :show-validation-summary="false"
                    :validation-group="'advance-filter-form'"
                    :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                    label-location="top"
                    :items="filterItems"
                    ref="so-filter-form"
                    :scrolling-enabled="true"
                    :height="advanceFilter.filterFormHeight"
                  >
                    <template #ProductCategory1Template="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                    <template #ProductCategory2Template="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                    <template #ProductCategory3Template="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                    <template #ProductCategory4Template="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                    <template #ProductTypeTemplate="{ data }">
                      <div class="custom-auto-complete">
                        <span class="auto-complete-primary">{{
                          data.Description
                        }}</span>
                        <span class="auto-complete-secondary">{{
                          data.Code
                        }}</span>
                      </div>
                    </template>
                    <!-- <template #filterCustomerTemplate="{ data }">
                  <div class="toolbar-auto-complete">
                    <span class="title">{{ data.Name }}</span>
                    <span class="sub-title" style="color:grey;">{{
                      data.Code
                    }}</span>
                  </div>
                </template>

                <template #filterCustomerRepTemplate="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary"
                      >{{ data.FirstName }} {{ data.Surname }}</span
                    >
                    <span class="auto-complete-secondary">{{ data.Code }}</span>
                  </div>
                    </template>-->
                  </DxForm>
                </form>

                <div class="gc-advanced-filter-toolbar">
                  <DxButton
                    text="clear"
                    type="normal"
                    @click="clearAdvanceFilters"
                  />
                </div>
              </DxScrollView>
            </div>
          </div>
          <div v-show="sidebarTabSelectedIndex == 1">
            <gc-number-pad />
          </div>
        </template>
      </gc-filter-split-view>
    </div>

    <!-- <div v-if="!isTablet">
      <span>not tablet</span>
    </div>-->

    <!-- account status popup  -->

    <GcAccountStatusModal
      v-if="popupVisible"
      :parent-model="model"
      :show-modal.sync="popupVisible"
      @close-form="popUpBackButtonClick"
      @show-loading="showLoadingHelper"
    />

    <!-- items history popup  -->
    <DxPopup
      :visible.sync="itemHistoryPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Customer Item History"
      :showCloseButton="false"
      :height="700"
      @hidden="itemHistoryPopupHidden"
    >
      <dx-data-grid
        :data-source="customerItemHistoryDataSourceConfig"
        :height="540"
        :columns="customerItemHistoryColumns"
        @toolbar-preparing="itemHistoryToolbarPreparing($event)"
        ref="itemHistoryGrid"
        :allow-column-reordering="false"
        :column-chooser="{ enabled: false }"
        @content-ready="itemHistoryAddGridNoResults($event)"
      >
        <template #historyStatusTemplate="{ data }">
          <gc-status-chip :status="data.data.Status" />
        </template>

        <template #date-in-cell-template="{ data }">
          <gc-friendly-date :date="data.data.DateIn" />
        </template>

        <template #displayDescription="{ data }">
          <div class="informer">
            <GcHeaderContentDynamic
              :baseView="baseView"
              :primaryLabel="customerItemHistory['Description']"
              :secondaryLabel="customerItemHistory['ItemCode']"
              :viewMode="'popup'"
            />
          </div>
        </template>
      </dx-data-grid>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>

    <!-- product details popup -->
    <DxPopup
      :visible.sync="productDetailsPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :title.sync="productDetails.title"
      :showCloseButton="false"
      :height="580"
      @hidden="customePopUpHidden"
    >
      <div class="product-details" v-show="productDetails.data != null">
        <div class="row">
          <!-- <DxToolbar class="view-toolbar">
          <DxItem #default location="left" locate-in-menu="auto">-->
          <GcHeaderContentDynamic
            :baseView="baseView"
            :primaryLabel="productDetails.data['Description']"
            :secondaryLabel="productDetails.data['ItemCode']"
            :viewMode="'popup'"
          />
          <!-- </DxItem>
          </DxToolbar>-->
        </div>
        <div class="row details-row">
          <div class="col-6">
            <div
              v-show="productDetails.data.HasPrimaryImage == false"
              class="product-primary-image-img"
            >
              <div class="no-image">
                <span class="product-primary-image-label-secondary"
                  >No Image</span
                >
              </div>
            </div>
            <div
              v-show="productDetails.data.HasPrimaryImage == true"
              class="product-primary-image-img"
            >
              <img :src="productDetails.imageURL" width="300" />
            </div>
          </div>
          <div class="col-6">
            <form>
              <DxForm
                ref="product-details-form"
                :form-data.sync="productDetails.model"
                :read-only="true"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :label-location="formsConfig.labelPosition"
                :customizeItem="customizeItem"
                :items="productDetailsItems"
              ></DxForm>
            </form>
          </div>
        </div>
      </div>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>

    <!-- GP Tool Popup  -->

    <DxPopup
      :visible.sync="gpToolPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :show-title="true"
      :title.sync="gpTool.title"
      :showCloseButton="false"
      :height="350"
    >
      <div class="gp-toop-popup">
        <div class="row">
          <!-- <DxToolbar class="view-toolbar">
          <DxItem #default location="left" locate-in-menu="auto">-->
          <GcHeaderContentDynamic
            :baseView="baseView"
            :primaryLabel="gpTool.data['Description']"
            :secondaryLabel="gpTool.data['ItemCode']"
            :viewMode="'popup'"
          />
          <!-- </DxItem>
          </DxToolbar>-->
        </div>

        <div class="row">
          <form>
            <DxForm
              :form-data.sync="gpTool.model"
              :read-only="false"
              :show-colon-after-label="false"
              :show-required-mark="false"
              :show-validation-summary="false"
              :label-location="formsConfig.labelPosition"
              :customizeItem="customizeItem"
              :items="getGPToolFormItems"
              :validation-group="'gp-tool-form'"
            ></DxForm>
          </form>
        </div>
      </div>

      <div class="footer">
        <DxButton
          text="Apply"
          type="default"
          styling-mode="contained"
          @click="applyGPToolValue"
          class="save-btn"
        />
        <DxButton
          text="Back"
          type="normal"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>

    <!-- Best Before popup  -->
    <DxPopup
      :visible.sync="bestBeforeDatePopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      title="Best Before Date"
      :showCloseButton="false"
      :width="550"
      :height="250"
    >
      <form>
        <DxForm
          :ref="'best-before-form'"
          :customizeItem="customizeItem"
          :form-data.sync="bestBeforeDate.model"
          :items="getBestBeforeDateFormItems"
        ></DxForm>
      </form>

      <div class="footer">
        <DxButton
          text="Apply"
          type="default"
          styling-mode="contained"
          @click="applyBestBeforeDateValue"
          class="save-btn"
        />
        <DxButton
          text="Back"
          type="normal"
          styling-mode="contained"
          @click="popUpBackButtonClick"
        />
      </div>
    </DxPopup>

    <!--tablet mode select popup  -->
    <DxPopup
      :visible.sync="tabletModeSelectPopupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-title="true"
      :title="tabletModePopUp.model.title"
      :showCloseButton="false"
      :width="800"
      :height="600"
      @hidden="customePopUpHidden"
    >
      <dx-data-grid
        class="select-popup-grid"
        :data-source="tabletViewSelectDataSourceConfig"
        :show-column-headers="tabletModePopUp.options.showColumnHeaders"
        :selection="{
          mode: tabletModePopUp.options.multipleSelect ? 'multiple' : 'single',
        }"
        :height="430"
        :columns="tabletViewSelectColumns"
        @selection-changed="tabletViewSelectionChanged"
        :ref="'custom-popup-grid'"
        :selected-row-keys.sync="tabletModePopUp.options.selectedRowKeys"
        @content-ready="onContentReady"
        @toolbar-preparing="selectPopUpToolbarPreparing($event)"
        @row-click="customePopUpRowClick"
        @editor-preparing="tabletModeSelectPopupEditorPreparing"
        :allow-column-reordering="false"
        :column-chooser="{ enabled: false }"
      >
        <template #customer-cell-template="{ data }">
          <div class="toolbar-auto-complete">
            <span class="title">{{ data.data.Name }}</span>
            <span class="sub-title" style="color: grey">{{
              data.data.Code
            }}</span>
          </div>
        </template>

        <template #branch-cell-template="{ data }">
          <div class="toolbar-auto-complete">
            <span class="title">{{ data.data.Description }}</span>
            <span class="sub-title" style="color: grey">{{
              data.data.Code
            }}</span>
          </div>
        </template>

        <template #sales-rep-cell-template="{ data }">
          <div>
            <div class="toolbar-auto-complete">
              <span class="title">{{
                data.data.FirstName + " " + data.data.Surname
              }}</span>
              <span class="sub-title" style="color: grey">{{
                data.data.Code
              }}</span>
            </div>
          </div>
        </template>

        <template #deliveryAddressTemplate="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{
              data.data.CompanyName
            }}</span>
            <span class="auto-complete-secondary no-padding">
              <span v-if="data.data.PhysicalAddressStreetLine1 != ''">
                {{ data.data.PhysicalAddressStreetLine1 }}
              </span>
              <span v-if="data.data.PhysicalAddressStreetLine2 != ''">{{
                data.data.PhysicalAddressStreetLine2
              }}</span>
              <span v-if="data.data.PhysicalAddressSuburb != ''">{{
                data.data.PhysicalAddressSuburb
              }}</span>
              <span v-if="data.data.PhysicalAddressState != ''">{{
                data.data.PhysicalAddressState
              }}</span>
              <span v-if="data.data.PhysicalAddressPostcode != ''">{{
                data.data.PhysicalAddressPostcode
              }}</span>
            </span>
          </div>
        </template>

        <DxSelection
          :select-all-mode="'allPages'"
          :show-check-boxes-mode="'always'"
          :mode="tabletModePopUp.options.multipleSelect ? 'multiple' : 'single'"
        />
      </dx-data-grid>
      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popUpBackButtonClick"
          :visible="tabletModePopUp.options.showBackButton"
        />

        <DxButton
          text="Ok"
          type="default"
          styling-mode="contained"
          @click="applyPopUpFilter"
          :visible="tabletModePopUp.options.showOkButton"
        />
      </div>
    </DxPopup>

    <GcStockLevels
      v-if="visibleStockLevels"
      :itemData="stockLevelItemData"
      :setVisible="visibleStockLevels"
      :callBack="stockLevelCallBack"
    />

    <gc-item-price-update
      v-if="visibleItemPriceUpdate"
      :setVisible="visibleItemPriceUpdate"
      :callBack="popUpCallBack"
      :itemPriceUpdateData="itemPriceUpdateData"
      :branchCode="model.BranchCode"
      :baseView="baseView"
    ></gc-item-price-update>

    <gc-edit-delivery-address
      :setVisible="visibleEditDeliveryAddress"
      :formModel="model"
      :CustomerCode="model.CustomerCode"
      :callBack="deliveryAddressCallBack"
    ></gc-edit-delivery-address>

    <template #footer>
      <GcFooterSalesOrder
        :CurrencyCode="model.CurrencyCode"
        :ItemCount="computedItemCount"
        :ExTaxTotal="computedFXExTaxTotal"
        :TaxTotal="computedFXTaxTotal"
        :Total="computedFXTotal"
      />
    </template>
  </gc-main-layout>
</template>

<script>
let delay = 500,
  timerId = null;

function debouncer(fn) {
  if (timerId) clearTimeout(timerId);
  timerId = setTimeout(fn, delay);
}

import validationEngine from "devextreme/ui/validation_engine";

import BaseViewMixin from "../../v1/_mixins/base.view";
import { CustomerSalesContracts } from "../../_models/customer-sales-contracts";

import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { SalesOrderEDIService } from "../../_services/api/sales/sales-order-edi.service";
import { SaleItemCompanyBranchService } from "../../_services/api/sales/sale-item-company-branch.service";
import { SalesItemHistoryService } from "../../_services/api/sales/sale-item-history.service";
import { SalesOrderProductDetails } from "../../_services/api/sales/sales-order-product-details.service";
import { SalesOrderListService } from "../../_services/api/sales/sales-order-list.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { DivisionService } from "../../_services/api/sales/division.service";
import { FactorService } from "../../_services/api/sales/factor.service";
import { SalesOrderTypeService } from "../../_services/api/sales/sales-order-type.service";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import { SalesOrderNoteService } from "../../_services/api/sales/sales-order-note.service";
import { ProductSizeService } from "../../_services/api/settings/products/product-size.service";
import { mapGetters } from "vuex";

import { AgentSupplierService } from "../../_services/api/accounts/agent-supplier.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { CustomerSalesContractService } from "../../_services/api/accounts/customer-sales-contract.service";
import { CustomerFreightChargeService } from "../../_services/api/accounts/customer-freight-charge.service";

import { PriceGroupService } from "../../_services/api/sales/price-group.service";
import { alert } from "devextreme/ui/dialog";

import { compareValues } from "../../_helpers/collections/array-helper";

import SalesFormulas from "../../_helpers/formulas/sales-formulas";
import { DxSelection, DxKeyboardNavigation } from "devextreme-vue/data-grid";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { ProductCategory1Service } from "../../_services/api/settings/products/product-category-1.service";

const {
  calculateGrossProfitPcnt,
  calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateSalesUMPriceFromSalesUMFXPrice,
  calculateCalculatedDiscPcnt,
  calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = SalesFormulas;

let UMDictionary = {};
let soDetailsSortExpr = null;
let soDetailsGridInstance = null;
let reviewModeSearchText = "";
let screenModeChanged = false;
let soGlobal = {
  model: {
    CustomerCode: undefined,
    FilterDate: undefined,
    FactorcVal: undefined,
    BranchValue: undefined,
  },
};

let focusedQtyCellInfo = null;

let soDetailsBaseRecord = {
AddDiscPriceGroupCode: null,
  AddDiscPricingMethod: null,
  AddDiscPricingMethodValue: 0,
  AddDiscSalesUMPrice: 0,
  AddDiscStockUMPrice: 0,
  CalculatedDiscPcnt: 0,
  Comment: "",
  CustomerProduct: "",
  CustomerSalesContractCode: null,
  CustomerSalesContractLineNo: null,
  DiscFXLineTotal: 0,
  DiscLineTotal: 0,
  DiscPcnt: 0,
  ExTaxUnitCost: 0,
  FXLineTotal: 0,
  IsCommentVisible: false,
  IsPrimeCostItem: false,
  ItemCode: "",
  ItemType: "",
  KitVersion: 0,
  LineNo: 0,
  LineTotal: 0,
  NetFXLineTotal: 0,
  NetLineTotal: 0,
  PriceGroupCode: null,
  PriceGroupSalesUMPrice: 0,
  PriceGroupStockUMPrice: 0,
  PricingMethod: null,
  PricingMethodValue: null,
  RecordId: "00000000-0000-0000-0000-000000000000",
  RequiredByDate: null,
  SalesTaxPcnt: 0,
  SalesUM: "",
  SalesUMConversion: null,
  SalesUMCost: 0,
  SalesUMFXPrice: 0,
  SalesUMIsVariable: null,
  SalesUMManufacturedCost: 0,
  SalesUMNetFXPrice: 0,
  SalesUMNetPrice: 0,
  SalesUMPrice: 0,
  SalesUMPromotionNetPrice: 0,
  SalesUMQty: 0,
  SalesUMQtyFocused: false,
  SalesUMStandardCost: 0,
  SalesUMStandardPrice: 0,
  ShipDate: null,
  Status: "A",
  StockUM: null,
  StockUMFXPrice: 0,
  StockUMManufacturedCost: 0,
  StockUMNetFXPrice: 0,
  StockUMNetPrice: 0,
  StockUMPrice: 0,
  StockUMQty: 0,
  StockUMStandardCost: 0,
  StockUMStandardPrice: 0,
  TaxableFXLineTotal: 0,
  TaxableLineTotal: 0,
  TaxCode: null,
  TaxFXLineTotal: 0,
  TaxLineTotal: 0,
  WetFreightAdjustment: 0,
  WetFXFreightAdjustment: 0,
  WetFXLineTotal: 0,
  WetLineTotal: 0,
  WetPcnt: 0,
  HasPromotion: false,
  BestBeforeDate: null,
  ProductSizeCode: "",
};

var productSizeDataSource = ProductSizeService.dataSourceConfig(
  "api/ProductSize",
  {
    select: ["Code", "Sequence", "Inactive"],
    sort: [{ selector: "Sequence", desc: true }],
  }
);

let productSizes = [];

var currentRowIndex = -1,
  currentColumnIndex = -1,
  cellInfoData = undefined;

let getFilterExpressionForArray = (fieldName, arr) => {
  let expression = "";
  for (let index = 0; index < arr.length; index++) {
    if (index == 0) {
      expression = `${fieldName} eq '` + arr[index] + "'";
    } else {
      expression = expression + ` or ${fieldName} eq '` + arr[index] + "'";
    }
  }
  return expression;
};

var reviewListFilterValues = undefined,
  reviewListItemCodes = [];
var soDetailsReviewListDataSource = SalesOrderService.dataSourceConfig(
  "api/SalesOrderDetailCompanyBranch",
  {
    // sort: [{ selector: "ItemCode", desc: false }],
    postProcess: (data) => {
      reviewListFilterValues = "";
      reviewListItemCodes = [];
      for (let index = 0; index < data.length; index++) {
        reviewListItemCodes.push(data[index].ItemCode);

        data[index].SalesUMQtyFocused = false;

        let x = data.filter((i) => {
          return i.ItemCode == data[index].ItemCode;
        });
        if (x.length > 0) {
          x.forEach((element, i) => {
            if (element.CopyCode == undefined) {
              element.CopyCode = data[index].ItemCode + "-" + i;
              // this.$logger.debug("element.CopyCode ", element.CopyCode);
            }
          });
        }
      }

      // reviewListFilterValues = getFilterExpressionForArray(
      //   "ItemCode",
      //   reviewListItemCodes.splice(5)
      // );
      return data;
    },
    key: "ItemCode, LineNo, SalesUM",
    preventPagination: true,
  }
);

var productListFilterValues = undefined,
  productListItemCodes = [];

let filterFunction = (x) => {
  return (
    x.ItemCode.toLowerCase().indexOf(
      soDetailsGridInstance._options._optionManager._options.searchPanel.text.toLowerCase()
    ) !== -1 ||
    x.Description.toLowerCase().indexOf(
      soDetailsGridInstance._options._optionManager._options.searchPanel.text.toLowerCase()
    ) !== -1
  );
};
let chunkArray = (array, size) => {
  let result = [];
  for (let i = 0; i < array.length; i += size) {
    let chunk = array.slice(i, i + size);
    result.push(chunk);
  }
  return result;
};

let getAllIndexes = (arr, val) => {
  var indexes = [],
    i;
  for (i = 0; i < arr.length; i++) if (arr[i].ItemCode === val) indexes.push(i);
  return indexes;
};

var soDetailsProductListDataSource = SalesOrderService.dataSourceConfig(
  "api/ProductFilterGroupSaleItemCompanyBranch",
  {
    // sort: [{ selector: "ItemCode", desc: false }],
    postProcess: (data) => {
      // eslint-disable-next-line no-console
      // this.$logger.debug("post process SalesOrderDetailCompanyBranch", data);
      let pushedItemCodesFromReviewList = [];
      let resultingData = [];

      data.forEach((row) => {
        let x = data.filter((i) => {
          return i.ItemCode == row.ItemCode;
        });
        if (x.length > 0) {
          x.forEach((element, i) => {
            if (element.CopyCode == undefined) {
              element.CopyCode = row.ItemCode + "-" + i;
              // this.$logger.debug("element.CopyCode ", element.CopyCode);
            }
          });
        }

        if (!soGlobal.model.BranchValue) {
          row.Available = 0;
        }

        let foundIndex = soDetailsReviewListDataSource
          .items()
          .findIndex((x) => x.ItemCode == row.ItemCode);

        if (foundIndex > -1) {
          if (pushedItemCodesFromReviewList.indexOf(row.itemCode) == -1) {
            pushedItemCodesFromReviewList.push(row.ItemCode);
            let allIndexes = getAllIndexes(
              soDetailsReviewListDataSource.items(),
              row.ItemCode
            );
            // push all the matching items from the review list
            allIndexes.forEach((i) => {
              resultingData.push(soDetailsReviewListDataSource.items()[i]);
            });
          }
        } else {
          let productListRecord = Object.assign({}, soDetailsBaseRecord);
          resultingData.push(Object.assign(productListRecord, row));
        }
      });

      if (soDetailsSortExpr) {
        resultingData.sort(
          compareValues(
            soDetailsSortExpr.dataField,
            soDetailsSortExpr.sortOrder
          )
        );
      }

      if (soDetailsGridInstance)
        resultingData = resultingData.filter(filterFunction);

      productListFilterValues = "";
      productListItemCodes = [];
      for (let index = 0; index < resultingData.length; index++) {
        productListItemCodes.push(resultingData[index].ItemCode);
      }

      if (
        soGlobal.model.CustomerCode != undefined &&
        soGlobal.model.FilterDate != undefined
      ) {
        let itemCodeChunks = chunkArray(productListItemCodes, 20);

        let promoPromiseArr = [];
        let stockPromiseArr = [];
        for (let i = 0; i < itemCodeChunks.length; i++) {
          productListFilterValues = getFilterExpressionForArray(
            "ItemCode",
            itemCodeChunks[i]
          );

          var stockListFilterValues = getFilterExpressionForArray(
            "ProductCode",
            itemCodeChunks[i]
          );

          // this.$logger.debug(
          //   productListFilterValues,
          //   "productListFilterValues"
          // );
          var promoFilter =
            "(" +
            productListFilterValues +
            ") and CustomerCode eq '" +
            soGlobal.model.CustomerCode +
            "' and (StartDate le " +
            soGlobal.model.FilterDate +
            "T00:00:00Z" +
            " and EndDate ge " +
            soGlobal.model.FilterDate +
            "T00:00:00Z" +
            ")";

          var stockFilter =
            "(" +
            stockListFilterValues +
            ") and BranchCode eq '" +
            soGlobal.model.BranchCode +
            "'";

          promoPromiseArr.push(
            SalesOrderService.getSalesOrderPromotion(promoFilter)
          );

          stockPromiseArr.push(SalesOrderService.getProductStock(stockFilter));
        }
        // this.$logger.debug(promoPromiseArr, "promoPromiseArr");

        Promise.all(promoPromiseArr).then((results) => {
          results.forEach((result) => {
            var getData = result.data.value;
            for (let index = 0; index < getData.length; index++) {
              var getIndex = resultingData.findIndex(
                (x) => x.ItemCode == getData[index].ItemCode
              );
              if (getIndex > -1) {
                resultingData[getIndex]["HasPromotion"] = true;
              }
            }
          });
        });

        Promise.all(stockPromiseArr).then((results) => {
          results.forEach((result) => {
            var stockData = result.data.value;
            for (let index = 0; index < stockData.length; index++) {
              var getIndex = resultingData.findIndex(
                (x) => x.ItemCode == stockData[index].ProductCode
              );
              if (getIndex > -1) {
                resultingData[getIndex]["Available"] =
                  stockData[index].Available;
              }
            }
          });
        });

        return resultingData;
      } else {
        return resultingData;
      }
    },
  }
);

var customerListFilterValues = undefined,
  customerListItemCodes = [];
var soDetailsCustomerListDataSource = SalesOrderService.dataSourceConfig(
  "api/CustomerSaleItemCompanyBranch",
  {
    // sort: [{ selector: "ItemCode", desc: false }],
    postProcess: (data) => {
      let pushedItemCodesFromReviewList = [];
      let resultingData = [];

      // eslint-disable-next-line no-unused-vars
      data.forEach((row, dIndex) => {
        let x = data.filter((i) => {
          return i.ItemCode == row.ItemCode;
        });
        if (x.length > 0) {
          x.forEach((element, i) => {
            if (element.CopyCode == undefined) {
              element.CopyCode = row.ItemCode + "-" + i;
              // this.$logger.debug("element.CopyCode ", element.CopyCode);
            }
          });
        }

        if (!soGlobal.model.BranchValue) {
          row.Available = 0;
        }

        let foundIndex = soDetailsReviewListDataSource
          .items()
          .findIndex((x) => x.ItemCode == row.ItemCode);

        if (foundIndex > -1) {
          if (pushedItemCodesFromReviewList.indexOf(row.itemCode) == -1) {
            pushedItemCodesFromReviewList.push(row.ItemCode);
            let allIndexes = getAllIndexes(
              soDetailsReviewListDataSource.items(),
              row.ItemCode
            );
            // push all the matching items from the review list
            allIndexes.forEach((i) => {
              resultingData.push(soDetailsReviewListDataSource.items()[i]);
            });
          }
        } else {
          let customerListRecord = Object.assign({}, soDetailsBaseRecord);
          resultingData.push(Object.assign(customerListRecord, row));
        }
      });

      if (soDetailsSortExpr) {
        resultingData.sort(
          compareValues(
            soDetailsSortExpr.dataField,
            soDetailsSortExpr.sortOrder
          )
        );
      }

      if (soDetailsGridInstance)
        resultingData = resultingData.filter(filterFunction);

      customerListFilterValues = "";
      customerListItemCodes = [];
      for (let index = 0; index < resultingData.length; index++) {
        customerListItemCodes.push(resultingData[index].ItemCode);
      }

      customerListFilterValues = getFilterExpressionForArray(
        "ItemCode",
        customerListItemCodes
      );

      if (
        soGlobal.model.CustomerCode != undefined &&
        soGlobal.model.FilterDate != undefined
      ) {
        let itemCodeChunks = chunkArray(customerListItemCodes, 20);
        let promoPromiseArr = [];
        let stockPromiseArr = [];
        for (let i = 0; i < itemCodeChunks.length; i++) {
          customerListFilterValues = getFilterExpressionForArray(
            "ItemCode",
            itemCodeChunks[i]
          );

          var stockListFilterValues = getFilterExpressionForArray(
            "ProductCode",
            itemCodeChunks[i]
          );

          var promoFilter =
            "(" +
            customerListFilterValues +
            ") and CustomerCode eq '" +
            soGlobal.model.CustomerCode +
            "' and (StartDate le " +
            soGlobal.model.FilterDate +
            "T00:00:00Z" +
            " and EndDate ge " +
            soGlobal.model.FilterDate +
            "T00:00:00Z" +
            ")";

          var stockFilter =
            "(" +
            stockListFilterValues +
            ") and BranchCode eq '" +
            soGlobal.model.BranchCode +
            "'";

          promoPromiseArr.push(
            SalesOrderService.getSalesOrderPromotion(promoFilter)
          );

          stockPromiseArr.push(SalesOrderService.getProductStock(stockFilter));
        }

        Promise.all(promoPromiseArr).then((results) => {
          // 'results' contain an array of results for each request
          results.forEach((result) => {
            var getData = result.data.value;
            for (let index = 0; index < getData.length; index++) {
              var getIndex = resultingData.findIndex(
                (x) => x.ItemCode == getData[index].ItemCode
              );
              if (getIndex > -1) {
                resultingData[getIndex]["HasPromotion"] = true;
              }
            }
          });
        });

        Promise.all(stockPromiseArr).then((results) => {
          results.forEach((result) => {
            var stockData = result.data.value;
            for (let index = 0; index < stockData.length; index++) {
              var getIndex = resultingData.findIndex(
                (x) => x.ItemCode == stockData[index].ProductCode
              );
              if (getIndex > -1) {
                resultingData[getIndex]["Available"] =
                  stockData[index].Available;
              }
            }
          });
        });

        return resultingData;
      } else {
        return resultingData;
      }
    },
  }
);

var deliveryAddressDataSource = CustomerDeliveryAddressService.dataSourceConfig(
  "api/CustomerDeliveryAddress",
  {
    select: [
      "CompanyName",
      "PhysicalAddressStreetLine1",
      "PhysicalAddressStreetLine2",
      "PhysicalAddressSuburb",
      "PhysicalAddressState",
      "PhysicalAddressPostcode",
      "PhysicalAddressCountry",
      "RecordId",
      "LineNo",
    ],
    key: "RecordId",
    filter: ["Inactive", "=", "N"],
  }
);

var orderNotesDataSource = SalesOrderNoteService.dataSourceConfig({
  select: ["Note", "LineNo"],
  sort: [{ selector: "LineNo", asc: true }],
});

var salesRepDataSource = SalesRepresentativeService.dataSourceConfig(
  "api/SalesRepresentative",
  {
    select: ["Code", "FirstName", "Surname"],
    filter: ["Inactive", "=", "N"],
    sort: [{ selector: "FirstName", asc: true }],
  }
);

var customerDataSource = AgentSupplierService.dataSourceConfig("api/Customer", {
  select: [
    "Code",
    "Name",
    "SalesRepresentativeCode",
    "CurrencyCode",
    "StopCredit",
  ],
  sort: [{ selector: "Name", asc: true }],
  top: 5,
  filter: ["Inactive", "=", "N"],
  count: true,
});

import ApiService from "../../_services/api/api.service";
import { FeatureStorage } from "../../_services/storage";
import { ProductTypeService } from "../../_services/api/settings/products/product-type.service";

export default {
  props: {},
  mixins: [BaseViewMixin],
  updated() {
    if (this.dataLoaded) {
      validationEngine.validateGroup(this.formsConfig.validationGroup);
      validationEngine.validateGroup("headerFormData");
    }
  },
  components: {
    // DxContextMenu,
    DxSelection,
    DxKeyboardNavigation,
  },
  beforeDestroy() {
    this.salesOrderDetailsReviewList
      .items()
      .splice(0, this.salesOrderDetailsReviewList.items().length);
  },
  watch: {
    gridExpanded() {
      this.$refs[this.soDetailsGridRefName].instance.repaint();
    },
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    // eslint-disable-next-line no-unused-vars
    sourceNumericValue: function(val, oldVal) {
      // this.$logger.debug(`old:${oldVal} new: ${val}`);

      debouncer(() => {
        if (val === undefined) return;
        if (this.isTablet) {
          if (focusedQtyCellInfo && this.fieldFocused) {
            if (this.soDetailsCurrentView == "GridList") {
              this.onGridListViewSizeQtyChanged(
                { value: val, previousValue: oldVal },
                focusedQtyCellInfo.cellInfo,
                true
              );
            } else {
              this.onSoDetailsViewQtyChanged(
                { value: val, previousValue: oldVal },
                focusedQtyCellInfo.cellInfo,
                true
              );
            }
          }
        }
      });
    }, // #28009 : Order Qty's being missed and not saved successfully
    // eslint-disable-next-line no-unused-vars
    numericValue: function(val, oldVal) {
      // eslint-disable-next-line no-console
      // this.$logger.debug(`old:${oldVal} new: ${val}`);
      if (val === undefined) return;
      if (this.isTablet) {
        if (focusedQtyCellInfo && this.fieldFocused) {
          this.updateDataSource(
            this.getCurrentSoDetailsDataSource(),
            focusedQtyCellInfo.rowIndex,
            focusedQtyCellInfo.dataField,
            val
          );
          soDetailsGridInstance.repaintRows([focusedQtyCellInfo.rowIndex]);
        }
      }
    },
    customerCodeComputed: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.toolbar.status.items[0].disabled = false;
        } else {
          this.toolbar.status.items[0].disabled = true;
        }
        let toolbar = this.$refs["toolbar-header"];
        if (toolbar) toolbar.instance.repaint();

        let grid = this.$refs[this.soDetailsGridRefName];
        if (grid) grid.instance.repaint();
      },
    },
    model: {
      handler(val) {
        if (this.baseView.mode == "create") {
          if (val.CustomerCode == null) this.setDefaultSalesRep(undefined);
        }
      },
      deep: true,
    },
  },
  async created() {
    reviewModeSearchText = "";
    this.intialize();

    SalesOrderListService.getUserDefaultSalesRepresentative()
      .then((result) => {
        if (result.data.value[0].SalesRepresentativeCode != "") {
          this.tabletModePopUp.model.filterBySalesRep =
            result.data.value[0].SalesRepresentativeCode;

          let grid = this.$refs["custom-popup-grid"].instance;
          grid.filter([
            [
              "SalesRepresentativeCode",
              "=",
              this.tabletModePopUp.model.filterBySalesRep,
            ],
            "and",
            ["Inactive", "=", "N"],
          ]);

          grid.repaint(true);
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((err) => {
        // this.$logger.debug("getUserDefaultSalesRepresentative ", err);
      });
  },
  data() {
    return {
      stockLevelItemData: undefined,
      visibleStockLevels: false,
      freightCharges: [],
      gridExpanded: false,
      // #28013 :  Grid view returns records but columns per sizing is missing
      soDetailsGridListDataSource: SalesOrderService.dataSourceConfig(
        "api/GridSaleItemCompanyBranch",
        {
          sort: [{ selector: "Model", desc: false }],
          postProcess: (data) => {
            let validColumnIndexes = [];
            let validGridListSizeColumns = [];

            data.forEach((row) => {
              let x = data.filter((i) => {
                return i.Model == row.Model;
              });
              if (x.length > 0) {
                x.forEach((element, i) => {
                  if (element.CopyCode == undefined) {
                    element.CopyCode = row.Model + "-" + i;
                    // this.$logger.debug("element.CopyCode ", element.CopyCode);
                  }
                });
              }

              for (var i = 0; i <= 20; i++) {
                if (row[`Size${i}ItemCode`] !== "") {
                  validColumnIndexes.push(i);
                }
                row[`Size${i}Qty`] = 0;
                row[`Size${i}QtyFocused`] = false;
              }
            });

            let uniqueValidColumnIndexes = [...new Set(validColumnIndexes)];
            uniqueValidColumnIndexes.forEach((i) => {
              validGridListSizeColumns.push({
                Sequence: i,
                ColumnLabel: productSizes[i],
              });
            });

            data.forEach((row, dIndex) => {
              validGridListSizeColumns.forEach((sizeItem) => {
                let fIndex = soDetailsReviewListDataSource
                  .items()
                  .findIndex(
                    (x) =>
                      x.ItemCode == row[`Size${sizeItem.Sequence}ItemCode`] &&
                      x.SalesUM.toLowerCase() == row.SalesUM.toLowerCase()
                  );

                if (fIndex > -1) {
                  row[
                    `Size${sizeItem.Sequence}Qty`
                  ] = soDetailsReviewListDataSource.items()[fIndex].SalesUMQty;
                  // foundIndexes.push(foundIndex);
                }
              });

              let productListRecord = Object.assign({}, soDetailsBaseRecord);
              productListRecord = Object.assign(productListRecord, row);
              productListRecord["ItemCode"] = row.Model;
              productListRecord["Description"] = row.Description;
              data[dIndex] = productListRecord;
            });

            if (soDetailsSortExpr) {
              data.sort(
                compareValues(
                  soDetailsSortExpr.dataField,
                  soDetailsSortExpr.sortOrder
                )
              );
            }

            // if (soDetailsGridInstance) data = data.filter(filterFunction);

            this.updateSoGridListViewColumns(validGridListSizeColumns);

            return data;
          },
        }
      ),
      newHeightForGrid: 0,
      formHeight: 0,
      toolbarHeight: 0,
      dataLoaded: false,
      visibleEditDeliveryAddress: false,
      soDetailsGridInstance: soDetailsGridInstance,
      customerIsChanging: false,
      multiple: [
        {
          keyCode: 78,
          modifiers: ["altKey"],
          preventDefault: true,
        },
        {
          keyCode: 71,
          modifiers: ["altKey"],
          preventDefault: true,
        },
        {
          keyCode: 83,
          modifiers: ["altKey"],
          preventDefault: true,
        },
      ],
      UMDictionary: UMDictionary,
      sidebarTabSelectedIndex: 0,
      categorySelectionDisabled: false,
      showNumberPadForTheFirstTime: false,
      isExchangeReverting: false,
      soGridViewColumns: [],
      sizeTotalGridColumns: [],
      soDetailsGridColumns: [],
      gridListViewFilterConfig: {
        dataSource: [],
        placeholder: "Select",
      },
      gridListViewFilterValue: "",
      soDetailsLineContextMenu: {
        icon: "overflow",
      },
      salesOrderDetailsDataSourceConfig: [],
      salesOrderDetailsReviewList: soDetailsReviewListDataSource,
      orderNotesDataSourceConfig: [],
      contextMenuItems: ["Order Comments", "Order Notes"],
      isContextMenuVisible: false,
      commentsPopupVisible: false,
      lineCommentsPopupVisible: false,
      gridTotalsVisible: false,
      notesPopupVisible: false,
      itemHistoryPopupVisible: false,
      productDetailsPopupVisible: false,
      gpToolPopupVisible: false,
      bestBeforeDatePopupVisible: false,
      tabletModeSelectPopupVisible: false,
      isEditVisible: true,
      gridRefName: "gridManifestOrder",
      soDetailsGridRefName: "soDetailsGrid",
      soDetailsCurrentView: "Review",
      revertSelection: false,
      toolbar: {
        gridTotal: {
          icon: "datafield",
          onClick: () => {
            this.gridTotalsVisible = true;
            this.$logger.trackEventOpenPopup("Sales Order Grid Totals");
          },
        },
        edit: {
          icon: "edit",
          onClick: () => {
            reviewModeSearchText =
              soDetailsGridInstance._options._optionManager._options.searchPanel
                .text;
            screenModeChanged = true;
            this.$router.push({
              path: `/sales-order-old/edit/${this.model.Code}/${
                this.selectedIndex == 0 ? "header" : "details"
              }`,
            });
          },
        },
        save: {
          icon: "save",
          validationGroup: "formsData",
          onClick: () => {
            this.$notify("Save has been clicked!");
          },
        },
        menu: {
          items: [
            { menuText: "Save Draft" },
            { menuText: "Save & Commit" },
            { menuText: "Save & Accept" },
            { menuText: "Cancel" },
          ],
          keyExpr: "menuText",
          displayExpr: "menuText",
          icon: "floppy",
          // validationGroup: "formsData",
          showArrowIcon: false,
          dropDownOptions: {
            width: "150px",
          },
          stylingMode: "text",
          onItemClick: async (e) => {
            // let validationResult = validationEngine.validateGroup(
            //   this.formsConfig.validationGroup
            // );

            // if (!validationResult.isValid) {
            //   this.displayValidationSummary();
            //   return;
            // }

            let validationResult = await validationEngine.validateGroup(
              this.formsConfig.validationGroup
            );

            let vr2 = validationEngine.validateGroup("headerFormData");
            if (!validationResult.isValid || !vr2.isValid) {
              var value = validationResult.brokenRules.concat(vr2.brokenRules);
              this.addErrorMessagesFromValidationResult({
                brokenRules: value,
              });
              this.displayCustomValidationSummary();
              return;
            }

            // this.$logger.debug("e ", e, validationResult);

            if (e.itemData.menuText == "Cancel") {
              let confirmLeaving = await this.$confirm(
                "Do you really wish to cancel sales order?",
                "Cancel sales order"
              );

              if (confirmLeaving) {
                this.$logger.trackEventButtonClick("Cancel Sales Order");
                this.cancelSalesOrder();
              }
            } else if (e.itemData.menuText == "Save Draft") {
              this.$logger.trackEventButtonClick("Save Sales Order Draft");
              this.saveSalesOrder("D");
            } else if (
              e.itemData.menuText == "Save & Commit" ||
              e.itemData.menuText == "Save & Accept"
            ) {
              this.$logger.trackEventButtonClick("Save Sales Order");
              this.saveSalesOrder("A");
            }
          },
        },
        notes: {
          icon: "file",
          items: ["Order Comments", "Order Notes"],
          dropDownOptions: { width: 250 },
          class: "gc-dropdown-icon-button",
          stylingMode: "text",
          showArrowIcon: false,
          onClick: () => {
            // this.isContextMenuVisible = true;
          },
          onItemClick: (e) => {
            if (e.itemData == "Order Comments") {
              this.commentsPopupVisible = true;
              this.$logger.trackEventOpenPopup("Sales Order Comments");
            } else if (e.itemData == "Order Notes") {
              this.notesPopupVisible = true;
              this.$logger.trackEventOpenPopup("Sales Order Note");
            }
          },
        },

        status: {
          icon: "more",
          class: "gc-dropdown-icon-button",
          stylingMode: "text",
          showArrowIcon: false,
          items: [{ menuText: "Account Status" }],
          keyExpr: "menuText",
          displayExpr: "menuText",
          dropDownOptions: { width: 150 },
          onItemClick: () => {
            this.popupVisible = true;
            this.$logger.trackEventOpenPopup("Sales Order Account Status");
          },
        },
        audit: {
          icon: "clock",
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      columns: [
        {
          caption: "Note",
          dataField: "Note",
          width: 400,
          alignment: "left",
          cellTemplate: "note-template",
          editorOptions: {
            maxLength: 1000,
          },
          validationRules: [
            {
              type: "required",
              message: "Note is required",
            },
          ],
        },
      ],

      lineCommentItems: this.parseFormColumns([
        {
          dataField: "Comment",
          gcLabel: " ",
          labelVisible: false,
          gcType: "String",
          editorType: "dxTextArea",
          editorOptions: {
            height: "140",
            maxLength: 1000,
          },
        },
        {
          dataField: "IsCommentVisible",
          gcLabel: "Visible On Invoice",
          gcType: "Boolean",
        },
      ]),
      lineCommentModel: {
        Comment: "",
        IsCommentVisible: false,
      },
      commentSettings: {},
      factor368: "",
      model: {
        Code: "",
        Name: "",
        CustomerName: undefined,
        ConsignmentNo: "",
        DateCreated: "",
        CreatedBy: "",
        DateChanged: "",
        ChangedBy: "",
        CustomerCode: undefined,
        PreviousCustomer: undefined,
        Status: "",
        CurrencyCode: "",
        IsLockedForPicking: "",
        DateIn: null,
        RequiredByDate: null,
        ShipDate: null,
        OrderNo: "",
        CustomerDeliveryAddressLineNo: "",
        DeliveryAddressCompanyName: undefined,
        DeliveryAddressStreetLine1: "",
        DeliveryAddressStreetLine2: "",
        DeliveryAddressSuburb: "",
        DeliveryAddressState: "",
        DeliveryAddressPostcode: "",
        DeliveryAddressCountry: "",
        CompanyCode: "",
        BranchCode: "",
        BranchName: "",
        DivisionCode: "",
        DivisionName: "",
        SalesOrderTypeCode: "",
        SalesOrderTypeName: "",
        SalesOrderType: "",
        SalesRepresentativeCode: "",
        SalesRepresentativeName: "",
        FirstName: "",
        Surname: "",
        UserComment1: "",
        UserComment2: "",
        UserComment3: "",
        UserComment4: "",
        UserComment5: "",
        UserComment6: "",
        UserComment7: "",
        UserComment8: "",
        UserComment9: "",
        UserComment10: "",
        UserComment11: "",
        UserComment12: "",
        UserComment13: "",
        UserComment14: "",
        UserComment15: "",
        UserComment16: "",
        UserComment17: "",
        UserComment18: "",
        UserComment19: "",
        UserComment20: "",
        ExchangeRate: 1,
        ExTaxTotal: 0,
        ItemCount: 0,
        SalesOrderDetails: [],
        SalesOrderNotes: [],
        TaxTotal: 0,
        Total: 0,
        commentOptions: [],
        itemCode: undefined,
        isEDIOrder: false,
        isPendingEDIOrder: false,
        Currency: "",
        BuyRate: 1,
        CompanyCurrency: "",
      },
      popupVisible: false,
      customerItemHistory: [],
      customerItemHistoryColumns: [
        {
          caption: "Order",
          dataField: "SalesOrderCode",
          alignment: "left",
          width: 130,
        },
        {
          caption: "Date",
          dataField: "DateIn",
          width: 100,
          cellTemplate: "date-in-cell-template",
          allowFiltering: false,
        },
        {
          caption: "Qty",
          dataField: "SalesUMQty",
          alignment: "right",
          format: this.getDecimalFormatByCode(7).Format,
          width: 150,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          alignment: "left",
          width: 100,
        },
        {
          caption: "Unit Price",
          dataField: "SalesUMNetPrice",
          alignment: "right",
          format: this.getDecimalFormatByCode(13).Format,
          width: 150,
        },
        {
          caption: "Status",
          dataField: "FriendlyStatus",
          cellTemplate: "historyStatusTemplate",
          width: 100,
        },
        {
          caption: "Price Group",
          dataField: "PriceGroupDescription",
          alignment: "left",
        },
      ],
      productDetails: {
        title: "Product Details",
        data: {
          HasPrimaryImage: false,
        },
        hasPromotion: false,
        imageURL: null,
        model: {
          itemCode: null,
          apn: null,
          standardSell: null,
          customerSell: null,
          cartonQty: null,
          salesUM: null,
          promotionStartDate: null,
          promotionEndDate: null,
        },
      },
      gpTool: {
        title: "GP Tool",
        data: [],
        model: {
          quantity: null,
          standardSell: null,
          currentPrice: null,
          gp: null,
          newSalesUMNetPrice: null,
        },
        //  items:  getGPToolFormItems
      },
      bestBeforeDate: {
        data: [],
        model: {
          bestBeforeDate: new Date(),
        },
      },
      showLeftContainer: true,
      showRightContainer: false,
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            this.sidebarTabSelectedIndex = 0;
            // var grid = this.$refs["soDetailsGrid"].instance;
            // grid.repaint();
            var item = document.getElementById("details-grid-filter-btn");
            item.classList.remove("dx-state-invisible");
          },
          // visible: browserHelper.tablet,
        },
        clear: {
          text: "Clear",
          onClick: () => {
            this.clearAdvanceFilters();
          },
        },
      },
      advanceFilter: {
        model: {
          ProdCat1: [],
          ProdCat2: [],
          ProdCat3: [],
          ProdCat4: [],
          ProdType: [],
          ProdCat1SelectedRows: [],
          ProdCat2SelectedRows: [],
          ProdCat3SelectedRows: [],
          ProdCat4SelectedRows: [],
          ProdTypeSelectedRows: [],
        },
        filterFormHeight: "auto",
      },
      defaultFilters: {
        default: [],
        reviewListViewFilter: [],
        productListViewFilter: [],
        customerListViewFilter: [],
        gridListViewFilter: [],
        setCustomFilter: [],
      },
      tabletModePopUp: {
        model: {
          title: null,
          type: null,
          filterBySalesRep: "",
        },
        options: {
          dataSourceConfig: [],
          columns: [],
          showColumnHeaders: false,
          showBackButton: true,
          showOkButton: false,
          multipleSelect: false,
          selectedRowKeys: [],
          selectSalesRep: false,
          run: false,
          clearAll: false,
        },
      },
      visibleItemPriceUpdate: false,
      itemPriceUpdateData: null,
      fromItemPriceUpdate: false,
      itemPriceUpdateValue: null,
      selectedItemIndex: null,
      CustomerSalesContracts: new CustomerSalesContracts(),
      SalesContractDrawdownEnabled: false,
      gridTotalPopUpHeight: 0,
    };
  },
  computed: {
    noDataMessage() {
      let noDataMessageObject = {
        addNew: {},
      };

      if (this.soDetailsCurrentView == "Review") {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Order Lines",
          message: "Get Started, Add an Order Line",
        };
      } else if (this.soDetailsCurrentView == "ProductList") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Product Lines",
          message:
            "Products must be marked Available for Sale to appear here.  Head over to the Product screen to adjust this setting.",
        };
      } else if (this.soDetailsCurrentView == "CustomerList") {
        noDataMessageObject.addNew = {
          class: "no-data",
          title: "No Order Lines",
          message:
            "Products despatched and invoiced to the customer will show here.  Head over to the Despatch Order screen to despatch and invoice orders for this customer",
        };
      } else {
        noDataMessageObject.addNew = {
          class: "add-new",
          title: "No Order Lines",
          message: "Get Started, Add an Order Line",
        };
      }

      return noDataMessageObject;
    },
    productDetailsItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "apn",
              gcLabel: "APN",
              gcType: "String",
              editorType: "dxTextBox",
            },
            {
              dataField: "standardSell",
              gcType: "Decimal-4-2C",
              gcLabel: "Standard Sell",
            },
            {
              dataField: "customerSell",
              gcType: "Decimal-4-2C",
              gcLabel: "Customer Sell",
            },
            {
              dataField: "promotionStartDate",
              gcLabel: "Promotion Start Date",
              gcType: "Date",
              visible: this.productDetails.hasPromotion,
            },
            {
              dataField: "promotionEndDate",
              gcLabel: "Promotion End Date",
              gcType: "Date",
              visible: this.productDetails.hasPromotion,
            },
            {
              dataField: "cartonQty",
              gcLabel: "Carton Quantity",
              gcType: "String",
              editorType: "dxTextBox",
            },
            {
              dataField: "salesUM",
              gcLabel: "Sales UM",
              gcType: "String",
              editorType: "dxTextBox",
            },
          ]),
        },
      ];
    },
    soDetailsGridHeight() {
      if (!this.gridExpanded) {
        if (this.isTablet) return this.gridHeight - 5;
        else return this.gridHeight - (this.formHeight + this.toolbarHeight);
      } else {
        return this.gridHeight - this.toolbarHeight;
      }
    },
    getGridTotalPopUpHeight() {
      return this.gridTotalPopUpHeight;
    },

    customerItemHistoryDataSourceConfig() {
      if (!this.model.CustomerCode || !this.model.itemCode) {
        return;
      } else {
        return SalesItemHistoryService.dataSourceConfig({
          // select: ["Note", "LineNo", "SalesOrderCode"],
          sort: [{ selector: "SalesOrderCode", desc: true }],
          filter: [
            ["CustomerCode", "=", this.model.CustomerCode],
            "and",
            ["ItemType", "=", "S"],
            "and",
            ["ItemCode", "=", this.model.itemCode],
          ],
        });
      }
    },
    ItemPriceVisible() {
      return (
        this.hasItemPriceUpdateAccess &&
        this.baseView.mode != "review" &&
        this.model.CompanyCurrency == this.model.CurrencyCode
      );
    },
    exchangeRateEditable() {
      return (
        this.baseView.mode != "review" &&
        this.model.CompanyCurrency != this.model.CurrencyCode
      );
    },
    gridTotalsDataSource() {
      var arr = [];
      let obj = {};

      for (let j = 0; j < this.sizeTotalGridColumns.length; j++) {
        let total = 0;
        for (
          let x = 0;
          x < this.salesOrderDetailsReviewList.items().length;
          x++
        ) {
          let record = this.salesOrderDetailsReviewList.items()[x];

          if (
            record.ProductSizeCode ==
            this.sizeTotalGridColumns[j].productSizeCode
          ) {
            total += parseFloat(record.SalesUMQty).roundNumber(2);
          }
        }

        obj[this.sizeTotalGridColumns[j]["dataField"]] = total;
      }
      arr.push(obj);
      return arr;
    },
    hasItemPriceUpdateAccess() {
      return FeatureStorage.checkPermission(
        "ItemPriceUpdate",
        this.baseView.mode
      );
    },
    ...mapGetters({
      numericValue: "numericInputStore/getNumericValue",
      sourceNumericValue: "numericInputStore/getSourceNumericValue",
      sourceNumericRecord: "numericInputStore/getSourceNumericRecord",
      fieldFocused: "numericInputStore/getFieldFocused",
    }),
    filterPanelTabOptions() {
      return {
        dataSource: this.sideBarTabsSOList,
        onItemClick: this.changeFilterPanelTab,
        selectedIndex: this.sidebarTabSelectedIndex,
      };
    },

    commentItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "UserComment1",
              gcDynamicLabel: this.commentSettings.CommentLabel1,
              visible: this.commentSettings.CommentLabel1 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired1 !== "N",
            },
            {
              dataField: "UserComment2",
              gcDynamicLabel: this.commentSettings.CommentLabel2,
              visible: this.commentSettings.CommentLabel2 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired2 !== "N",
            },
            {
              dataField: "UserComment3",
              gcDynamicLabel: this.commentSettings.CommentLabel3,
              visible: this.commentSettings.CommentLabel3 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired3 !== "N",
            },
            {
              dataField: "UserComment4",
              gcDynamicLabel: this.commentSettings.CommentLabel4,
              visible: this.commentSettings.CommentLabel4 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired4 !== "N",
            },
            {
              dataField: "UserComment5",
              gcDynamicLabel: this.commentSettings.CommentLabel5,
              visible: this.commentSettings.CommentLabel5 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired5 !== "N",
            },
            {
              dataField: "UserComment6",
              gcDynamicLabel: this.commentSettings.CommentLabel6,
              visible: this.commentSettings.CommentLabel6 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired6 !== "N",
            },
            {
              dataField: "UserComment7",
              gcDynamicLabel: this.commentSettings.CommentLabel7,
              visible: this.commentSettings.CommentLabel7 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired7 !== "N",
            },
            {
              dataField: "UserComment8",
              gcDynamicLabel: this.commentSettings.CommentLabel8,
              visible: this.commentSettings.CommentLabel8 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired8 !== "N",
            },
            {
              dataField: "UserComment9",
              gcDynamicLabel: this.commentSettings.CommentLabel9,
              visible: this.commentSettings.CommentLabel9 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired9 !== "N",
            },
            {
              dataField: "UserComment10",
              gcDynamicLabel: this.commentSettings.CommentLabel10,
              visible: this.commentSettings.CommentLabel10 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired10 !== "N",
            },
            {
              dataField: "UserComment11",
              gcDynamicLabel: this.commentSettings.CommentLabel11,
              visible: this.commentSettings.CommentLabel11 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired11 !== "N",
            },
            {
              dataField: "UserComment12",
              gcDynamicLabel: this.commentSettings.CommentLabel12,
              visible: this.commentSettings.CommentLabel12 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired12 !== "N",
            },
            {
              dataField: "UserComment13",
              gcDynamicLabel: this.commentSettings.CommentLabel13,
              visible: this.commentSettings.CommentLabel13 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired13 !== "N",
            },
            {
              dataField: "UserComment14",
              gcDynamicLabel: this.commentSettings.CommentLabel14,
              visible: this.commentSettings.CommentLabel14 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired14 !== "N",
            },
            {
              dataField: "UserComment15",
              gcDynamicLabel: this.commentSettings.CommentLabel15,
              visible: this.commentSettings.CommentLabel15 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired15 !== "N",
            },
            {
              dataField: "UserComment16",
              gcDynamicLabel: this.commentSettings.CommentLabel16,
              visible: this.commentSettings.CommentLabel16 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired16 !== "N",
            },
            {
              dataField: "UserComment17",
              gcDynamicLabel: this.commentSettings.CommentLabel17,
              visible: this.commentSettings.CommentLabel17 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired17 !== "N",
            },
            {
              dataField: "UserComment18",
              gcDynamicLabel: this.commentSettings.CommentLabel18,
              visible: this.commentSettings.CommentLabel18 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired18 !== "N",
            },
            {
              dataField: "UserComment19",
              gcDynamicLabel: this.commentSettings.CommentLabel19,
              visible: this.commentSettings.CommentLabel19 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired19 !== "N",
            },
            {
              dataField: "UserComment20",
              gcDynamicLabel: this.commentSettings.CommentLabel20,
              visible: this.commentSettings.CommentLabel20 !== "",
              gcType: "String",
              editorType: "dxTextBox",
              required: this.commentSettings.CommentRequired20 !== "N",
            },
          ]),
        },
      ];
    },

    tabletViewSelectDataSourceConfig() {
      return this.tabletModePopUp.options.dataSourceConfig;
    },
    tabletViewSelectColumns() {
      // this.tabletModePopUp.options.columns = [];

      return this.tabletModePopUp.options.columns;
    },
    hasGpToolAccess() {
      return FeatureStorage.checkPermission("GP Tool", "create");
    },
    sideBarTabsSOList() {
      return [
        {
          id: 0,
          text: "Filters",
        },
        {
          id: 1,
          text: "Number Pad",
          visible: this.isTablet,
        },
      ];
    },
    filterItems() {
      var formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "ProdCat1",
              gcLabel: "Product Category 1",
              gcType: "String",
              editorType: "dxTagBox",
              disabled: this.categorySelectionDisabled,
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductCategory1Service.dataSourceConfig(
                  "api/ProductCategory1",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductCategory1Template",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                onFocusIn: this.isTablet
                  ? this.onFocusEvent.bind(this, "ProdCat1")
                  : null,
                openOnFieldClick: this.isTablet ? false : true,
                searchEnabled: this.isTablet ? false : true,
                onSelectionChanged: this.tabBoxOnSelectionChanged.bind(
                  this,
                  "ProdCat1"
                ),
              },
            },
            {
              dataField: "ProdCat2",
              gcLabel: "Product Category 2",
              gcType: "String",
              editorType: "dxTagBox",
              disabled: this.categorySelectionDisabled,
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductCategory1Service.dataSourceConfig(
                  "api/ProductCategory2",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductCategory2Template",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                onFocusIn: this.isTablet
                  ? this.onFocusEvent.bind(this, "ProdCat2")
                  : null,
                openOnFieldClick: this.isTablet ? false : true,
                searchEnabled: this.isTablet ? false : true,
                onSelectionChanged: this.tabBoxOnSelectionChanged.bind(
                  this,
                  "ProdCat2"
                ),
              },
            },
            {
              dataField: "ProdCat3",
              gcLabel: "Product Category 3",
              gcType: "String",
              editorType: "dxTagBox",
              disabled: this.categorySelectionDisabled,
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductCategory1Service.dataSourceConfig(
                  "api/ProductCategory3",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductCategory3Template",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                onFocusIn: this.isTablet
                  ? this.onFocusEvent.bind(this, "ProdCat3")
                  : null,
                openOnFieldClick: this.isTablet ? false : true,
                searchEnabled: this.isTablet ? false : true,
                onSelectionChanged: this.tabBoxOnSelectionChanged.bind(
                  this,
                  "ProdCat3"
                ),
              },
            },

            {
              dataField: "ProdCat4",
              gcLabel: "Product Category 4",
              gcType: "String",
              editorType: "dxTagBox",
              disabled: this.categorySelectionDisabled,
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductCategory1Service.dataSourceConfig(
                  "api/ProductCategory4",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductCategory4Template",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                onFocusIn: this.isTablet
                  ? this.onFocusEvent.bind(this, "ProdCat4")
                  : null,
                openOnFieldClick: this.isTablet ? false : true,
                searchEnabled: this.isTablet ? false : true,
                onSelectionChanged: this.tabBoxOnSelectionChanged.bind(
                  this,
                  "ProdCat4"
                ),
              },
            },
            {
              dataField: "ProdType",
              gcLabel: "Product Type",
              gcType: "String",
              editorType: "dxTagBox",
              disabled: this.categorySelectionDisabled,
              editorOptions: {
                onValueChanged: this.applyCustomFilter.bind(this),
                dataSource: ProductTypeService.dataSourceConfig(
                  "api/ProductType",
                  {
                    select: ["Code", "Description"],
                    filter: [["Inactive", "=", "N"]],
                    sort: [{ selector: "Description", asc: true }],
                  }
                ),
                itemTemplate: "ProductTypeTemplate",
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                onFocusIn: this.isTablet
                  ? this.onFocusEvent.bind(this, "ProdType")
                  : null,
                openOnFieldClick: this.isTablet ? false : true,
                searchEnabled: this.isTablet ? false : true,
                onSelectionChanged: this.tabBoxOnSelectionChanged.bind(
                  this,
                  "ProdType"
                ),
              },
            },
          ]),
        },
      ];

      return formFields;
    },
    deleteEnabled() {
      return this.baseView.mode != "review";
    },
    ...mapGetters({ applicationMode: "profile/applicationMode" }),
    tabs() {
      let tabItems = [];
      if (this.model.isEDIOrder) {
        tabItems = [
          {
            text: this.isTablet ? "Header" : "Order",
            path: `/sales-order-old/${this.baseView.mode}/${this.baseView.id}/header`,
            applicationFeatureCode: "SalesOrder",
          },
          {
            text: "Details",
            path: `/sales-order-old/${this.baseView.mode}/${this.baseView.id}/details`,
            applicationFeatureCode: "SalesOrder",
            visible: this.isTablet,
          },
          {
            text: "EDI",
            path: `/sales-order-edi/${this.baseView.id}`,
            applicationFeatureCode: "SalesOrderEDI",
          },
        ];
      } else {
        tabItems = [
          {
            text: this.isTablet ? "Header" : "Order",
            path: `/sales-order-old/${this.baseView.mode}/${this.baseView.id}/header`,
            applicationFeatureCode: "SalesOrder",
          },
          {
            text: "Details",
            path: `/sales-order-old/${this.baseView.mode}/${this.baseView.id}/details`,
            applicationFeatureCode: "SalesOrder",
            visible: this.isTablet,
          },
        ];
      }

      if (
        FeatureStorage.checkPermission(
          "AlmondcoInshellSalesOrderLotAssignment",
          "review"
        ) &&
        this.baseView.mode !== "create"
      ) {
        tabItems.push({
          text: "Lot Assignment",
          path: `/almondco-inshell-sales-order-lot-assignment/review/${this.baseView.id}`,
          applicationFeatureCode: "AlmondcoInshellSalesOrderLotAssignment",
        });
      }

      return tabItems;
      // return this.isTablet ? tabItems : [];
    },
    fields() {
      return {
        dateBoxOptions: {
          invalidDateMessage:
            "The date must have the following format: MM/dd/yyyy",
        },
        deliverToOptions: { height: 140 },
      };
    },
    dataSourceConfig() {
      return SalesOrderNoteService.dataSourceConfig({
        select: ["Note", "LineNo", "SalesOrderCode"],
        sort: [{ selector: "LineNo", asc: true }],
        filter: ["SalesOrderCode", "=", this.model.Code],
      });
    },
    // customerCodeInstance() {
    //   return this.$refs["customerCode"];
    // },
    setGridHeight() {
      // 76 default toolbar height
      // 24 popup content padding
      // 60 space for footer button
      return window.innerHeight * 0.8 - 76 - 24 - 60;
    },
    // popupHeight() {
    //   var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    //   return height - 100;
    // },
    statusFreindly() {
      let status =
        this.model.Status == "" ? "D" : this.model.Status.toUpperCase();
      if (status !== "X" && this.model.Status !== "C") {
        if (
          this.model.IsLockedForPicking !== undefined &&
          this.model.IsLockedForPicking.toUpperCase() === "Y"
        ) {
          status = "L";
        }
      }

      return status;
    },
    headerFormItems() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "DateIn",
                  gcLabel: "Date In",
                  gcType: "Date",
                  editorOptions: {
                    onValueChanged: this.onDateInValueChanged.bind(this),
                  },
                  required: true,
                },
                {
                  dataField: "RequiredByDate",
                  gcLabel: "Reqd Date",
                  gcType: "Date",
                  editorOptions: {
                    onValueChanged: this.onRequiredByDateValueChanged.bind(
                      this
                    ),
                  },
                  required: true,
                },
                {
                  dataField: "ShipDate",
                  gcLabel: "Ship Date",
                  gcType: "Date",
                  editorOptions: {
                    onValueChanged: this.onShipDateValueChanged.bind(this),
                  },

                  required: true,
                },
                {
                  dataField: "OrderNo",
                  gcLabel: "Cust PO",
                  editorOptions: {
                    maxLength: 20,
                    onValueChanged: this.onOrderNoChanged.bind(this),
                  },
                  gcType: "String",
                  editorType: "dxTextBox",
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "DeliveryAddressCompanyName",
                  gcLabel: "Deliver To",
                  gcType: "String",
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  required: true,
                  editorOptions: {
                    dataSource: deliveryAddressDataSource,
                    valueExpr: "CompanyName",
                    displayExpr: "CompanyName",
                    searchExpr: ["CustomerCode", "CompanyName"],
                    searchMode: "contains",
                    showClearButton: false,
                    itemTemplate: "deliveryAddressTemplate",
                    acceptCustomValue: true,
                    onCustomItemCreating: this.customItemCreating,

                    searchEnabled: this.isTablet ? false : true,
                    openOnFieldClick: this.isTablet ? false : true,
                    onItemClick: this.onDeliveryAddressChanged.bind(this),
                    onFocusIn: this.isTablet
                      ? this.onFocusEvent.bind(this, "DeliverTo")
                      : null,
                  },
                },

                {
                  dataField: "",
                  template: "editAddressTemplate",
                  gcType: "Button",
                },
                {
                  dataField: "ConsignmentNo",
                  gcLabel: "Con Note",
                  gcType: "String",
                  editorType: "dxTextBox",
                  editorOptions: {
                    maxLength: 100,
                  },
                },
                {
                  dataField: "CurrencyCode",
                  gcLabel: "Currency",
                  gcType: "String",
                  editorType: "dxTextBox",
                  editorOptions: {
                    readOnly: true,
                  },
                },
                {
                  dataField: "ExchangeRate",
                  gcLabel: "Exchange Rate",
                  gcType: "Decimal-6-4",
                  editorOptions: {
                    readOnly:
                      !this.exchangeRateEditable || this.factor368 == "N",
                    onValueChanged: this.onExchangeValueChanged,
                    step: 0,
                  },
                  required: true,
                },

                // {
                //   dataField: "DeliveryAddressStreetLine1",
                //   label: { text: "Street Line 1" },
                //   validationRules: [
                //     {
                //       type: "required",
                //       message: "Street Line 1 is required",
                //     },
                //   ],
                // },
                // {
                //   dataField: "DeliveryAddressStreetLine2",
                //   label: { text: "Street Line 2" },
                // },
                // {
                //   dataField: "DeliveryAddressSuburb",
                //   label: { text: "Suburb" },
                //   validationRules: [
                //     {
                //       type: "required",
                //       message: "Suburb is required",
                //     },
                //   ],
                // },
                // {
                //   dataField: "DeliveryAddressState",
                //   label: { text: "State" },
                //   validationRules: [
                //     {
                //       type: "required",
                //       message: "State is required",
                //     },
                //   ],
                // },
                // {
                //   dataField: "DeliveryAddressPostcode",
                //   label: { text: "Post Code" },
                //   validationRules: [
                //     {
                //       type: "required",
                //       message: "Post Code is required",
                //     },
                //   ],
                // },
                // {
                //   dataField: "DeliveryAddressCountry",
                //   label: { text: "Country" },
                //   validationRules: [
                //     {
                //       type: "required",
                //       message: "Country is required",
                //     },
                //   ],
                // },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: this.isTablet ? "BranchName" : "BranchCode",
                  gcLabel: "Branch",
                  gcType: "String",
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  required: true,
                  editorOptions: {
                    dataSource: BranchService.dataSourceConfig("api/Branch", {
                      sort: [{ selector: "Description", asc: true }],
                      select: ["Description", "Code"],
                      filter: ["Inactive", "=", "N"],
                    }),
                    valueExpr: "Code",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "branchTemplate",
                    searchEnabled: this.isTablet ? false : true,
                    openOnFieldClick: this.isTablet ? false : true,
                    displayExpr: "Description",
                    onValueChanged: this.onBranchCodeValueChanged.bind(this),
                    onFocusIn: this.isTablet
                      ? this.onFocusEvent.bind(this, "Branch")
                      : null,
                  },
                },
                {
                  dataField: this.isTablet ? "DivisionName" : "DivisionCode",
                  gcLabel: "Division",
                  gcType: "String",
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  required: true,
                  editorOptions: {
                    dataSource: BranchService.dataSourceConfig("api/Division", {
                      select: ["Code", "Description"],
                      filter: ["Inactive", "=", "N"],
                      sort: [{ selector: "Description", asc: true }],
                    }),
                    valueExpr: "Code",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "divisionTemplate",
                    searchEnabled: this.isTablet ? false : true,
                    openOnFieldClick: this.isTablet ? false : true,
                    displayExpr: "Description",
                    onFocusIn: this.isTablet
                      ? this.onFocusEvent.bind(this, "Division")
                      : null,
                  },
                },
                {
                  dataField: this.isTablet
                    ? "SalesOrderTypeName"
                    : "SalesOrderTypeCode",
                  gcLabel: "SO Type",
                  gcType: "String",
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  required: true,
                  editorOptions: {
                    dataSource: SalesOrderTypeService.dataSourceConfig(
                      "api/SalesOrderType",
                      {
                        select: ["Code", "Description"],
                        filter: ["Inactive", "=", "N"],
                        sort: [{ selector: "Description", asc: true }],
                      }
                    ),
                    valueExpr: "Code",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    showClearButton: true,
                    itemTemplate: "soTemplate",
                    searchEnabled: this.isTablet ? false : true,
                    openOnFieldClick: this.isTablet ? false : true,
                    displayExpr: "Description",
                    onValueChanged: this.onSoTypeValueChanged.bind(this),
                    onFocusIn: this.isTablet
                      ? this.onFocusEvent.bind(this, "SOType")
                      : null,
                  },
                },
                {
                  dataField: this.isTablet
                    ? "SalesRepresentativeName"
                    : "SalesRepresentativeCode",
                  gcLabel: "Sales Rep",
                  gcType: "String",
                  editorType: this.isTablet ? "dxTextBox" : "dxSelectBox",
                  required: true,
                  editorOptions: {
                    dataSource: SalesRepresentativeService.dataSourceConfig(
                      "api/SalesRepresentative",
                      {
                        select: ["Code", "FirstName", "Surname"],
                        filter: ["Inactive", "=", "N"],
                        sort: [{ selector: "FirstName", asc: true }],
                      }
                    ),
                    itemTemplate: "salesRepTemplate",
                    valueExpr: "Code",
                    displayExpr: function(data) {
                      if (data) return data.FirstName + " " + data.Surname;
                    },
                    searchExpr: ["Code", "FirstName", "Surname"],
                    searchMode: "contains",
                    showClearButton: true,
                    searchEnabled: this.isTablet ? false : true,
                    openOnFieldClick: this.isTablet ? false : true,
                    onFocusIn: this.isTablet
                      ? this.onFocusEvent.bind(this, "SalesRep")
                      : null,
                  },
                },
              ]),
            },
          ],
        },
      ];

      return items;
    },
    soDetailsColumns() {
      if (this.soDetailsCurrentView == "GridList")
        return this.soGridViewColumns;
      // else return this.getSoDetailsGridColumns();
      else return this.soDetailsGridColumns;
    },
    soDetailsGrid() {
      return this.$refs[this.soDetailsGridRefName]
        ? this.$refs[this.soDetailsGridRefName].instance
        : null;
    },
    soDetailsColumnTotalLabel() {
      return `Total (${this.model.CurrencyCode})`;
    },
    soDetailsColumnPriceLabel() {
      return `Price (${this.model.CurrencyCode})`;
    },
    soDetailsColumnNetPriceLabel() {
      return `Net (${this.model.CurrencyCode})`;
    },
    soCellEditorClass() {
      return this.baseView.mode !== "review" ? "gc-editor-cell" : "";
    },
    computedFXExTaxTotal() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()
          .forEach(
            (x) => (total += parseFloat(x.TaxableFXLineTotal).roundNumber(4))
          );

      return total.roundNumber(4);
    },
    computedExTaxTotal() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()
          .forEach(
            (x) => (total += parseFloat(x.TaxableLineTotal).roundNumber(4))
          );

      return total.roundNumber(4);
    },
    computedFXTaxTotal() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()

          .forEach(
            (x) => (total += parseFloat(x.TaxFXLineTotal).roundNumber(4))
          );

      return total.roundNumber(4);
    },
    computedTaxTotal() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()

          .forEach((x) => (total += parseFloat(x.TaxLineTotal).roundNumber(4)));

      return total.roundNumber(4);
    },
    computedItemCount() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()

          .forEach((x) => (total += parseFloat(x.SalesUMQty).roundNumber(4)));

      return total;
    },
    computedStockItemCount() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()

          .forEach((x) => (total += Math.floor(x.StockUMQty)));

      return total;
    },
    computedFXTotal() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()
          .forEach((x) => (total += parseFloat(x.FXLineTotal).roundNumber(4)));

      return total.roundNumber(4);
    },
    computedTotal() {
      let total = 0;
      if (this.salesOrderDetailsReviewList)
        this.salesOrderDetailsReviewList
          .items()
          .forEach((x) => (total += parseFloat(x.LineTotal).roundNumber(4)));

      return total.roundNumber(4);
    },
    toolbarFormItems() {
      var items = this.parseFormColumns([
        {
          dataField: "CustomerCode",
          ref: "customerCode",
          cssClass: "toolbar-customer-label",
          gcLabel: "Customer",
          labelVisible: false,
          gcType: "String",
          editorType: "dxSelectBox",
          required: true,
          editorOptions: {
            dataSource: customerDataSource,
            valueExpr: "Code",
            displayExpr: "Name",
            searchExpr: ["Code", "Name"],
            searchMode: "contains",
            showClearButton: true,
            itemTemplate: "agentTemplate",
            searchEnabled: true,
            onValueChanged: this.onCustomerCodeValueChanged,
            // key: "RecordId",
            onItemClick: this.onCustomerItemClicked,
            placeholder: "Customer Name",
            onFocusIn: this.isTablet
              ? this.onFocusEvent.bind(this, "Customer")
              : null,
          },
        },
      ]);

      return this.dataLoaded ? items : [];
    },
    setProductDetails() {
      if (this.productDetails.data != null) {
        return true;
      } else {
        return false;
      }
    },
    getGPToolNewPriceLable() {
      return `New Price (${this.model.CurrencyCode})`;
    },
    getStandardSellLable() {
      return `Std Sell (${this.model.CurrencyCode})`;
    },
    getCurrentPriceLable() {
      return `Current Price (${this.model.CurrencyCode})`;
    },
    getGPToolFormItems() {
      var items = [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              colCound: 1,
              items: this.parseFormColumns([
                {
                  dataField: "quantity",
                  gcLabel: "Quantity",
                  gcType: "String",
                  editorType: "dxTextBox",
                  readOnly: true,
                },
                {
                  dataField: "standardSell",
                  gcDynamicLabel: this.getStandardSellLable,
                  gcType: "Decimal-4-2C",
                  readOnly: true,
                },
                {
                  dataField: "currentPrice",
                  gcDynamicLabel: this.getCurrentPriceLable,
                  gcType: "Decimal-4-2C",
                  readOnly: true,
                },
              ]),
            },
            {
              itemType: "group",
              caption: "",
              colCound: 1,
              items: this.parseFormColumns([
                {
                  dataField: "gp",
                  gcLabel: "GP %",
                  gcType: "Decimal-4-2",
                  editorOptions: {
                    onChange: this.gpPrecentageChange.bind(this),
                    onValueChanged: this.onGpValueChanged,
                  },
                },
                {
                  dataField: "newSalesUMNetPrice",
                  gcDynamicLabel: this.getGPToolNewPriceLable,
                  gcType: "Decimal-4-2C",
                  editorOptions: {
                    onChange: this.gpNewPriceChange.bind(this),
                  },
                },
              ]),
            },
          ],
        },
      ];

      return items;
    },
    getBestBeforeDateFormItems() {
      var items = [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "bestBeforeDate",
              gcLabel: "Best Before Date",
              gcType: "Date",
            },
          ]),
        },
      ];

      return items;
    },
    customerCodeComputed() {
      return this.model.CustomerCode;
    },
  },
  methods: {
    stockLevelCallBack() {
      this.visibleStockLevels = !this.visibleStockLevels;
    },
    visibleStockLevel(item) {
      this.stockLevelItemData = item;
      this.visibleStockLevels = !this.visibleStockLevels;
    },
    async onGpValueChanged(e) {
      if (e.value >= 100 || e.value < 0) {
        let res = await alert(
          "GP % must have a value between 0 and 100",
          "Invalid GP Value"
        );
        if (res) {
          this.gpTool.model.gp = e.previousValue;
        }
      }
    },
    showLoadingHelper(state) {
      this.showLoading(state);
    },
    expandGrid() {
      this.gridExpanded = !this.gridExpanded;
      this.$refs[this.soDetailsGridRefName].instance.repaint(true);
    },
    gridTotalsOnContentReady(e) {
      this.gridTotalPopUpHeight = e.element.clientHeight + 160;
    },
    async onOrderNoChanged(e) {
      if (this.getFactorByCode(578).Factorc !== "Y" || e.value == "") return;
      let orderNo = e.value;

      let result = await SalesOrderService.findOrderNoUsageForSalesOrder(
        orderNo,
        this.model.Code,
        this.model.CustomerCode
      );

      let orderNoUsedPreviously = result.data.value.length > 0;
      if (!orderNoUsedPreviously) {
        result = await SalesOrderService.findOrderNoUsageForInvoice(
          orderNo,
          this.model.Code,
          this.model.CustomerCode
        );
        orderNoUsedPreviously = result.data.value.length > 0;
      }

      if (orderNoUsedPreviously) {
        // Show prompt
        let confirmOrderNoReuse = await this.$confirm(
          `Customer ${this.model.CustomerName} has used Customer PO ${orderNo} previously. Will you use Customer PO ${orderNo} again?`,
          "Customer PO Used Previously"
        );

        if (!confirmOrderNoReuse) {
          e.component.focus();
          e.element.querySelector("input").select();
        }
      }
    },
    onNotesPopupHidden() {
      const maxLineNo = Math.max.apply(
        Math,
        this.orderNotesDataSourceConfig.map(function(o) {
          return o.LineNo ? o.LineNo : -1;
        })
      );
      let notes = this.orderNotesDataSourceConfig.map((note) => {
        let n = {
          LineNo: maxLineNo + 1,
          Note: note.Note,
        };
        return n;
      });
      this.model.SalesOrderNotes = notes;
    },
    headerFormOnContentReady() {
      if (document.getElementsByClassName("sales-order-form").length != 0) {
        this.formHeight = document.getElementsByClassName(
          "sales-order-form"
        )[0].clientHeight;
        this.toolbarHeight = document.getElementsByClassName(
          "sales-order-toolbar"
        )[0].clientHeight;
      }
    },
    editDeliveryAddress() {
      this.visibleEditDeliveryAddress = !this.visibleEditDeliveryAddress;
    },
    deliveryAddressCallBack() {
      this.visibleEditDeliveryAddress = false;
    },
    async onExchangeValueChanged(e) {
      if (this.isExchangeReverting) {
        this.isExchangeReverting = false;
        return;
      }
      if (e.value === 0) {
        this.displayValidationSummary([
          "Exchange rate should be greater than 0.0000",
        ]);
        this.isExchangeReverting = true;
        this.model.ExchangeRate = e.previousValue;
      } else {
        // let confirmExchangeChange = await this.$confirm(
        //   "Would you like to recalculate the sell price of all items based upon this new Exchange Rate?",
        //   "Exchange Rate Change"
        // );

        this.setCompanyCurrencyPriceAllLines();

        // if (confirmExchangeChange) {
        //   this.setSaleItemPriceAllLines();
        // } else {
        //   this.isExchangeReverting = true;
        //   this.model.ExchangeRate = e.previousValue;
        // }
      }
    },

    async onCustomerItemClicked(e) {
      if (this.baseView.mode == "create")
        this.setDefaultSalesRep(e.itemData.SalesRepresentativeCode);
      soGlobal.model.CustomerCode = this.model.CustomerCode;
      this.model.Currency = e.itemData.CurrencyCode;
      let result = await CompanyCurrencyService.getByCurrencyCode(
        this.model.CurrencyCode
      );
      this.model.ExchangeRate = result.data.value[0].BuyRate;
    },
    getProductSizeCodeBySequence(sequence) {
      let record = this.sizeTotalGridColumns.find(
        (s) => s.sequence == sequence
      );
      return record.productSizeCode;
    },

    async getCommentSettings() {
      let result = await SalesOrderTypeService.getByCode(
        this.model.SalesOrderTypeCode
      );

      this.commentSettings = result.data.value[0];
      this.$logger.debug(result);
    },
    popUpCallBack(updated, value) {
      this.visibleItemPriceUpdate = !this.visibleItemPriceUpdate;
      this.itemPriceUpdateValue = value;
      if (updated) {
        this.fromItemPriceUpdate = true;
        this.applyGPToolValue();
      }
    },
    onKeyDown(e) {
      this.$logger.debug(e, "keypress event");
      if (e.event.ctrlKey) {
        this.$logger.debug("Ctrl  was pressed");
      }
    },
    getGridReference() {
      let grid = this.$refs[this.soDetailsGridRefName];

      return grid;
    },
    async soDetailsGridonContentReady(e) {
      this.advanceFilter.filterFormHeight =
        document.getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
          .clientHeight -
        document.getElementsByClassName("dx-datagrid-header-panel")[0]
          .clientHeight -
        document.getElementsByClassName("dx-datagrid-headers")[0].clientHeight -
        5;

      if (this.showNumberPadForTheFirstTime) {
        this.reApplyFocus();
        this.showNumberPadForTheFirstTime = false;
      }
      this.addGridNoResults(e);
    },
    getSalesUmDataSourceForItemCode(itemCode) {
      return SaleItemCompanyBranchService.dataSourceConfig(
        "api/SaleItemCompanyBranch",
        {
          select: ["SalesUM"],
          sort: [
            { selector: "IsDefault", desc: true },
            { selector: "SalesUM", desc: false },
          ],
          filter: [
            [
              ["BranchCode", "=", this.model.BranchCode],
              "and",
              ["CompanyCode", "=", this.model.CompanyCode],
            ],
            "and",
            [["ItemCode", "=", itemCode], "and", ["ItemType ", "=", "S"]],
          ],
        }
      );
    },
    tabletModeSelectPopupEditorPreparing(e) {
      if (e.editorName === "dxTextBox" && e.parentType == "searchPanel") {
        const defaultValueChangeHandler = e.editorOptions.onFocusIn;
        e.editorOptions.onFocusIn = function(args) {
          // setTimeout(() => {
          // window.scrollTo(0, 0);
          // document.body.scrollTop = 0;
          // }, 500);
          defaultValueChangeHandler(args);
        };
      }
    },
    onCellPrepared(e) {
      if (e.rowType == "data") {
        if (this.soDetailsCurrentView == "GridList") {
          const sizePatternToMatch = /^Size(\w+)Qty/;
          let m;

          if ((m = sizePatternToMatch.exec(e.column.dataField)) !== null) {
            let matchingSizeSequence = m[1];

            if (e.data["Size" + matchingSizeSequence + "ItemCode"] !== "") {
              if (e.data["Size" + matchingSizeSequence + "Available"] <= 0) {
                e.cellElement.className = "avail-error";
              } else if (
                e.data["Size" + matchingSizeSequence + "Available"] > 0
              ) {
                e.cellElement.className = "avail-no-error";
              }

              if (!this.model.BranchCode) {
                e.data["Size" + matchingSizeSequence + "Available"] = 0;
                e.cellElement.className = "avail-no-error";
              }
            }
          }
        } else {
          if (e.column.dataField == "Available") {
            if (e.value <= 0) {
              e.cellElement.className = "avail-error";
            } else if (e.value > 0) {
              e.cellElement.className = "avail-no-error";
            }

            if (!this.model.BranchCode) {
              e.cellElement.className = "avail-no-error";
            }
          }
        }
      }
    },
    changeFilterPanelTab(e) {
      this.sidebarTabSelectedIndex = e.itemIndex;
    },
    customePopUpRowClick(e) {
      var grid = e.component;
      var rowKey = grid.getKeyByRowIndex(e.rowIndex);
      if (!e.isSelected) grid.selectRows(e.key, true);
      else grid.deselectRows([rowKey]);

      if (e.data.SalesRepresentativeCode)
        this.setDefaultSalesRep(e.data.SalesRepresentativeCode);
    },
    showNumericKeyPad() {
      if (!this.showRightContainer) {
        this.showRightContainer = !this.showRightContainer;

        // soDetailsGridInstance.repaint();
        this.showNumberPadForTheFirstTime = true;
      }
      this.sidebarTabSelectedIndex = 1;
    },
    selectPopUpToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return item.name !== "searchPanel";
      });

      searchPanel.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: 260,
            dataSource: salesRepDataSource,
            placeholder: "Sales Representative",
            valueExpr: "Code",
            value: this.tabletModePopUp.model.filterBySalesRep,
            showClearButton: true,
            searchEnabled: false,
            displayExpr: function(data) {
              if (data) return data.FirstName + " " + data.Surname;
            },
            onValueChanged: (e) => {
              let grid = this.$refs["custom-popup-grid"].instance;
              if (e.value != null) {
                grid.filter([
                  ["SalesRepresentativeCode", "=", e.value],
                  "and",
                  ["Inactive", "=", "N"],
                ]);
              } else {
                grid.filter(["Inactive", "=", "N"]);
              }
            },
            showDataBeforeSearch: true,
          },
          visible: this.tabletModePopUp.options.selectSalesRep,
        },
        searchPanel
      );
    },
    onContentReady() {
      let grid = this.$refs["custom-popup-grid"].instance;
      grid.off("contentReady");

      if (this.tabletModePopUp.options.run == false) {
        this.tabletModePopUp.options.run = true;

        switch (this.tabletModePopUp.model.type) {
          case "ProdCat1": {
            this.advanceFilter.model.ProdCat1SelectedRows.forEach((element) => {
              this.tabletModePopUp.options.selectedRowKeys.push(element);
            });
            break;
          }
          case "ProdCat2": {
            this.advanceFilter.model.ProdCat2SelectedRows.forEach((element) => {
              this.tabletModePopUp.options.selectedRowKeys.push(element);
            });
            break;
          }
          case "ProdCat3": {
            this.advanceFilter.model.ProdCat3SelectedRows.forEach((element) => {
              this.tabletModePopUp.options.selectedRowKeys.push(element);
            });
            break;
          }

          case "ProdCat4": {
            this.advanceFilter.model.ProdCat4SelectedRows.forEach((element) => {
              this.tabletModePopUp.options.selectedRowKeys.push(element);
            });
            break;
          }
          case "ProdType": {
            this.advanceFilter.model.ProdTypeSelectedRows.forEach((element) => {
              this.tabletModePopUp.options.selectedRowKeys.push(element);
            });
            break;
          }

          default:
            break;
        }
      }

      grid.refresh(true);
      setTimeout(() => {
        grid.on("contentReady", this.onContentReady);
      }, 1500);
    },
    async tabBoxOnSelectionChanged(type, e) {
      if (
        e.removedItems.length ==
          this.tabletModePopUp.options.selectedRowKeys.length &&
        this.selectedIndex == 1
      ) {
        if (
          this.$refs["so-filter-form"].instance.getEditor(type) != undefined
        ) {
          this.$refs["so-filter-form"].instance.getEditor(type).blur();

          this.tabletModeSelectPopupVisible = false;
          // #27990 : Filters not clearing correctly
          // this.tabletModePopUp.options.clearAll = true;
        } else {
          this.tabletModePopUp.options.clearAll = false;
        }
      } else {
        this.tabletModePopUp.options.clearAll = false;
      }

      switch (type) {
        case "ProdCat1": {
          e.removedItems.forEach(async (element) => {
            var index = this.advanceFilter.model.ProdCat1SelectedRows.findIndex(
              (x) => x.Code == element.Code
            );
            if (index > -1) {
              this.advanceFilter.model.ProdCat1SelectedRows.splice(index, 1);
              this.tabletModePopUp.options.selectedRowKeys.splice(index, 1);
            }
          });
          break;
        }

        case "ProdCat2": {
          e.removedItems.forEach(async (element) => {
            var index2 = this.advanceFilter.model.ProdCat2SelectedRows.findIndex(
              (x) => x.Code == element.Code
            );
            if (index2 > -1) {
              this.advanceFilter.model.ProdCat2SelectedRows.splice(index2, 1);
              this.tabletModePopUp.options.selectedRowKeys.splice(index2, 1);
            }
          });
          break;
        }
        case "ProdCat3": {
          e.removedItems.forEach(async (element) => {
            var index3 = this.advanceFilter.model.ProdCat3SelectedRows.findIndex(
              (x) => x.Code == element.Code
            );
            if (index3 > -1) {
              this.advanceFilter.model.ProdCat3SelectedRows.splice(index3, 1);
              this.tabletModePopUp.options.selectedRowKeys.splice(index3, 1);
            }
          });
          break;
        }
        case "ProdCat4": {
          e.removedItems.forEach(async (element) => {
            var index4 = this.advanceFilter.model.ProdCat4SelectedRows.findIndex(
              (x) => x.Code == element.Code
            );
            if (index4 > -1) {
              this.advanceFilter.model.ProdCat4SelectedRows.splice(index4, 1);
              this.tabletModePopUp.options.selectedRowKeys.splice(index4, 1);
            }
          });
          break;
        }
        case "ProdType": {
          e.removedItems.forEach(async (element) => {
            var index5 = this.advanceFilter.model.ProdTypeSelectedRows.findIndex(
              (x) => x.Code == element.Code
            );
            if (index5 > -1) {
              this.advanceFilter.model.ProdTypeSelectedRows.splice(index5, 1);
              this.tabletModePopUp.options.selectedRowKeys.splice(index5, 1);
            }
          });
          break;
        }

        default:
          break;
      }
    },
    applyPopUpFilter() {
      this.tabletModeSelectPopupVisible = false;

      // this.tabletModePopUp.options.selectedRowKeys = [];

      let grid = this.$refs["custom-popup-grid"].instance;
      var selectedRowKeys = grid.getSelectedRowKeys();

      grid.option("dataSource", []);
      grid.repaint(true);

      switch (this.tabletModePopUp.model.type) {
        case "ProdCat1": {
          this.advanceFilter.model.ProdCat1 = [];
          this.advanceFilter.model.ProdCat1SelectedRows = [];
          selectedRowKeys.forEach((element) => {
            let index = this.advanceFilter.model.ProdCat1.findIndex(
              (x) => x == element.Code
            );
            if (index < 0) {
              this.advanceFilter.model.ProdCat1.push(element.Code);
              this.advanceFilter.model.ProdCat1SelectedRows.push(element);
            }
          });
          break;
        }

        case "ProdCat2": {
          this.advanceFilter.model.ProdCat2 = [];
          this.advanceFilter.model.ProdCat2SelectedRows = [];
          selectedRowKeys.forEach((element) => {
            let index = this.advanceFilter.model.ProdCat2.findIndex(
              (x) => x == element.Code
            );
            if (index < 0) {
              this.advanceFilter.model.ProdCat2.push(element.Code);
              this.advanceFilter.model.ProdCat2SelectedRows.push(element);
            }
          });
          break;
        }
        case "ProdCat3": {
          this.advanceFilter.model.ProdCat3 = [];
          this.advanceFilter.model.ProdCat3SelectedRows = [];
          selectedRowKeys.forEach((element) => {
            let index = this.advanceFilter.model.ProdCat3.findIndex(
              (x) => x == element.Code
            );
            if (index < 0) {
              this.advanceFilter.model.ProdCat3.push(element.Code);
              this.advanceFilter.model.ProdCat3SelectedRows.push(element);
            }
          });
          break;
        }
        case "ProdCat4": {
          this.advanceFilter.model.ProdCat4 = [];
          this.advanceFilter.model.ProdCat4SelectedRows = [];
          selectedRowKeys.forEach((element) => {
            let index = this.advanceFilter.model.ProdCat4.findIndex(
              (x) => x == element.Code
            );
            if (index < 0) {
              this.advanceFilter.model.ProdCat4.push(element.Code);
              this.advanceFilter.model.ProdCat4SelectedRows.push(element);
            }
          });
          break;
        }

        case "ProdType": {
          this.advanceFilter.model.ProdType = [];
          this.advanceFilter.model.ProdTypeSelectedRows = [];
          selectedRowKeys.forEach((element) => {
            let index = this.advanceFilter.model.ProdType.findIndex(
              (x) => x == element.Code
            );
            if (index < 0) {
              this.advanceFilter.model.ProdType.push(element.Code);
              this.advanceFilter.model.ProdTypeSelectedRows.push(element);
            }
          });
          break;
        }

        default:
          break;
      }
    },
    customePopUpHidden() {
      this.tabletModePopUp.options.selectSalesRep = false;
      // this.tabletModePopUp.options.selectedRowKeys = [];
      let grid = this.$refs["custom-popup-grid"].instance;
      if (this.tabletModePopUp.model.type != "DeliverTo") {
        grid.clearFilter();
      }
      // grid.option("dataSource", []);
      // grid.repaint(true);
      this.productDetails.imageURL = null;

      // remove focus from the filter field on tablet mode popup
      let type = this.tabletModePopUp.model.type;
      let filterFormInstance = this.$refs["so-filter-form"].instance;
      if (type && filterFormInstance.getEditor(type) != undefined) {
        filterFormInstance.getEditor(type).blur();
        this.tabletModeSelectPopupVisible = false;
      }
    },
    async tabletViewSelectionChanged(e) {
      if (e.selectedRowsData.length != 0) {
        let customer = {};
        switch (this.tabletModePopUp.model.type) {
          case "Customer":
            this.model.CustomerCode = e.selectedRowsData[0].Code;
            this.model.CustomerName = e.selectedRowsData[0].Name;
            deliveryAddressDataSource.filter([
              "CustomerCode",
              "=",
              e.selectedRowsData[0].Code,
            ]);
            await deliveryAddressDataSource.load().then((result) => {
              if (result) {
                var item = result.filter((x) => {
                  return x.LineNo == 1;
                });
                if (item) {
                  this.model.DeliveryAddressCompanyName = item[0].CompanyName;
                  this.model.DeliveryAddressStreetLine1 =
                    item[0].PhysicalAddressStreetLine1;
                  this.model.DeliveryAddressStreetLine2 =
                    item[0].PhysicalAddressStreetLine2;
                  this.model.DeliveryAddressSuburb =
                    item[0].PhysicalAddressSuburb;
                  this.model.DeliveryAddressState =
                    item[0].PhysicalAddressState;
                  this.model.DeliveryAddressPostcode =
                    item[0].PhysicalAddressPostcode;
                  this.model.DeliveryAddressCountry =
                    item[0].PhysicalAddressCountry;
                }
              }
            });

            // HACK
            customer.value = this.model.CustomerCode;
            customer.previousValue = this.model.PreviousCustomer;
            this.onCustomerCodeValueChanged(customer);
            //

            this.tabletModeSelectPopupVisible = false;
            break;

          case "Branch":
            this.model.BranchCode = e.selectedRowsData[0].Code;
            this.model.BranchName = e.selectedRowsData[0].Description;
            this.tabletModeSelectPopupVisible = false;
            break;

          case "Division":
            this.model.DivisionCode = e.selectedRowsData[0].Code;
            this.model.DivisionName = e.selectedRowsData[0].Description;
            this.tabletModeSelectPopupVisible = false;
            break;

          case "SOType":
            this.model.SalesOrderTypeCode = e.selectedRowsData[0].Code;
            this.model.SalesOrderTypeName = e.selectedRowsData[0].Description;
            this.tabletModeSelectPopupVisible = false;
            break;

          case "SalesRep":
            this.model.SalesRepresentativeCode = e.selectedRowsData[0].Code;
            this.model.SalesRepresentativeName =
              e.selectedRowsData[0].FirstName +
              " " +
              e.selectedRowsData[0].Surname;
            this.tabletModeSelectPopupVisible = false;
            break;

          case "DeliverTo":
            this.model.DeliveryAddressCompanyName =
              e.selectedRowsData[0].CompanyName;
            this.tabletModeSelectPopupVisible = false;
            break;

          default:
            break;
        }
      }
    },
    onFocusEvent(type) {
      if (this.model.CustomerCode) {
        this.model.PreviousCustomer = this.model.CustomerCode;
      }
      if (!this.tabletModePopUp.options.clearAll) {
        this.tabletModePopUp.options.run = false;
        this.tabletModePopUp.options.dataSourceConfig = [];
        this.tabletModePopUp.options.selectedRowKeys = [];
        this.tabletModeSelectPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Order Tablet Select Mode");
        this.tabletModePopUp.model.type = type;
        switch (type) {
          case "Customer":
            this.tabletModePopUp.model.title = "Customer Search";
            this.tabletModePopUp.options.selectSalesRep = true;
            var grid = this.$refs["custom-popup-grid"].instance;
            grid.repaint(true);
            this.tabletModePopUp.options.dataSourceConfig = AgentSupplierService.dataSourceConfig(
              "api/Customer",
              {
                select: [
                  "Code",
                  "Name",
                  "SalesRepresentativeCode",
                  "CurrencyCode",
                ],
                sort: [{ selector: "Name", asc: true }],
                top: 50,
                filter:
                  this.tabletModePopUp.model.filterBySalesRep != ""
                    ? [
                        [
                          "SalesRepresentativeCode",
                          "=",
                          this.tabletModePopUp.model.filterBySalesRep,
                        ],
                        "and",
                        ["Inactive", "=", "N"],
                      ]
                    : ["Inactive", "=", "N"],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "customer-cell-template",
              },
              {
                caption: "Name",
                dataField: "Name",
                visible: false,
              },
            ];
            break;
          case "Branch":
            this.tabletModePopUp.model.title = "Branch Search";
            if (this.isTablet)
              this.$refs["so-header-form"].instance
                .getEditor("BranchName")
                .blur();
            this.tabletModePopUp.options.dataSourceConfig = BranchService.dataSourceConfig(
              "api/Branch",
              {
                sort: [{ selector: "Description", asc: true }],
                select: ["Description", "Code"],
                filter: ["Inactive", "=", "N"],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];
            break;

          case "Division":
            this.tabletModePopUp.model.title = "Division Search";
            if (this.isTablet)
              this.$refs["so-header-form"].instance
                .getEditor("DivisionName")
                .blur();
            this.tabletModePopUp.options.dataSourceConfig = BranchService.dataSourceConfig(
              "api/Division",
              {
                select: ["Code", "Description"],
                filter: ["Inactive", "=", "N"],
                sort: [{ selector: "Description", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];

            break;

          case "SOType":
            this.tabletModePopUp.model.title = "Division Search";
            if (this.isTablet)
              this.$refs["so-header-form"].instance
                .getEditor("SalesOrderTypeName")
                .blur();
            this.tabletModePopUp.options.dataSourceConfig = SalesOrderTypeService.dataSourceConfig(
              "api/SalesOrderType",
              {
                select: ["Code", "Description"],
                filter: ["Inactive", "=", "N"],
                sort: [{ selector: "Description", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];
            break;

          case "SalesRep":
            this.tabletModePopUp.model.title = "Sales Rep Search";
            if (this.isTablet)
              this.$refs["so-header-form"].instance
                .getEditor("SalesRepresentativeName")
                .blur();
            this.tabletModePopUp.options.dataSourceConfig = SalesRepresentativeService.dataSourceConfig(
              "api/SalesRepresentative",
              {
                select: ["Code", "FirstName", "Surname"],
                filter: ["Inactive", "=", "N"],
                sort: [{ selector: "FirstName", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "sales-rep-cell-template",
              },
              {
                caption: "FirstName",
                dataField: "FirstName",
                visible: false,
              },
              {
                caption: "Surname",
                dataField: "Surname",
                visible: false,
              },
            ];
            break;

          case "ProdCat1":
            this.tabletModePopUp.model.title = "Product Category 1 Filter";
            this.tabletModePopUp.options.showBackButton = false;
            this.tabletModePopUp.options.showOkButton = true;
            this.tabletModePopUp.options.multipleSelect = true;
            this.tabletModePopUp.options.dataSourceConfig = ProductCategory1Service.dataSourceConfig(
              "api/ProductCategory1",
              {
                select: ["Code", "Description"],
                filter: [["Inactive", "=", "N"]],
                sort: [{ selector: "Description", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];

            break;

          case "ProdCat2":
            this.tabletModePopUp.model.title = "Product Category 2 Filter";
            this.tabletModePopUp.options.showBackButton = false;
            this.tabletModePopUp.options.showOkButton = true;
            this.tabletModePopUp.options.multipleSelect = true;
            this.tabletModePopUp.options.dataSourceConfig = ProductCategory1Service.dataSourceConfig(
              "api/ProductCategory2",
              {
                select: ["Code", "Description"],
                filter: [["Inactive", "=", "N"]],
                sort: [{ selector: "Description", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];

            break;

          case "ProdCat3":
            this.tabletModePopUp.model.title = "Product Category 3 Filter";
            this.tabletModePopUp.options.showBackButton = false;
            this.tabletModePopUp.options.showOkButton = true;
            this.tabletModePopUp.options.multipleSelect = true;
            this.tabletModePopUp.options.dataSourceConfig = ProductCategory1Service.dataSourceConfig(
              "api/ProductCategory3",
              {
                select: ["Code", "Description"],
                filter: [["Inactive", "=", "N"]],
                sort: [{ selector: "Description", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];

            break;

          case "ProdCat4":
            this.tabletModePopUp.model.title = "Product Category 4 Filter";
            this.tabletModePopUp.options.showBackButton = false;
            this.tabletModePopUp.options.showOkButton = true;
            this.tabletModePopUp.options.multipleSelect = true;
            this.tabletModePopUp.options.dataSourceConfig = ProductCategory1Service.dataSourceConfig(
              "api/ProductCategory4",
              {
                select: ["Code", "Description"],
                filter: [["Inactive", "=", "N"]],
                sort: [{ selector: "Description", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];

            break;

          case "ProdType":
            this.tabletModePopUp.model.title = "Product Type Filter";
            this.tabletModePopUp.options.showBackButton = false;
            this.tabletModePopUp.options.showOkButton = true;
            this.tabletModePopUp.options.multipleSelect = true;
            this.tabletModePopUp.options.dataSourceConfig = ProductTypeService.dataSourceConfig(
              "api/ProductType",
              {
                select: ["Code", "Description"],
                filter: [["Inactive", "=", "N"]],
                sort: [{ selector: "Description", asc: true }],
              }
            );

            this.tabletModePopUp.options.columns = [
              {
                caption: "Code",
                dataField: "Code",
                cellTemplate: "branch-cell-template",
              },
              {
                caption: "Description",
                dataField: "Description",
                visible: false,
              },
            ];

            break;

          case "DeliverTo":
            if (this.isTablet)
              this.$refs["so-header-form"].instance
                .getEditor("DeliveryAddressCompanyName")
                .blur();
            this.tabletModePopUp.model.title = "Deliver To Search";
            this.tabletModePopUp.options.showBackButton = true;
            this.tabletModePopUp.options.showOkButton = false;
            this.tabletModePopUp.options.multipleSelect = false;
            this.tabletModePopUp.options.dataSourceConfig = deliveryAddressDataSource;

            this.tabletModePopUp.options.columns = [
              {
                caption: "Company Name",
                dataField: "CompanyName",
                cellTemplate: "deliveryAddressTemplate",
              },
              {
                caption: "PhysicalAddressStreetLine1",
                dataField: "PhysicalAddressStreetLine1",
                visible: false,
              },
              {
                caption: "AddressStreet Line 2",
                dataField: "PhysicalAddressStreetLine2",
                visible: false,
              },
              {
                caption: "PhysicalAddressSuburb",
                dataField: "PhysicalAddressSuburb",
                visible: false,
              },
              {
                caption: "PhysicalAddressState",
                dataField: "PhysicalAddressState",
                visible: false,
              },
              {
                caption: "PhysicalAddressPostcode",
                dataField: "PhysicalAddressPostcode",
                visible: false,
              },
              {
                caption: "PhysicalAddressCountry",
                dataField: "PhysicalAddressCountry",
                visible: false,
              },
            ];
            break;

          default:
            break;
        }
      }
    },
    clearAdvanceFilters() {
      this.advanceFilter.model.ProdCat1 = [];
      this.advanceFilter.model.ProdCat2 = [];
      this.advanceFilter.model.ProdCat3 = [];
      this.advanceFilter.model.ProdCat4 = [];
      this.advanceFilter.model.ProdType = [];
      this.advanceFilter.model.ProdCat1SelectedRows = [];
      this.advanceFilter.model.ProdCat2SelectedRows = [];
      this.advanceFilter.model.ProdCat3SelectedRows = [];
      this.advanceFilter.model.ProdCat4SelectedRows = [];
      this.advanceFilter.model.ProdTypeSelectedRows = [];
      this.defaultFilters.setCustomFilter = [];
    },
    applyCustomFilter() {
      const createFilter = [];
      if (this.advanceFilter.model.ProdCat1.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdCat1.length;
          index++
        ) {
          let filter = [
            "ProductCategory1Code",
            "=",
            this.advanceFilter.model.ProdCat1[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdCat1.length - 1) {
            afilter.push("or");
          }
        }
        createFilter.push(afilter);
      }

      if (this.advanceFilter.model.ProdCat2.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdCat2.length;
          index++
        ) {
          let filter = [
            "ProductCategory2Code",
            "=",
            this.advanceFilter.model.ProdCat2[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdCat2.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (this.advanceFilter.model.ProdCat3.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdCat3.length;
          index++
        ) {
          let filter = [
            "ProductCategory3Code",
            "=",
            this.advanceFilter.model.ProdCat3[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdCat3.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (this.advanceFilter.model.ProdCat4.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdCat4.length;
          index++
        ) {
          let filter = [
            "ProductCategory4Code",
            "=",
            this.advanceFilter.model.ProdCat4[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdCat4.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      if (this.advanceFilter.model.ProdType.length != 0) {
        let afilter = [];
        for (
          let index = 0;
          index < this.advanceFilter.model.ProdType.length;
          index++
        ) {
          let filter = [
            "ProductTypeCode",
            "=",
            this.advanceFilter.model.ProdType[index],
          ];
          afilter.push(filter);
          if (index != this.advanceFilter.model.ProdType.length - 1) {
            afilter.push("or");
          }
        }

        if (createFilter.length > 0) {
          createFilter.push("and");
          createFilter.push(afilter);
        } else {
          createFilter.push(afilter);
        }
      }

      // #28000 : Searching freezes when using the search feature for products
      if (this.soDetailsCurrentView == "Review") {
        this.defaultFilters.default = this.defaultFilters.reviewListViewFilter;
      } else if (this.soDetailsCurrentView == "ProductList") {
        this.defaultFilters.default = this.defaultFilters.productListViewFilter;
      } else if (this.soDetailsCurrentView == "CustomerList") {
        this.defaultFilters.default = this.defaultFilters.customerListViewFilter;
      } else if (this.soDetailsCurrentView == "GridList") {
        this.defaultFilters.default = this.defaultFilters.gridListViewFilter;
      }

      if (createFilter.length == 0) {
        if (this.defaultFilters.default.length > 0) {
          this.getCurrentSoDetailsDataSource().filter(
            this.defaultFilters.default
          );
        } else {
          // #28000 : Searching freezes when using the search feature for products
          if (this.soDetailsCurrentView == "GridList") {
            this.defaultFilters.default = this.defaultFilters.gridListViewFilter;
            this.getCurrentSoDetailsDataSource().filter(
              this.defaultFilters.default
            );
          } else {
            this.getCurrentSoDetailsDataSource().filter(null);
          }
        }
        this.defaultFilters.setCustomFilter = [];
      } else {
        var filter = [];
        if (this.defaultFilters.default.length > 0) {
          filter.push(this.defaultFilters.default);
          filter.push("and");
        }
        filter.push(createFilter);
        this.defaultFilters.setCustomFilter = createFilter;

        if (this.soDetailsCurrentView == "GridList") {
          this.soDetailsGridListDataSource.filter(filter);
        } else {
          this.getCurrentSoDetailsDataSource().filter(filter);
        }
      }
      if (this.soDetailsCurrentView == "GridList") {
        this.loadGridListViewDataSource();
      }
      // else {
      //   this.getCurrentSoDetailsDataSource().load();
      // }

      this.refreshView();
    },
    updateGridFilterDatasource(filterValue) {
      this.gridListViewFilterConfig = this.getGridListViewFilterConfig(
        filterValue
      );
    },
    repaintSoDetailsGrid() {
      let grid = this.$refs[this.soDetailsGridRefName];
      if (grid) grid.instance.repaint();
    },
    getGridListViewFilterConfig(filterValue) {
      let url = "",
        placeholder = "Select",
        entity = "",
        entityKeyField = "";

      switch (filterValue) {
        case "PC1":
          placeholder = "Product Category 1";
          url = "api/ProductCategory1";
          entity = "ProductCategory1";
          entityKeyField = "ProductCategory1Code";
          break;

        case "PC2":
          placeholder = "Product Category 2";
          url = "api/ProductCategory2";
          entity = "ProductCategory2";
          entityKeyField = "ProductCategory2Code";
          break;

        case "PC3":
          placeholder = "Product Category 3";
          url = "api/ProductCategory3";
          entity = "ProductCategory3";
          entityKeyField = "ProductCategory3Code";
          break;

        case "PC4":
          placeholder = "Product Category 4";
          url = "api/ProductCategory4";
          entity = "ProductCategory4";
          entityKeyField = "ProductCategory4Code";
          break;

        case "PT":
          placeholder = "Product Type";
          url = "api/ProductType";
          entity = "ProductType";
          entityKeyField = "ProductTypeCode";
          break;

        default:
          break;
      }

      let dataSource = ApiService.createDataSource(url, {
        sort: [{ selector: "Description", asc: true }],
        select: ["Description", "Code"],
        filter: ["Inactive", "=", "N"],
      });

      return {
        dataSource: dataSource,
        placeholder: placeholder,
        entity: entity,
        entityKeyField: entityKeyField,
      };
    },
    applyFocusClass(inputEl) {
      document
        .querySelector(".dx-datagrid")
        .querySelectorAll("div.gc-grid-number-box-editor")
        .forEach((el) => el.parentNode.classList.remove("key-pad-focused"));
      if (inputEl.closest("div.gc-grid-number-box-editor")) {
        inputEl
          .closest("div.gc-grid-number-box-editor")
          .parentNode.classList.add("key-pad-focused");
      }
    },
    clearFocusedCell() {
      if (this.soDetailsCurrentView == "GridList") {
        this.getCurrentSoDetailsDataSource()
          .items()
          .forEach((element) => {
            for (var i = 0; i <= 20; i++) {
              element[`Size${i}QtyFocused`] = false;
            }
          });
      } else {
        this.getCurrentSoDetailsDataSource()
          .items()
          .forEach((element) => {
            element.SalesUMQtyFocused = false;
          });
      }

      focusedQtyCellInfo = null;
    },
    async reApplyFocus() {
      if (cellInfoData)
        var index = soDetailsGridInstance
          .getDataSource()
          .items()
          .findIndex((x) => x.CopyCode == cellInfoData.CopyCode);
      soDetailsGridInstance.focus(
        soDetailsGridInstance.getCellElement(
          index > -1 ? index : currentRowIndex,
          currentColumnIndex
        )
      );
    },
    async onSoDetailsViewSalesUMFocused() {
      if (this.isTablet) {
        this.clearFocusedCell();
      }
    },
    async onSoDetailsViewQtyFocused(e, cellInfo) {
      cellInfoData = cellInfo;
      if (this.isTablet) {
        let getIndex = this.getCurrentSoDetailsDataSource()
          .items()
          .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);
        cellInfo.rowIndex = getIndex;

        if (this.updatePendingForPreviousFocusedCell(cellInfo)) {
          this.onSoDetailsViewQtyChanged(
            { value: this.numericValue },
            focusedQtyCellInfo.cellInfo,
            true
          );
        }

        cellInfo.previousValue = e.component._parsedValue;

        this.clearFocusedCell();
        focusedQtyCellInfo = {
          rowIndex: getIndex,
          dataField: cellInfo.column.dataField,
          component: e.component,
          cellInfo: cellInfo,
          requestSent: false,
        };
        e.component.blur();
        let inputEl = e.element.querySelector(".dx-texteditor-input");
        this.showNumericKeyPad();

        this.applyFocusClass(inputEl);

        this.updateDataSource(
          this.getCurrentSoDetailsDataSource(),
          getIndex,
          "SalesUMQtyFocused",
          true
        );

        focusedQtyCellInfo.inputEl = inputEl;
        // Does not work on IPAD
        // inputEl.selectionStart = 0;
        // inputEl.selectionEnd = inputEl.value.length;

        await this.$store.dispatch("numericInputStore/setFieldFocused", false);
        this.$store.dispatch("numericInputStore/keyPadFocusChanged");
        this.$store.dispatch("numericInputStore/updateRecord", {
          itemCode: cellInfo.data.ItemCode,
          value: e.component._parsedValue,
        });
      }
    },
    updatePendingForGridViewPreviousFocusedCell(cellInfo) {
      return (
        focusedQtyCellInfo && // there is a focused cell already
        (focusedQtyCellInfo.rowIndex !== cellInfo.rowIndex || // assert changing focus from a different cell
          (focusedQtyCellInfo.rowIndex == cellInfo.rowIndex &&
            focusedQtyCellInfo.columnIndex !== cellInfo.columnIndex)) && // assert changing focus from a different cell in the same row
        !focusedQtyCellInfo.requestSent && // price api lookup for qty changed is not triggered yet
        focusedQtyCellInfo.cellInfo.value !== this.numericValue // check whether there actually is a quantity change done by the user
      );
    },
    updatePendingForPreviousFocusedCell(cellInfo) {
      return (
        focusedQtyCellInfo && // there is a focused cell already
        focusedQtyCellInfo.rowIndex !== cellInfo.rowIndex && // assert changing focus from a different cell
        !focusedQtyCellInfo.requestSent && // price api lookup for qty changed is not triggered yet
        focusedQtyCellInfo.cellInfo.value !== this.numericValue // check whether there actually is a quantity change done by the user
      );
    },
    async onGridListViewSizeQtyFocused(e, cellInfo) {
      if (this.isTablet) {
        if (this.updatePendingForGridViewPreviousFocusedCell(cellInfo)) {
          this.onGridListViewSizeQtyChanged(
            { value: this.numericValue },
            focusedQtyCellInfo.cellInfo,
            true
          );
        }

        // this.$logger.debug("focusInEventArg", e, "cellInfo", cellInfo);
        this.clearFocusedCell();
        currentRowIndex = cellInfo.rowIndex;
        currentColumnIndex = cellInfo.columnIndex;

        cellInfo.previousValue = e.component._parsedValue;

        focusedQtyCellInfo = {
          rowIndex: cellInfo.rowIndex,
          columnIndex: cellInfo.columnIndex,
          dataField: cellInfo.column.dataField,
          component: e.component,
          cellInfo: cellInfo,
        };

        e.component.blur();
        let inputEl = e.element.querySelector(".dx-texteditor-input");
        this.showNumericKeyPad();

        this.applyFocusClass(inputEl);

        this.updateDataSource(
          this.getCurrentSoDetailsDataSource(),
          currentRowIndex,
          cellInfo.column.dataField + "Focused",
          true
        );

        focusedQtyCellInfo.inputEl = inputEl;
        // Does not work on IPAD
        // inputEl.selectionStart = 0;
        // inputEl.selectionEnd = inputEl.value.length;

        await this.$store.dispatch("numericInputStore/setFieldFocused", false);
        this.$store.dispatch("numericInputStore/keyPadFocusChanged");

        this.$store.dispatch("numericInputStore/updateRecord", {
          itemCode: cellInfo.data.ItemCode,
          value: e.component._parsedValue,
        });
      }
    },
    onGridListViewSizeQtyChanged(
      valueChangedEventArg,
      cellInfo,
      debouncEnabled
    ) {
      let prevSalesUMQty = valueChangedEventArg.previousValue;
      let salesUMQty = valueChangedEventArg.value;

      if (this.isTablet && focusedQtyCellInfo) {
        this.$logger.debug(
          "focusedQtyCellInfo.cellInfo",
          focusedQtyCellInfo.cellInfo
        );
        prevSalesUMQty = focusedQtyCellInfo.cellInfo.previousValue;
        focusedQtyCellInfo.requestSent = true;
      }
      if (!debouncEnabled) cellInfo.setValue(valueChangedEventArg.value);

      let currentRowIndex = cellInfo.rowIndex;

      this.mergeFromOrderGrid(
        currentRowIndex,
        cellInfo,
        prevSalesUMQty,
        salesUMQty
      );
    },
    async tryProcessSalesContracts(
      valueChangedEventArg,
      cellInfo,
      currentRowIndex
    ) {
      if (!this.SalesContractDrawdownEnabled) return null;

      let record = this.getCurrentSoDetailsDataSource().items()[
        currentRowIndex
      ];

      let newSalesUM, oldSalesUM, newSalesUMQty, oldSalesUMQty;

      if (cellInfo.column.dataField == "SalesUM") {
        newSalesUM = valueChangedEventArg.value;
        oldSalesUM = cellInfo.displayValue;
        newSalesUMQty = record.SalesUMQty;
        oldSalesUMQty = record.SalesUMQty;
      } else if (cellInfo.column.dataField == "SalesUMQty") {
        newSalesUM = record.SalesUM;
        oldSalesUM = record.SalesUM;
        newSalesUMQty = valueChangedEventArg.value;
        oldSalesUMQty = cellInfo.displayValue;
      }

      // this.$logger.debug(
      //   `NewSalesUM: ${newSalesUM} Record SalesUM: ${oldSalesUM}`,
      //   cellInfo
      // );
      var existingContractLineUsages = this.salesOrderDetailsReviewList
        .items()
        .filter(
          (detail) =>
            detail.CustomerSalesContractCode !== null &&
            detail.CustomerSalesContractLineNo !== null
        )
        .map((detail) => ({
          CustomerSalesContractCode: detail.CustomerSalesContractCode,
          CustomerSalesContractLineNo: detail.CustomerSalesContractLineNo,
          LineNo: detail.LineNo,
          ItemCode: detail.ItemCode,
        }));

      var customerContractItemsForProduct = this.CustomerSalesContracts.drawProduct(
        record.LineNo,
        record.ItemCode,
        oldSalesUMQty,
        newSalesUMQty,
        oldSalesUM,
        newSalesUM,
        record.CustomerSalesContractCode,
        record.CustomerSalesContractLineNo,
        existingContractLineUsages
      );

      if (customerContractItemsForProduct !== null) {
        customerContractItemsForProduct.Proceed = true;

        if (
          customerContractItemsForProduct.CustomerSalesContractCode == 0 &&
          customerContractItemsForProduct.CustomerSalesContractLineNo == 0 &&
          customerContractItemsForProduct.SalesContractItem == null
        ) {
          customerContractItemsForProduct.CustomerSalesContractCode = null;
          customerContractItemsForProduct.CustomerSalesContractLineNo = null;

          let confirmTitle, confirmMessage;

          if (
            customerContractItemsForProduct.MessageType &&
            customerContractItemsForProduct.MessageType !== ""
          ) {
            if (
              customerContractItemsForProduct.MessageType == "SalesUMChanged"
            ) {
              confirmTitle = "Confirmation";
              confirmMessage = `Contract could not be associated for the UM ${newSalesUM}. Do you want to proceed anyway?`;
            } else {
              confirmTitle = "Insufficient Quantity";
              let cont = "";
              if (
                record.CustomerSalesContractCode &&
                record.CustomerSalesContractCode != 0
              ) {
                cont = `(${record.CustomerSalesContractCode}) `;
              } else if (
                customerContractItemsForProduct.FailedCustomerSalesContractCode
              ) {
                cont = `(${customerContractItemsForProduct.FailedCustomerSalesContractCode}) `;
              }

              confirmMessage = `There is insufficient quantity available on the associated contract ${cont}and the product ${record.ItemCode} will not be allocated.`;
            }

            // let confirmContractAssociation =
            await alert(confirmMessage, confirmTitle);
            customerContractItemsForProduct.Proceed = false;

            //   if (confirmContractAssociation) {
            //     // removing an existing association due to quantity being insufficient
            //     if (
            //       record.CustomerSalesContractCode != null &&
            //       record.CustomerSalesContractLineNo !== null
            //     ) {
            //       return customerContractItemsForProduct;
            //     }
            //   } else {
            //     customerContractItemsForProduct.Proceed = false;
            return customerContractItemsForProduct;
            //  }
          } else {
            return customerContractItemsForProduct;
          }
        } else {
          return customerContractItemsForProduct;
        }
      }

      return null;
    },
    async onSoDetailsSalesUMChanged(valueChangedEventArg, cellInfo) {
      let rowIndex = this.getCurrentSoDetailsDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);
      currentRowIndex = soDetailsGridInstance
        .getDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);

      let newSalesUM = valueChangedEventArg.value;

      let contractItemModel = false;

      if (
        FeatureStorage.checkPermission(
          "CustomerSalesContract",
          this.baseView.mode
        )
      ) {
        contractItemModel = await this.tryProcessSalesContracts(
          valueChangedEventArg,
          cellInfo,
          rowIndex
        );
      }

      this.updateDataSource(
        this.getCurrentSoDetailsDataSource(),
        rowIndex,
        cellInfo.column.dataField,
        newSalesUM
      );

      if (this.isTablet && focusedQtyCellInfo)
        focusedQtyCellInfo.requestSent = true;

      let record = this.getCurrentSoDetailsDataSource().items()[rowIndex];

      this.showLoading(true);
      cellInfo.setValue(newSalesUM); // Updates the cell value
      await SalesOrderService.setSaleItemPrice(
        // Non Grid List
        record,
        this.model.SalesOrderTypeCode,
        this.model.BranchCode,
        this.model.CustomerCode,
        this.model.ExchangeRate,
        this.model.DateIn,
        this.model.RequiredByDate,
        false
      ).then(async (res) => {
        if (contractItemModel && contractItemModel.Proceed == true) {
          this.updateSalesOrderDetailsRecord(record, contractItemModel);
        }

        this.$logger.debug("setSaleItemPrice: " + JSON.stringify(res));
        this.mergeItemWithReviewList(record);
        this.$logger.debug(
          "qtyZeroToNotZeroNotACopiedLine" + this.soDetailsCurrentView
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "SalesUMFXPrice",
          record.SalesUMFXPrice
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "DiscPcnt",
          record.DiscPcnt
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "SalesUMNetFXPrice",
          record.SalesUMNetFXPrice
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "FXLineTotal",
          record.FXLineTotal
        );

        this.showLoading(false);
      });
    },

    async onSoDetailsViewQtyChangedDebounced(
      valueChangedEventArg,
      cellInfo,
      debouncEnabled
    ) {
      debouncer(() => {
        this.onSoDetailsViewQtyChanged(
          valueChangedEventArg,
          cellInfo,
          debouncEnabled
        );
      });
    },
    async onSoDetailsViewQtyChanged(
      valueChangedEventArg,
      cellInfo,
      debouncEnabled
    ) {
      this.$logger.debug(
        "onSoDetailsViewQtyChanged valueChangedEventArg",
        valueChangedEventArg
      );
      this.$logger.debug(
        "onSoDetailsViewQtyChanged cellInfo",
        valueChangedEventArg
      );
      this.$logger.debug(
        "onSoDetailsViewQtyChanged debouncEnabled",
        debouncEnabled
      );

      // currentRowIndex = cellInfo.rowIndex;

      let rowIndex = this.getCurrentSoDetailsDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);
      currentRowIndex = soDetailsGridInstance
        .getDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);

      let prevSalesUMQty = valueChangedEventArg.previousValue;
      let newSalesUMQty = valueChangedEventArg.value;

      let contractItemModel = false;

      if (
        FeatureStorage.checkPermission(
          "CustomerSalesContract",
          this.baseView.mode
        )
      ) {
        contractItemModel = await this.tryProcessSalesContracts(
          valueChangedEventArg,
          cellInfo,
          rowIndex
        );
      }

      if (contractItemModel && contractItemModel.Proceed == false) {
        newSalesUMQty = 0;
      }

      if (!debouncEnabled) {
        cellInfo.setValue(newSalesUMQty);

        this.updateDataSource(
          this.getCurrentSoDetailsDataSource(),
          rowIndex,
          cellInfo.column.dataField,
          newSalesUMQty
        );
      }

      if (this.isTablet && focusedQtyCellInfo) {
        this.$logger.debug(
          "onSoDetailsViewQtyChanged  focusedQtyCellInfo.cellInfo",
          focusedQtyCellInfo.cellInfo
        );
        prevSalesUMQty = focusedQtyCellInfo.cellInfo.previousValue;
        focusedQtyCellInfo.requestSent = true;
      }

      let record = this.getCurrentSoDetailsDataSource().items()[rowIndex];

      // #27699: Qty Edit Changes
      // WHEN Quantity goes from zero to non-zero AND the line is not a copied line THEN
      // - Perform Price Lookup
      // - Update all fields as it does now

      let qtyZeroToNotZeroNotACopiedLine =
        prevSalesUMQty == 0 && newSalesUMQty != 0 && !record.copiedLine;
      let qtyZeroToNonZeroOnCopiedLine =
        prevSalesUMQty == 0 && newSalesUMQty != 0 && record.copiedLine;
      let qtyNonZeroToNonZeroNotCopiedLine =
        prevSalesUMQty != 0 && newSalesUMQty != 0 && !record.copiedLine;
      let qtyNonZeroToNonZeroCopiedLine =
        prevSalesUMQty != 0 && newSalesUMQty != 0 && record.copiedLine;

      if (qtyZeroToNotZeroNotACopiedLine || qtyNonZeroToNonZeroNotCopiedLine) {
        this.showLoading(true);
        cellInfo.setValue(newSalesUMQty); // Updates the cell value
        await SalesOrderService.setSaleItemPrice(
          // Non Grid List
          record,
          this.model.SalesOrderTypeCode,
          this.model.BranchCode,
          this.model.CustomerCode,
          this.model.ExchangeRate,
          this.model.DateIn,
          this.model.RequiredByDate,
          false
        ).then(async (res) => {
          if (contractItemModel && contractItemModel.Proceed == true) {
            this.updateSalesOrderDetailsRecord(record, contractItemModel);
          }

          this.$logger.debug("setSaleItemPrice: " + JSON.stringify(res));
          // cellInfo.setValue(newSalesUMQty); // Updates the cell value
          this.mergeItemWithReviewList(record);
          this.$logger.debug(
            "qtyZeroToNotZeroNotACopiedLine || qtyNonZeroToNonZeroNotCopiedLine" +
              this.soDetailsCurrentView
          );

          soDetailsGridInstance.cellValue(
            currentRowIndex,
            "SalesUMFXPrice",
            record.SalesUMFXPrice
          );

          soDetailsGridInstance.cellValue(
            currentRowIndex,
            "DiscPcnt",
            record.DiscPcnt
          );

          soDetailsGridInstance.cellValue(
            currentRowIndex,
            "SalesUMNetFXPrice",
            record.SalesUMNetFXPrice
          );

          soDetailsGridInstance.cellValue(
            currentRowIndex,
            "FXLineTotal",
            record.FXLineTotal
          );

          soDetailsGridInstance.cellValue(
            currentRowIndex,
            "TaxableFXLineTotal",
            record.TaxableFXLineTotal
          );

          this.showLoading(false);
        });
      }

      // WHEN Quantity goes from zero to non-zero AND the line is a copied line THEN OR  WHEN Quantity goes from non-zero to non-zero THEN
      // - Do not perform Price Lookup
      // - Update Net and Totals based on price & discount in screen
      else if (qtyZeroToNonZeroOnCopiedLine || qtyNonZeroToNonZeroCopiedLine) {
        cellInfo.setValue(newSalesUMQty); // Updates the cell value
        this.mergeItemWithReviewList(record);

        if (qtyZeroToNonZeroOnCopiedLine) {
          this.$logger.debug(
            "qtyZeroToNonZeroOnCopiedLine: " + this.soDetailsCurrentView
          );
        } else {
          this.$logger.debug(
            "qtyNonZeroToNonZeroCopiedLine: " + this.soDetailsCurrentView
          );
        }

        if (contractItemModel && contractItemModel.Proceed == true) {
          this.updateSalesOrderDetailsRecord(record, contractItemModel);
        }

        this.setStockPrices(record);
        this.setLineTotals(record);

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "SalesUMFXPrice",
          record.SalesUMFXPrice
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "DiscPcnt",
          record.DiscPcnt
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "SalesUMNetFXPrice",
          record.SalesUMNetFXPrice
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "FXLineTotal",
          record.FXLineTotal
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "TaxableFXLineTotal",
          record.TaxableFXLineTotal
        );
      }
      // else {
      // WHEN Quantity goes from non-zero to zero THEN
      // - Price is 0
      // - Discount is 0
      // - Net is 0
      // - Update all other necessary fields

      // remove a qty line when zero
      if (newSalesUMQty === 0) {
        this.$logger.debug("qtyNonZeroToZero: " + this.soDetailsCurrentView);

        cellInfo.setValue(newSalesUMQty);

        record.SalesUMFXPrice = 0;
        record.SalesUMNetFXPrice = 0;
        record.SalesUMPrice = 0;
        record.DiscPcnt = 0;
        record.SalesUMNetPrice = 0;

        this.setStockPrices(record);
        this.setLineTotals(record);

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "SalesUMFXPrice",
          record.SalesUMFXPrice
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "DiscPcnt",
          record.DiscPcnt
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "SalesUMNetFXPrice",
          record.SalesUMNetFXPrice
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "FXLineTotal",
          record.FXLineTotal
        );

        soDetailsGridInstance.cellValue(
          currentRowIndex,
          "TaxableFXLineTotal",
          record.TaxableFXLineTotal
        );

        var itemIndex = undefined;
        soDetailsReviewListDataSource.items().forEach((element, index) => {
          if (element.CopyCode == cellInfo.data.CopyCode) {
            itemIndex = index;
          }
        });

        if (itemIndex != undefined) {
          soDetailsReviewListDataSource.items().splice(itemIndex, 1);
          return;
        }
      }
      // }
      // eslint-disable-next-line no-console
      console.log(record.TaxableFXLineTotal, "Line  total");
    },
    onSoDetailsDiscountChanged(valueChangedEventArg, cellInfo) {
      let prevDiscPcnt = valueChangedEventArg.previousValue;
      let newDiscPcnt = valueChangedEventArg.value;

      let priceRowIndex = this.getCurrentSoDetailsDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);
      let priceRowIndex2 = soDetailsGridInstance
        .getDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);

      this.updateDataSource(
        this.getCurrentSoDetailsDataSource(),
        priceRowIndex,
        cellInfo.column.dataField,
        prevDiscPcnt
      );

      let record = this.getCurrentSoDetailsDataSource().items()[priceRowIndex];

      if (record.SalesUMQty == 0) {
        this.updateDataSource(
          this.getCurrentSoDetailsDataSource(),
          priceRowIndex,
          cellInfo.column.dataField,
          prevDiscPcnt
        );

        return;
      }

      let newsalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      let tempGp = calculateGrossProfitPcnt(
        record.SalesUMStandardCost,
        newsalesUMNetPrice
      );

      let globalGPVal = this.getFactorByCode(571).FactorInt;

      if (tempGp < globalGPVal) {
        if (record.SalesUMQty != 0) {
          this.displayValidationSummary([]);
          this.addErrorMessage(
            `Net Price is below the minimum GP of ${globalGPVal.roundNumber(2) +
              " %"}. Please enter a discount that meets the minimum GP % requirement.`
          );
          this.displayValidationSummary();
        }

        this.updateDataSource(
          this.getCurrentSoDetailsDataSource(),
          priceRowIndex,
          cellInfo.column.dataField,
          prevDiscPcnt
        );
      } else {
        record.DiscPcnt = newDiscPcnt;

        record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
          record.SalesUMFXPrice,
          record.DiscPcnt
        );
        this.setBaseCurrencyPriceFromFXPrice(record);

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "SalesUMFXPrice",
          record.SalesUMFXPrice
        );

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "DiscPcnt",
          record.DiscPcnt
        );

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "SalesUMNetFXPrice",
          record.SalesUMNetFXPrice
        );

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "FXLineTotal",
          record.FXLineTotal
        );
      }
    },
    onSoDetailsPriceChanged(valueChangedEventArg, cellInfo) {
      let prevSalesUMFXPrice = valueChangedEventArg.previousValue;
      let newsalesUMFXPrice = valueChangedEventArg.value;

      let priceRowIndex = this.getCurrentSoDetailsDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);
      let priceRowIndex2 = soDetailsGridInstance
        .getDataSource()
        .items()
        .findIndex((x) => x.CopyCode == cellInfo.data.CopyCode);

      this.updateDataSource(
        this.getCurrentSoDetailsDataSource(),
        priceRowIndex,
        cellInfo.column.dataField,
        prevSalesUMFXPrice
      );

      let record = this.getCurrentSoDetailsDataSource().items()[priceRowIndex];

      if (record.SalesUMQty == 0) {
        this.updateDataSource(
          this.getCurrentSoDetailsDataSource(),
          priceRowIndex,
          cellInfo.column.dataField,
          prevSalesUMFXPrice
        );
        return;
      }

      // eslint-disable-next-line no-unused-vars
      let newsalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        newsalesUMFXPrice,
        this.model.ExchangeRate
      );

      let newSalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        newsalesUMFXPrice,
        record.DiscPcnt
      );

      let newsalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        newSalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      let tempGp = calculateGrossProfitPcnt(
        record.SalesUMStandardCost,
        newsalesUMNetPrice
      );
      let globalGPVal = this.getFactorByCode(571).FactorInt;

      if (tempGp < globalGPVal) {
        this.displayValidationSummary([]);
        this.addErrorMessage(
          `Net Price is below the minimum GP of ${globalGPVal.roundNumber(2) +
            " %"}. Please enter a price that meets the minimum GP % requirement.`
        );
        this.displayValidationSummary();

        this.updateDataSource(
          this.getCurrentSoDetailsDataSource(),
          priceRowIndex,
          cellInfo.column.dataField,
          prevSalesUMFXPrice
        );
      } else {
        record.SalesUMFXPrice = newsalesUMFXPrice;
        record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
          newsalesUMFXPrice,
          record.DiscPcnt
        );
        this.setBaseCurrencyPriceFromFXPrice(record);

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "SalesUMFXPrice",
          record.SalesUMFXPrice
        );

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "DiscPcnt",
          record.DiscPcnt
        );

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "SalesUMNetFXPrice",
          record.SalesUMNetFXPrice
        );

        soDetailsGridInstance.cellValue(
          priceRowIndex2,
          "FXLineTotal",
          record.FXLineTotal
        );
      }
    },
    updateSalesOrderDetailsRecord(record, customerContractItemsForProduct) {
      this.$logger.debug(
        "DrawProduct: UpdateSalesOrderDetailsRecord",
        customerContractItemsForProduct
      );
      record.CustomerSalesContractCode =
        customerContractItemsForProduct.CustomerSalesContractCode;

      record.CustomerSalesContractLineNo =
        customerContractItemsForProduct.CustomerSalesContractLineNo;

      if (
        customerContractItemsForProduct.SalesContractItem &&
        customerContractItemsForProduct.SalesContractItem.UseMarket === "N"
      ) {
        record.SalesUMFXPrice =
          customerContractItemsForProduct.SalesContractItem.DefaultPrice;

        // apply freight
        if (
          customerContractItemsForProduct.SalesContractItem.ApplyFreight == "Y"
        ) {
          record.SalesUMFXPrice += this.getFreightCharge(record.SalesUM);
        }

        record.SalesUMNetFXPrice = calculateSalesUMNetFXPriceFromSalesUMFXPrice(
          record.SalesUMFXPrice,
          record.DiscPcnt
        );

        this.setBaseCurrencyPriceFromFXPrice(record);
      }
    },
    getFreightCharge(salesUM) {
      let item = this.freightCharges.find(
        (x) => x.UnitOfMeasureCode.toUpperCase() == salesUM.toUpperCase()
      );

      if (item) {
        // eslint-disable-next-line no-console
        // console.log("Freight", item.FreightCharge, salesUM);
        return item.FreightCharge;
      } else return 0;
    },

    setBaseCurrencyPriceFromFXPrice(record) {
      record.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        record.SalesUMFXPrice,
        this.model.ExchangeRate
      );

      record.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
        record.SalesUMStandardPrice,
        record.SalesUMPrice
      );

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      this.setStockPrices(record);
      this.setLineTotals(record);
    },
    setStockPrices(record) {
      record.StockUMQty = calculateStockUMQty(
        record.SalesUMQty,
        record.SalesUMConversion
      );

      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMConversion
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMConversion
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMConversion
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMConversion
      );
    },
    setLineTotals(record) {
      // FX Totals
      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.NetFXLineTotal = calculateNetFXLineTotal(
        record.SalesUMNetFXPrice,
        record.SalesUMQty,
        record.SalesUMFXPrice, // Updating this to support new changes in the formulars.
      );
      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt
      );

      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal
      );
      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt
      );
      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal
      );

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        this.model.ExchangeRate
      );
      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        this.model.ExchangeRate
      );
      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        this.model.ExchangeRate
      );
      record.LineTotal = calculateLineTotal(
        record.FXLineTotal,
        this.model.ExchangeRate
      );
      // window.ViewModel.calculateComputedFields();
    },
    setCompanyCurrencyPriceAllLines() {
      for (var i = 0; i < soDetailsReviewListDataSource.items().length; i++) {
        var record = soDetailsReviewListDataSource.items()[i];
        this.setBaseCurrencyPriceFromFXPrice(record);
      }
    },
    async handleLocalRouteChange() {
      setTimeout(() => {
        this.setTabSelection();
      }, 100);
    },
    async populateFreightCharges(customerCode, deliveryCode) {
      let ds = CustomerFreightChargeService.dataSourceConfig(
        "api/CustomerSalesContractFreightCharge",
        {
          filter: [
            ["CustomerCode", "=", customerCode],
            "and",
            ["DeliveryCode", "=", parseInt(deliveryCode)],
          ],
        }
      );
      this.freightCharges = await ds.load();
      this.$logger.debug("Freight charges Loaded", this.freightCharges);
    },
    async intialize() {
      this.dataLoaded = false;
      this.model.CustomerName = undefined;
      this.SalesContractDrawdownEnabled = false;
      this.showLoading(true);
      let that = this;

      this.updateSoDetailsGridColumns();

      if (this.soDetailsGrid) this.soDetailsGrid.clearFilter("search");
      let productSizeResult = await productSizeDataSource.load();

      productSizeResult.forEach((ps) => {
        productSizes[ps.Sequence] = ps.Code;
      });

      this.loadSizeTotalColumns(productSizeResult);

      // this.$logger.debug("productSizeDataSource result", productSizeResult);

      await this.$store.dispatch("screenFactors/getFactors", [
        616,
        549,
        550,
        505,
        95,
        87,
        565,
        571,
        655,
        643,
        368,
        639,
        578,
        95,
      ]);

      let factor655 = this.getFactorByCode(655).Factorc;
      this.updateGridFilterDatasource(factor655);

      this.factor368 = this.getFactorByCode(368).Factorc;

      if (this.baseView.mode !== "create") {
        this.model.Code = this.baseView.id;

        let resSoConsumption = await CustomerSalesContractService.getCustomerSalesContractSalesOrderConsumptionBySalesOrder(
          +this.model.Code
        );

        if (resSoConsumption.data.value.length > 0) {
          // enable Drawdown only if there is existing drawdowns against the SO
          this.SalesContractDrawdownEnabled = true;
        }

        let response = await this.getRecord();
        if (response.data.value.length > 0) {
          if (
            response.data.value[0].Status == "D" &&
            this.baseView.mode !== "edit"
          ) {
            // force push screen to edit mode when the Sales Order is in Draft mode
            this.$router.push({
              path: `/sales-order-old/edit/${this.model.Code}/${
                this.selectedIndex == 0 ? "header" : "details"
              }`,
            });
            screenModeChanged = true;
            this.refreshView();
          }

          this.model.BranchCode = response.data.value[0].BranchCode;
          this.model.BranchName = response.data.value[0].Branch.Description;
          this.model.ChangedBy = response.data.value[0].ChangedBy;
          this.model.CurrencyCode = response.data.value[0].CurrencyCode;
          this.model.CustomerDeliveryAddressLineNo =
            response.data.value[0].CustomerDeliveryAddressLineNo;
          this.model.DateChanged = response.data.value[0].DateChanged;
          this.model.DateCreated = response.data.value[0].DateCreated;

          this.model.Code = response.data.value[0].Code;
          this.model.CompanyCode = response.data.value[0].CompanyCode;
          this.model.CreatedBy = response.data.value[0].CreatedBy;
          this.model.CustomerCode = response.data.value[0].CustomerCode;
          this.model.DateIn = new Date(response.data.value[0].DateIn);
          this.model.DeliveryAddressCompanyName =
            response.data.value[0].DeliveryAddressCompanyName;
          this.model.DeliveryAddressCountry =
            response.data.value[0].DeliveryAddressCountry;
          this.model.DeliveryAddressPostcode =
            response.data.value[0].DeliveryAddressPostcode;
          this.model.DeliveryAddressState =
            response.data.value[0].DeliveryAddressState;
          this.model.DeliveryAddressStreetLine1 =
            response.data.value[0].DeliveryAddressStreetLine1;
          this.model.DeliveryAddressStreetLine2 =
            response.data.value[0].DeliveryAddressStreetLine2;
          this.model.DeliveryAddressSuburb =
            response.data.value[0].DeliveryAddressSuburb;
          this.model.DivisionCode = response.data.value[0].DivisionCode;
          this.model.DivisionName = response.data.value[0].Division.Description;

          this.model.IsLockedForPicking =
            response.data.value[0].IsLockedForPicking;
          this.model.OrderNo = response.data.value[0].OrderNo;
          // this.model.Currency = response.data.value[0].Currency;
          // this.model.BuyRate = response.data.value[0].BuyRate;
          this.model.ConsignmentNo = response.data.value[0].ConsignmentNo;

          this.model.RequiredByDate = response.data.value[0].RequiredByDate
            ? new Date(response.data.value[0].RequiredByDate)
            : null;
          this.model.SalesOrderTypeCode =
            response.data.value[0].SalesOrderTypeCode;
          this.model.SalesOrderTypeName =
            response.data.value[0].SalesOrderType.Description;
          this.model.SalesRepresentativeCode =
            response.data.value[0].SalesRepresentativeCode;
          this.model.SalesRepresentativeName =
            response.data.value[0].SalesRepresentative.FirstName +
            " " +
            response.data.value[0].SalesRepresentative.Surname;
          // SalesRepresentativeService.getByCode(
          //   this.model.SalesRepresentativeCode
          // ).then((response) => {
          //   if (response.data.value.length > 0) {
          //     this.model.FirstName = response.data.value[0].FirstName;
          //     this.model.Surname = response.data.value[0].Surname;
          //     this.model.SalesRepresentativeName = `${this.model.FirstName} ${this.model.Surname}`;
          //   }
          // });
          this.model.ShipDate = response.data.value[0].ShipDate
            ? new Date(response.data.value[0].ShipDate)
            : null;
          this.model.Status = response.data.value[0].Status;

          // disable 'Save Draft' menu on toolbar
          // HACK not having the menu items as computed
          this.toolbar.menu.items[0].disabled = this.model.Status !== "D";
          this.toolbar.menu.items[1].disabled = false;
          this.toolbar.menu.items[2].disabled = true;
          // this.soDetailsGrid && this.soDetailsGrid.repaint();
          // let toolbar = this.$refs["toolbar-header"].instance;
          // toolbar.repaint();

          this.model.CustomerName = response.data.value[0].Customer.Name;
          this.model.ExchangeRate = response.data.value[0].ExchangeRate;
          this.model.Name = `Sales Order # ${this.model.Code}`;
          this.model.UserComment1 = response.data.value[0].UserComment1;
          this.model.UserComment2 = response.data.value[0].UserComment2;
          this.model.UserComment3 = response.data.value[0].UserComment3;
          this.model.UserComment4 = response.data.value[0].UserComment4;
          this.model.UserComment5 = response.data.value[0].UserComment5;
          this.model.UserComment6 = response.data.value[0].UserComment6;
          this.model.UserComment7 = response.data.value[0].UserComment7;
          this.model.UserComment8 = response.data.value[0].UserComment8;
          this.model.UserComment9 = response.data.value[0].UserComment9;
          this.model.UserComment10 = response.data.value[0].UserComment10;
          this.model.UserComment11 = response.data.value[0].UserComment11;
          this.model.UserComment12 = response.data.value[0].UserComment12;
          this.model.UserComment13 = response.data.value[0].UserComment13;
          this.model.UserComment14 = response.data.value[0].UserComment14;
          this.model.UserComment15 = response.data.value[0].UserComment15;
          this.model.UserComment16 = response.data.value[0].UserComment16;
          this.model.UserComment17 = response.data.value[0].UserComment17;
          this.model.UserComment18 = response.data.value[0].UserComment18;
          this.model.UserComment19 = response.data.value[0].UserComment19;
          this.model.UserComment20 = response.data.value[0].UserComment20;
          soGlobal.model.BranchValue = this.model.BranchCode;

          // eslint-disable-next-line no-console
          // this.$logger.debug("Comments", this.model.commentOptions);
          // that.refreshView();
          let status = this.statusFreindly; // response.data.value[0].Status;
          if (
            status == "C" ||
            status == "Y" ||
            // status == "P" ||
            status == "X" ||
            status == "L"
          ) {
            this.isEditVisible = false;
          }

          deliveryAddressDataSource.filter([
            "CustomerCode",
            "=",
            this.model.CustomerCode,
          ]);
          deliveryAddressDataSource.load();
          orderNotesDataSource.filter(["SalesOrderCode", "=", this.model.Code]);
          orderNotesDataSource.load().then(() => {
            this.orderNotesDataSourceConfig = orderNotesDataSource.items();
          });

          await this.populateFreightCharges(
            this.model.CustomerCode,
            this.model.CustomerDeliveryAddressLineNo
          );

          // this.customerCodeInstance.$options.propsData.options.value = this.model.CustomerCode;
          this.loadDataSources();

          // HACK
          soGlobal.model.CustomerCode = this.model.CustomerCode;
          soGlobal.model.BranchCode = this.model.BranchCode;
          if (this.getFactorByCode(616).Factorc != "Date In") {
            soGlobal.model.FilterDate = this.model.RequiredByDate.toYYYYMMDD();
          } else {
            soGlobal.model.FilterDate = this.model.DateIn.toYYYYMMDD();
          }
          soGlobal.model.FactorcVal = this.getFactorByCode(616).Factorc;
          // EDI
          this.model.isPendingEDIOrder = false;

          await SalesOrderEDIService.getSalesOrderEDIByCode(
            this.model.Code
          ).then((res2) => {
            if (res2.data.value.length > 0) {
              this.model.isEDIOrder = true;
              if (this.model.Status == "P") {
                SalesOrderEDIService.getEDICustomerDocumentTypeByCustomerCode(
                  this.model.CustomerCode
                ).then((res3) => {
                  if (res3.data.value.length > 0) {
                    if (
                      res3.data.value.filter(
                        (a) => a.EDIDocumentTypeCode == "POA"
                      ) != null
                    ) {
                      this.model.isPendingEDIOrder = true;
                      // HACK not having the menu items as computed
                      this.toolbar.menu.items[0].disabled = true;
                      this.toolbar.menu.items[1].disabled = true;
                      this.toolbar.menu.items[2].disabled = false;
                      // let toolbar = this.$refs["toolbar-header"].instance;
                      // toolbar.repaint();

                      // let grid = this.$refs[this.soDetailsGridRefName]
                      //   .instance;
                      // grid.repaint();
                    }
                  }
                });
              }
            }
          });
          // This fixes up case sensitity issues with remote data in SelectBox
          if (that.$refs["so-header-form"])
            that.validateFormConfig(that.$refs["so-header-form"].instance);
          this.updateSoDetailsGridColumns();
          await this.getCommentSettings();
        }
        await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
          (res) => {
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
          }
        );
        this.showLoading(false);
        this.dataLoaded = true;
      } else if (this.baseView.mode == "create") {
        this.showLoading(true);

        this.soDetailsCurrentView = this.hasGridViewAccess()
          ? "GridList"
          : "CustomerList";

        this.model.DateIn = new Date();
        this.model.Status = "D";
        // HACK not having the menu items as computed
        this.toolbar.menu.items[2].disabled = true;
        this.toolbar.menu.items[3].disabled = true;

        this.model.Code = 0;
        await this.getDefaults().then(async (response) => {
          if (response.data.value.length > 0) {
            this.model.CompanyCode = response.data.value[0].CompanyCode;
            this.model.BranchCode = response.data.value[0].BranchCode;
            this.model.DivisionCode = response.data.value[0].DivisionCode;

            soGlobal.model.BranchValue = this.model.BranchCode;

            await BranchService.getByCode(
              response.data.value[0].BranchCode
            ).then((res) => {
              this.model.BranchName = res.data.value[0].Description;
            });

            await DivisionService.getByCode(
              response.data.value[0].DivisionCode
            ).then((res) => {
              this.model.DivisionName = res.data.value[0].Description;
            });

            await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
              (res) => {
                this.model.CurrencyCode = res.data.value[0].CurrencyCode;
                this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
              }
            );

            let factor549 = this.getFactorByCode(549);
            if (factor549.Factorc == "Y") {
              let factor550 = this.getFactorByCode(550);
              let requiredByLeadDays = parseInt(factor550.Factorc);
              let requiredByDate = new Date();
              requiredByDate.setDate(
                requiredByDate.getDate() + requiredByLeadDays
              );

              this.model.RequiredByDate = requiredByDate;
              if (this.getFactorByCode(616).Factorc != "Date In") {
                soGlobal.model.FilterDate = this.model.RequiredByDate.toYYYYMMDD();
              } else {
                soGlobal.model.FilterDate = this.model.DateIn.toYYYYMMDD();
              }
            }

            if (this.getFactorByCode(565).Factorc == "Y") {
              this.model.ShipDate = this.model.RequiredByDate;
            }
            if (this.getFactorByCode(565).Factorc == "N") {
              this.model.ShipDate = new Date();
            }

            // await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
            //   (response) => {
            //     if (
            //       response.data.value.length > 0 &&
            //       response.data.value[0].SalesRepresentativeCode != ""
            //     ) {
            //       this.model.SalesRepresentativeCode =
            //         response.data.value[0].SalesRepresentativeCode;
            //       this.model.SalesRepresentativeName =
            //         response.data.value[0].SalesRepresentativeFullName;
            //       this.model.FirstName = this.model.SalesRepresentativeName.split(
            //         " "
            //       )[0];
            //       this.model.Surname = this.model.SalesRepresentativeName.split(
            //         " "
            //       )[1];
            //     } else {
            //       this.model.SalesRepresentativeCode = this.getFactorByCode(
            //         95
            //       ).Factorc;
            //       SalesRepresentativeService.getByCode(
            //         this.model.SalesRepresentativeCode
            //       ).then((response2) => {
            //         if (response2.data.value.length > 0) {
            //           this.model.FirstName = response2.data.value[0].FirstName;
            //           this.model.Surname = response2.data.value[0].Surname;
            //           this.model.SalesRepresentativeName = `${this.model.FirstName} ${this.model.Surname}`;
            //         }
            //       });
            //     }
            //   }
            // );
            this.setDefaultSalesRep(undefined);

            this.model.SalesOrderTypeCode = this.getFactorByCode(87).Factorc;

            await SalesOrderTypeService.getByCode(
              this.model.SalesOrderTypeCode
            ).then((res) => {
              this.model.SalesOrderTypeName = res.data.value[0].Description;
            });

            this.loadDataSources(true);
            this.updateSoDetailsGridColumns();
            // that.refreshView();
            this.showLoading(false);
          }
          this.showLoading(false);
          this.dataLoaded = true;
        });
        await this.getCommentSettings();
      }

      // this.$logger.debug("type of this.model.Code :", typeof this.model.Code);

      this.toolbar.edit.visible = this.formsConfig.editableOption;
    },

    async setDefaultSalesRep(salesRepCode) {
      // await this.$store.dispatch("screenFactors/getFactors", [95]);

      var featureItems = FeatureStorage.getItems();
      if (featureItems[0].ApplicationUserTypeCode == "Sales") {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
          (res) => {
            this.model.SalesRepresentativeCode =
              res.data.value[0].SalesRepresentativeCode;
          }
        );
      } else if (
        featureItems[0].ApplicationUserTypeCode != "Sales" &&
        !this.model.CustomerCode
      ) {
        this.model.SalesRepresentativeCode = this.getFactorByCode(95).Factorc;
      } else if (
        featureItems[0].ApplicationUserTypeCode != "Sales" &&
        this.model.CustomerCode
      ) {
        if (salesRepCode) this.model.SalesRepresentativeCode = salesRepCode;
        else
          await CustomerService.getSalesRepForCustomer(this.model.CustomerCode)
            .then((res) => {
              if (res.data.value[0].SalesRepresentativeCode)
                this.model.SalesRepresentativeCode =
                  res.data.value[0].SalesRepresentativeCode;
              else
                this.model.SalesRepresentativeCode = this.getFactorByCode(
                  95
                ).Factorc;
            })
            .catch((err) => {
              if (err) {
                this.model.SalesRepresentativeCode = this.getFactorByCode(
                  95
                ).Factorc;
              }
            });
      } else {
        this.model.SalesRepresentativeCode = this.getFactorByCode(95).Factorc;
      }

      if (this.isTablet) {
        await SalesRepresentativeService.getByCode(
          this.model.SalesRepresentativeCode
        ).then((res) => {
          this.model.SalesRepresentativeName =
            res.data.value[0].FirstName + " " + res.data.value[0].Surname;
        });
      }
    },

    async applyGPToolValue() {
      var globalGPVal = this.getFactorByCode(571).FactorInt;
      if (
        (this.gpTool.model.gp < 0 || this.gpTool.model.gp > 100) &&
        !this.fromItemPriceUpdate
      ) {
        this.displayValidationSummary([]);
        this.addErrorMessage(`GP % value should be between 99.99 and 0.00`);
        this.displayValidationSummary();
      } else if (
        this.gpTool.model.gp < globalGPVal &&
        !this.fromItemPriceUpdate
      ) {
        this.displayValidationSummary([]);
        this.addErrorMessage(
          `Cannot save New Price below the min GP % (` +
            globalGPVal.toFixed(2) +
            `)`
        );
        this.displayValidationSummary();
      } else {
        if (!this.fromItemPriceUpdate) {
          var getIndex = this.getCurrentSoDetailsDataSource()
            .items()
            .findIndex((x) => x.CopyCode == this.gpTool.data.CopyCode);

          var getIndex1 = soDetailsGridInstance
            .getDataSource()
            .items()
            .findIndex((x) => x.CopyCode == this.gpTool.data.CopyCode);

          if (getIndex > -1) {
            soDetailsGridInstance.cellValue(
              getIndex1,
              "SalesUMNetFXPrice",
              this.gpTool.model.newSalesUMNetPrice
            );

            soDetailsGridInstance.cellValue(
              getIndex1,
              "SalesUMFXPrice",
              this.gpTool.model.newSalesUMNetPrice
            );

            this.getCurrentSoDetailsDataSource().items()[
              getIndex
            ].SalesUMFXPrice = this.gpTool.model.newSalesUMNetPrice;
            this.getCurrentSoDetailsDataSource().items()[
              getIndex
            ].SalesUMNetFXPrice = this.gpTool.model.newSalesUMNetPrice;
            this.getCurrentSoDetailsDataSource().items()[getIndex].DiscPcnt = 0;

            let newTotal =
              this.gpTool.model.newSalesUMNetPrice *
              this.getCurrentSoDetailsDataSource().items()[getIndex].SalesUMQty;

            soDetailsGridInstance.cellValue(
              getIndex1,
              "TaxableFXLineTotal",
              newTotal
            );

            this.setBaseCurrencyPriceFromFXPrice(
              this.getCurrentSoDetailsDataSource().items()[getIndex]
            );
          }
        } else {
          // var promises = [];
          // for (
          //   var i = 0;
          //   i < this.getCurrentSoDetailsDataSource().items().length;
          //   i++
          // ) {
          //   if (
          //     this.getCurrentSoDetailsDataSource().items()[i].ItemCode ==
          //     this.itemPriceUpdateData.ItemCode
          //   ) {
          // var record = this.getCurrentSoDetailsDataSource().items()[i];
          // if (record.DiscPcnt == 0) {  BACKED OUT - #27639 : Item Price Update - Save & Recalculate to Existing Sales Order Changes
          // promises.push(
          //   SalesOrderService.setSaleItemPrice(
          //     //GP TOOL
          //     record,
          //     this.model.SalesOrderTypeCode,
          //     this.model.BranchCode,
          //     this.model.CustomerCode,
          //     this.model.ExchangeRate,
          //     this.model.DateIn,
          //     new Date(this.model.RequiredByDate),
          //     false
          //   )
          // );
          // Promise.all(promises).then(function() {
          //   // this.$logger.debug("All SO details line prices are set", that.getCurrentSoDetailsDataSource().items());
          //   soDetailsGridInstance.refresh();
          //   // soDetailsGridInstance.refresh().then((e)=> {
          //   //   console.log('AAA ', e)
          //   // });
          // });
          // }
          //   }
          // }
          // }
        }

        this.gpToolPopupVisible = false;
      }
    },

    async applyBestBeforeDateValue() {
      var getIndex = await this.getCurrentSoDetailsDataSource()
        .items()
        .findIndex((x) => x.CopyCode == this.bestBeforeDate.data.CopyCode);

      if (getIndex > -1) {
        this.getCurrentSoDetailsDataSource().items()[
          getIndex
        ].BestBeforeDate = this.bestBeforeDate.model.bestBeforeDate;
      }
      // this.$logger.debug(
      //   "*********************** ",
      //   this.getCurrentSoDetailsDataSource().items()[getIndex]
      // );
      this.bestBeforeDatePopupVisible = false;
    },
    gpPrecentageChange() {
      this.gpTool.model.newSalesUMNetPrice = calculateSalesUMPriceForGP(
        this.gpTool.model.standardSell,
        this.gpTool.data.SalesUMStandardCost,
        this.gpTool.model.gp
      );
    },
    gpNewPriceChange() {
      this.gpTool.model.gp =
        this.gpTool.model.newSalesUMNetPrice == 0
          ? 0
          : (
              ((this.gpTool.model.newSalesUMNetPrice -
                this.gpTool.data.SalesUMStandardCost) /
                this.gpTool.model.newSalesUMNetPrice) *
              100
            ).roundNumber(2);
    },
    itemHistoryPopupHidden() {
      // this.$logger.debug("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
      // this.$logger.debug("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", this.$refs["itemHistoryGrid"].instance);
      this.model.itemCode = undefined;
      this.$refs["itemHistoryGrid"].instance.clearFilter("search");
    },
    hasGridViewAccess() {
      return FeatureStorage.checkPermission(
        "SalesOrderDetailGrid",
        this.baseView.mode
      );
    },
    isPromotionValidForCurrentView() {
      if (this.soDetailsCurrentView == "GridList") return false;
      else true;
    },
    getProductPromoDetails() {
      // if (this.isPromotionValidForCurrentView()) {
      let itemCodeChunks = chunkArray(reviewListItemCodes, 20);
      let promoPromiseArr = [];
      let stockPromiseArr = [];

      for (let i = 0; i < itemCodeChunks.length; i++) {
        reviewListFilterValues = getFilterExpressionForArray(
          "ItemCode",
          itemCodeChunks[i]
        );

        var stockListFilterValues = getFilterExpressionForArray(
          "ProductCode",
          itemCodeChunks[i]
        );

        var promoFilter =
          "(" +
          reviewListFilterValues +
          ") and CustomerCode eq '" +
          soGlobal.model.CustomerCode +
          "' and (StartDate le " +
          soGlobal.model.FilterDate +
          "T00:00:00Z" +
          " and EndDate ge " +
          soGlobal.model.FilterDate +
          "T00:00:00Z" +
          ")";

        var stockFilter =
          "(" +
          stockListFilterValues +
          ") and BranchCode eq '" +
          soGlobal.model.BranchCode +
          "'";

        promoPromiseArr.push(
          SalesOrderService.getSalesOrderPromotion(promoFilter)
        );

        stockPromiseArr.push(SalesOrderService.getProductStock(stockFilter));

        Promise.all(promoPromiseArr).then((results) => {
          results.forEach((result) => {
            var getData = result.data.value;
            for (let index = 0; index < getData.length; index++) {
              var getIndex = soDetailsReviewListDataSource
                .items()
                .findIndex((x) => x.ItemCode == getData[index].ItemCode);
              if (getIndex > -1) {
                soDetailsReviewListDataSource.items()[getIndex][
                  "HasPromotion"
                ] = true;
              }
            }
          });
          // this.refreshView();
        });

        Promise.all(stockPromiseArr).then((results) => {
          results.forEach((result) => {
            var stockData = result.data.value;
            for (let index = 0; index < stockData.length; index++) {
              var getIndex = soDetailsReviewListDataSource
                .items()
                .findIndex((x) => x.ItemCode == stockData[index].ProductCode);
              if (getIndex > -1) {
                soDetailsReviewListDataSource.items()[getIndex]["Available"] =
                  stockData[index].Available;
              }
            }
          });
          // this.refreshView();
        });
      }
      // }
    },
    setTabSelection() {
      if (this.baseView.tab === "details") {
        this.selectedIndex = 1;
        if (screenModeChanged) {
          screenModeChanged = false;
          this.loadCurrentViewData();
        } else {
          setTimeout(() => {
            this.repaintSoDetailsGrid();
          }, 20);
        }
      } else {
        this.selectedIndex = 0;
      }
    },
    onSoDetailsInitialized(e) {
      soDetailsGridInstance = e.component;
      if (reviewModeSearchText !== "") {
        e.component.searchByText(reviewModeSearchText);
      }
      this.soDetailsGridInstance = e.component;
    },
    onSoDetailsColumnHeaderClick(e) {
      if (e.data) cellInfoData = e.data;

      if (e.rowType == "header") {
        soDetailsSortExpr = {
          dataField: e.column.dataField,
          sortOrder: e.column.sortOrder,
        };
      }

      if (e.rowType == "data") {
        currentRowIndex = e.rowIndex;
        currentColumnIndex = e.columnIndex;

        if (this.isTablet) {
          let isQtyField = false;
          if (this.soDetailsCurrentView !== "GridList") {
            isQtyField = e.column.dataField == "SalesUMQty";
          } else if (this.soDetailsCurrentView == "GridList") {
            const sizePatternToMatch = /^Size(\w+)Qty/;
            isQtyField = sizePatternToMatch.exec(e.column.dataField) !== null;
          }

          if (isQtyField) {
            if (!focusedQtyCellInfo) focusedQtyCellInfo = {};
            focusedQtyCellInfo.rowIndex = currentRowIndex;
            focusedQtyCellInfo.dataField = e.column.dataField;
          }
        }
      }
    },
    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },
    async handlePriceChangeTrigger(e, dataField, dataLabel, callback) {
      if (
        this.baseView.mode === "create" &&
        (e.previousValue == "" ||
          e.previousValue == null ||
          e.value == "" ||
          e.value == null)
      ) {
        if (callback) callback(e);
        return;
      }

      if (this.model.revertSelection) {
        this.model.revertSelection = false;
        return;
      }
      // this.$refs["so-header-form"].instance.getEditor("RequiredByDate").option("onValueChanged", null);
      let confirmPriceChange = await this.$confirm(
        `Would you like to recalculate the sell price of all items based upon this new ${dataLabel}?`,
        "Price Change"
      );

      if (confirmPriceChange) {
        if (dataField == "BranchCode") {
          soGlobal.model.BranchCode = this.model.BranchCode;
        }

        this.loadSoDetailsProductListDataSourceFilter();
        this.loadSoDetailsCustomerListDataSourceFilter();
        this.loadCurrentViewData();

        if (callback) await callback(e);
        this.setSaleItemPriceAllLines();
      } else {
        if (callback) await callback(e);
        // if (e.previousValue) {
        //   this.model.revertSelection = true;
        //   this.model[dataField] = e.previousValue;
        // }
      }

      if (this.getFactorByCode(565).Factorc == "Y") {
        this.$refs["so-header-form"].instance
          .getEditor("ShipDate")
          .option("onValueChanged", null);
        this.model.ShipDate = this.model.RequiredByDate;

        setTimeout(() => {
          this.$refs["so-header-form"].instance
            .getEditor("ShipDate")
            .option("onValueChanged", this.onShipDateValueChanged.bind(this));
        }, 1000);
      }

      // this.$refs["so-header-form"].instance.getEditor("RequiredByDate").option("onValueChanged", this.onRequiredByDateValueChanged.bind(this));
    },

    async onCustomerCodeValueChanged(e) {
      if (!e.value) {
        if (e.previousValue) this.model.PreviousCustomer = e.previousValue;
        return;
      } else {
        if (this.model.PreviousCustomer && !e.previousValue)
          e.previousValue = this.model.PreviousCustomer;
      }
      this.model.PreviousCustomer = undefined;

      this.loadSoDetailsProductListDataSourceFilter();
      this.loadSoDetailsCustomerListDataSourceFilter();
      this.loadCurrentViewData();

      // soDetailsGridInstance.repaint();

      if (this.customerIsChanging) {
        this.customerIsChanging = false;
        return;
      }

      let response = await CustomerService.getByCode(e.value);
      let stopCredit = response.data.value[0].StopCredit;
      let factor643 = this.getFactorByCode(643).Factorc;

      if (stopCredit === "Y" && factor643 === "Warn & Allow Processing") {
        let res = await alert(
          "Customer is currently on stop credit. You may continue to process this order if you wish, alternatively cancel this order as the customer is on stop credit.",
          "Customer is on Stop Credit "
        );
        if (res) {
          soGlobal.model.CustomerCode = this.model.CustomerCode;
          await this.handlePriceChangeTriggerFunction(e);
        }
      } else if (
        stopCredit === "Y" &&
        factor643 === "Warn & Block Processing"
      ) {
        await alert(
          "Customer is on stop credit. You may not process this order until the Stop Credit is removed.",
          "Customer is on Stop Credit "
        );

        this.customerIsChanging = true;
        this.model.CustomerCode = e.previousValue;
      } else if (stopCredit === "N") {
        soGlobal.model.CustomerCode = this.model.CustomerCode;
        await this.handlePriceChangeTriggerFunction(e);
      }
    },
    async handlePriceChangeTriggerFunction(e) {
      await this.handlePriceChangeTrigger(
        e,
        "CustomerCode",
        "Customer",
        async (e) => {
          if (e.value == "" || e.value == null) {
            deliveryAddressDataSource.filter([
              ["CustomerCode", "=", ""],
              "and",
              ["Inactive", "=", "N"],
            ]);
            await deliveryAddressDataSource.load();
            this.model.CustomerName = "";
            this.model.CustomerCode = "";
            this.model.CurrencyCode = "";

            this.loadSoDetailsCustomerListDataSource();
            this.preSelectDeliveryAddress("");
          } else {
            let itemData = null;
            if (e.component && e.component.option("items"))
              itemData = e.component
                .option("items")
                .find((x) => x.Code == e.value);

            if (!itemData) {
              let value = this.isTablet ? this.model.CustomerCode : e.value;
              let response = await CustomerService.getByCode(value);
              itemData = response.data.value[0];
            }

            deliveryAddressDataSource.filter([
              ["CustomerCode", "=", itemData.Code],
              "and",
              ["Inactive", "=", "N"],
            ]);
            await deliveryAddressDataSource.load().then((result) => {
              if (result) {
                var item = result.filter((x) => {
                  return x.LineNo == 1;
                });
                if (item) {
                  this.model.DeliveryAddressCompanyName = item[0].CompanyName;
                  this.model.DeliveryAddressStreetLine1 =
                    item[0].PhysicalAddressStreetLine1;
                  this.model.DeliveryAddressStreetLine2 =
                    item[0].PhysicalAddressStreetLine2;
                  this.model.DeliveryAddressSuburb =
                    item[0].PhysicalAddressSuburb;
                  this.model.DeliveryAddressState =
                    item[0].PhysicalAddressState;
                  this.model.DeliveryAddressPostcode =
                    item[0].PhysicalAddressPostcode;
                  this.model.DeliveryAddressCountry =
                    item[0].PhysicalAddressCountry;
                }

                this.$logger.debug("default item ", item);
              }
            });

            this.model.CustomerName = itemData.Name;
            this.model.CustomerCode = itemData.Code;
            this.model.CurrencyCode = itemData.CurrencyCode;
            let result = await CompanyCurrencyService.getByCurrencyCode(
              this.model.CurrencyCode
            );
            this.model.ExchangeRate = result.data.value[0].BuyRate;

            this.loadCustomerSalesContracts();
            this.updateSoDetailsGridColumns();
            this.loadSoDetailsCustomerListDataSource();
            this.preSelectDeliveryAddress(itemData.Code);
          }
          this.refreshView();
          // this.customerCodeInstance.$options.propsData.options.value = this.model.CustomerCode;
        }
      );
    },
    async onBranchCodeValueChanged(e) {
      soGlobal.model.BranchValue = e.value;
      this.handlePriceChangeTrigger(e, "BranchCode", "Branch", async (e) => {
        if (this.soDetailsCurrentView == "GridList") {
          if (e.value)
            this.soDetailsGridListDataSource.filter(
              this.defaultFilters.gridListViewFilter
            );
          else this.soDetailsGridListDataSource.filter(null);

          this.soDetailsGridListDataSource.load().then(() => {
            this.salesOrderDetailsDataSourceConfig = this.soDetailsGridListDataSource;
          });
        } else {
          await this.loadSoDetailsProductListDataSourceFilter();
          await this.loadSoDetailsCustomerListDataSourceFilter();
          await this.loadCurrentViewData();

          // if (this.soDetailsCurrentView == "ProductList") {
          //   this.defaultFilters.default = this.defaultFilters.productListViewFilter;
          //   soDetailsProductListDataSource.load().then((res) => {
          //     console.log("soDetailsProductListDataSource ", res);
          //   });
          //   // this.salesOrderDetailsDataSourceConfig = soDetailsProductListDataSource;

          //   // if(!this.model.BranchCode) {
          //   //   console.log('soDetailsProductListDataSource ',soDetailsProductListDataSource);
          //   // }
          // }
        }
      });
    },
    onDeliveryAddressChanged(e) {
      this.$logger.debug("onDeliveryAddressChanged", e);
      // CustomerDeliveryAddressService.getByName(e.itemData.CompanyName).then((response) => {
      if (e.itemData) {
        this.model.DeliveryAddressCompanyName = e.itemData.CompanyName;

        this.model.DeliveryAddressStreetLine1 =
          e.itemData.PhysicalAddressStreetLine1;
        this.model.DeliveryAddressStreetLine2 =
          e.itemData.PhysicalAddressStreetLine2;
        this.model.DeliveryAddressSuburb = e.itemData.PhysicalAddressSuburb;
        this.model.DeliveryAddressState = e.itemData.PhysicalAddressState;
        this.model.DeliveryAddressPostcode = e.itemData.PhysicalAddressPostcode;
        this.model.DeliveryAddressCountry = e.itemData.PhysicalAddressCountry;
        this.model.CustomerDeliveryAddressLineNo = e.itemData.LineNo.toString();

        this.populateFreightCharges(
          this.model.CustomerCode,
          this.model.CustomerDeliveryAddressLineNo
        );
      }
      // });
    },
    onDateInValueChanged(e) {
      if (this.getFactorByCode(616).Factorc == "Date In") {
        soGlobal.model.FilterDate = e.value.toYYYYMMDD();
        this.handlePriceChangeTrigger(e, "DateIn", "Date In");
      }
    },
    onRequiredByDateValueChanged(e) {
      if (this.getFactorByCode(616).Factorc != "Date In") {
        soGlobal.model.FilterDate = e.value.toYYYYMMDD();
        this.handlePriceChangeTrigger(e, "RequiredByDate", "Required By Date");
      } else {
        if (this.getFactorByCode(565).Factorc == "Y") {
          this.$refs["so-header-form"].instance
            .getEditor("ShipDate")
            .option("onValueChanged", null);
          this.model.ShipDate = this.model.RequiredByDate;

          setTimeout(() => {
            this.$refs["so-header-form"].instance
              .getEditor("ShipDate")
              .option("onValueChanged", this.onShipDateValueChanged.bind(this));
          }, 1000);
        }
      }
    },
    async onSoTypeValueChanged(e) {
      this.handlePriceChangeTrigger(e, "SalesOrderTypeCode", "SO Type");
      await this.getCommentSettings();
    },
    onShipDateValueChanged(e) {
      if (this.getFactorByCode(565).Factorc == "Y") {
        this.$refs["so-header-form"].instance
          .getEditor("RequiredByDate")
          .option("onValueChanged", null);
        this.model.RequiredByDate = this.model.ShipDate;
        if (this.getFactorByCode(616).Factorc != "Date In") {
          soGlobal.model.FilterDate = e.value.toYYYYMMDD();
          this.handlePriceChangeTrigger(
            e,
            "RequiredByDate",
            "Required By Date"
          );
        }

        setTimeout(() => {
          this.$refs["so-header-form"].instance
            .getEditor("RequiredByDate")
            .option(
              "onValueChanged",
              this.onRequiredByDateValueChanged.bind(this)
            );
        }, 1000);
      }
    },

    async loadSoDetailsProductListDataSourceFilter() {
      this.defaultFilters.productListViewFilter = [
        [
          ["ItemType", "=", "S"],
          "and",
          ["IsDefault", "=", "Y"],
          "and",
          ["AvailableForSale", "=", "Y"],
        ],
        "and",
        [
          ["CustomerCode", "=", this.model.CustomerCode],
          "and",
          ["Inactive", "=", "N"],
        ],
      ];

      if (this.model.BranchCode) {
        this.defaultFilters.productListViewFilter[2].push("and");
        this.defaultFilters.productListViewFilter[2].push([
          "BranchCode",
          "=",
          this.model.BranchCode,
        ]);
      }
      soDetailsProductListDataSource.filter(
        this.defaultFilters.productListViewFilter
      );
    },
    loadSoDetailsProductListDataSource() {
      this.loadSoDetailsProductListDataSourceFilter();
      return soDetailsProductListDataSource.load();
    },

    async loadSoDetailsCustomerListDataSourceFilter() {
      this.defaultFilters.customerListViewFilter = [
        [["ItemType", "=", "S"], "and", ["IsDefault", "=", "Y"]],
        "and",
        [
          ["CustomerCode", "=", this.model.CustomerCode],
          "and",
          ["Inactive", "=", "N"],
        ],
      ];

      if (this.model.BranchCode) {
        this.defaultFilters.customerListViewFilter[2].push("and");
        this.defaultFilters.customerListViewFilter[2].push([
          "BranchCode",
          "=",
          this.model.BranchCode,
        ]);
      }

      soDetailsCustomerListDataSource.filter(
        this.defaultFilters.customerListViewFilter
      );
    },

    loadSoDetailsCustomerListDataSource() {
      this.loadSoDetailsCustomerListDataSourceFilter();
      return soDetailsCustomerListDataSource.load();
    },
    setDefaultFilters() {
      this.defaultFilters.productListViewFilter = [
        [
          ["ItemType", "=", "S"],
          "and",
          ["IsDefault", "=", "Y"],
          "and",
          ["AvailableForSale", "=", "Y"],
        ],
        "and",
        [
          ["BranchCode", "=", this.model.BranchCode],
          "and",
          ["CustomerCode", "=", this.model.CustomerCode],
          "and",
          ["Inactive", "=", "N"],
        ],
      ];

      soDetailsProductListDataSource.filter(
        this.defaultFilters.productListViewFilter
      );

      this.defaultFilters.customerListViewFilter = [
        [["ItemType", "=", "S"], "and", ["IsDefault", "=", "Y"]],
        "and",
        [
          ["BranchCode", "=", this.model.BranchCode],
          "and",
          ["AvailableForSale", "=", "Y"],
          "and",
          ["CustomerCode", "=", this.model.CustomerCode],
          "and",
          ["Inactive", "=", "N"],
        ],
      ];
      soDetailsCustomerListDataSource.filter(
        this.defaultFilters.customerListViewFilter
      );
    },

    loadDataSources(isCreateMode) {
      this.categorySelectionDisabled = this.soDetailsCurrentView == "Review";
      if (this.model.Status == "D") {
        this.categorySelectionDisabled = false;
      }

      this.setDefaultFilters();

      if (isCreateMode) {
        if (this.soDetailsCurrentView == "GridList") {
          this.soDetailsGridListDataSource.filter(
            this.defaultFilters.gridListViewFilter
          );
          this.loadGridListViewDataSource();
        } else if (this.soDetailsCurrentView == "CustomerList") {
          this.loadSoDetailsCustomerListDataSource();
        }
        this.loadCustomerSalesContracts();
      } else {
        soDetailsReviewListDataSource.filter([
          "SalesOrderCode",
          "=",
          parseInt(this.model.Code),
        ]);

        this.defaultFilters.reviewListViewFilter = [
          ["SalesOrderCode", "=", parseInt(this.model.Code)],
        ];

        soDetailsReviewListDataSource.load().then(() => {
          this.salesOrderDetailsDataSourceConfig = soDetailsReviewListDataSource.items();

          this.loadCustomerSalesContracts();

          this.loadSoDetailsProductListDataSource().then(() => {
            this.mergeProductListData();
            this.loadSoDetailsCustomerListDataSource().then(() => {
              this.mergeCustomerListData();
              // eslint-disable-next-line no-empty
              if (this.soDetailsCurrentView == "Review") {
              } else if (this.soDetailsCurrentView == "GridList") {
                this.soDetailsGridListDataSource.filter(
                  this.defaultFilters.gridListViewFilter
                );

                this.soDetailsGridListDataSource.load().then(() => {
                  this.salesOrderDetailsDataSourceConfig = this.soDetailsGridListDataSource;

                  // this.updateSoGridListViewColumns(validGridListSizeColumns);
                });
              } else
                this.salesOrderDetailsDataSourceConfig = this.getCurrentSoDetailsDataSource();

              // this.getProductPromoDetails();
            });
          });
        });
      }
    },
    mergeCustomerListData() {
      soDetailsReviewListDataSource.items().forEach((details) => {
        var foundIndex = soDetailsCustomerListDataSource
          .items()
          .findIndex(
            (item) =>
              item.ItemCode == details.ItemCode &&
              item.SalesUM == details.SalesUM
          );
        if (foundIndex !== -1) {
          soDetailsCustomerListDataSource.items()[foundIndex] = details;
        }
      });
    },
    mergeProductListData() {
      soDetailsReviewListDataSource.items().forEach((details) => {
        var foundIndex = soDetailsProductListDataSource
          .items()
          .findIndex(
            (item) =>
              item.ItemCode == details.ItemCode &&
              item.SalesUM == details.SalesUM
          );
        if (foundIndex !== -1) {
          soDetailsProductListDataSource.items()[foundIndex] = details;
        }
      });
    },
    updateSoDetailsGridColumns() {
      let gridColumns = [
        {
          caption: "Item",
          minWidth: this.gridColumnMinWidth(300),
          alignment: "left",
          allowEditing: false,
          cellTemplate: "primaryImageTemplate",
          allowFixing: true,
          fixedPosition: "left",
          fixed: !this.isTablet, // HACK: Tablet scrolling doesnt worked on fixed columns
          calculateSortValue: "ItemCode",
          allowSorting: true,
          sortOrder: "asc",
          allowReordering: false,
        },
        {
          caption: "Item",
          dataField: "ItemCode",
          minWidth: this.gridColumnMinWidth(170),
          width: 170,
          alignment: "left",
          allowEditing: false,
          visible: false,
        },
        {
          caption: "Description",
          dataField: "Description",
          alignment: "left",
          minWidth: this.gridColumnMinWidth(230),
          allowEditing: false,
          visible: false,
        },
        {
          caption: "",
          dataField: "HasPromotion",
          allowEditing: false,
          allowSorting: false,
          alignment: "right",
          width: 50,

          cellTemplate: "promotionTemplate",
          allowFiltering: false,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          width: 100,
          cellTemplate: "sales-um-template",
          cssClass: this.soCellEditorClass,
          editCellTemplate: "salesUMEditTemplate",
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          // hidingPriority: 0,
          minWidth: this.getDecimalFormatByCode(7).Width,
          setCellValue: this.setSalesUMQtyCell,
          // format: this.getDecimalFormatByCode(7).Format,
          editorOptions: {
            format: this.getDecimalFormatByCode(7).Format,
          },
          allowSorting: false,
          cssClass: this.soCellEditorClass + " decimal-no-wrap",
          allowFiltering: false,
          editCellTemplate: "qtyEditTemplate",
          showEditorAlways: true,
        },
        {
          caption: this.soDetailsColumnPriceLabel,
          dataField: "SalesUMFXPrice",
          // hidingPriority: 0,
          minWidth: this.getDecimalFormatByCode(13).Width,
          // allowEditing: true,
          editorOptions: {
            format: this.getDecimalFormatByCode(13).Format,
          },
          allowSorting: false,
          allowFiltering: false,
          editCellTemplate: "priceEditTemplate",
          showEditorAlways: true,
          cssClass: "decimal-no-wrap",
        },
        {
          caption: "Discount",
          dataField: "DiscPcnt",
          // hidingPriority: 0,
          minWidth: this.getDecimalFormatByCode(6).Width,
          // allowEditing: true,
          editorOptions: {
            format: this.getDecimalFormatByCode(6).Format,
          },
          allowSorting: false,
          allowFiltering: false,
          editCellTemplate: "discountTemplate",
          showEditorAlways: true,
          cssClass: "decimal-no-wrap",
        },
        {
          caption: this.soDetailsColumnNetPriceLabel,
          dataField: "SalesUMNetFXPrice",
          // hidingPriority: 0,
          minWidth: this.getDecimalFormatByCode(12).Width,
          allowEditing: false,
          format: this.getDecimalFormatByCode(12).Format,
          allowSorting: false,
          allowFiltering: false,
          cssClass: "decimal-no-wrap",
        },
        {
          caption: this.soDetailsColumnTotalLabel,
          dataField: "TaxableFXLineTotal",
          // hidingPriority: 0,
          minWidth: this.getDecimalFormatByCode(12).Width,
          allowEditing: false,
          format: this.getDecimalFormatByCode(12).Format,
          allowSorting: false,
          allowFiltering: false,
          cssClass: "decimal-no-wrap",
        },
      ];

      let availableColumn = {
        caption: "Available",
        dataField: "Available",
        // hidingPriority: 0,
        width: 120,
        allowEditing: false,
        // allowFiltering: false
        format: this.getDecimalFormatByCode(7).Format,
        cellTemplate: "available-template",
      };

      if (
        this.soDetailsCurrentView === "ProductList" ||
        this.soDetailsCurrentView === "CustomerList"
      ) {
        availableColumn.allowFiltering = false;
      }

      gridColumns.push(availableColumn);

      gridColumns.push({
        caption: "",
        dataField: "",
        width: 40,
        minWidth: this.gridColumnMinWidth(30),
        maxWidth: 80,
        allowEditing: false,
        cellTemplate: "menu-cell-template",
        alignment: "left",
        cssClass: "more-menu",
        fixedPosition: "right",
        fixed: true,
        allowFixing: true,
        allowReordering: false,
      });

      this.soDetailsGridColumns = gridColumns;
    },
    onSoDetailsLineContextMenuItemClick(e) {
      this.fromItemPriceUpdate = false;
      if (e.itemData.menuText == "Line Comment") {
        let rowData = e.itemData.data.data;

        currentRowIndex = e.itemData.data.component.getRowIndexByKey(
          e.itemData.data.key
        );

        let visibleOnInvoiceFactor = this.getFactorByCode(505);

        this.lineCommentModel.Comment = rowData.Comment;
        this.lineCommentModel.IsCommentVisible =
          rowData.LineNo == 0
            ? visibleOnInvoiceFactor.Factorc == "Y"
              ? true
              : false
            : rowData.IsCommentVisible;

        this.lineCommentsPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Order Line Comment");
        let form = this.$refs["line-comments-form"].instance;
        form.repaint();
      } else if (e.itemData.menuText == "Item History") {
        if (!this.model.CustomerCode) {
          this.displayValidationSummary([]);
          this.addErrorMessage(`Customer should be selected`);
          this.displayValidationSummary();
        } else {
          this.model.itemCode = e.itemData.data.data.ItemCode;
          this.customerItemHistory = e.itemData.data.data;
          this.itemHistoryPopupVisible = true;
          this.$logger.trackEventOpenPopup("Sales Order Item History");
        }
      } else if (e.itemData.menuText == "Copy Line") {
        this.$logger.trackEventButtonClick(`Sales Order Copy Line`);

        let dataObj = Object.assign({ copiedLine: true }, e.itemData.data.data);
        const maxLineNo = Math.max.apply(
          Math,
          soDetailsReviewListDataSource.items().map(function(o) {
            return o.LineNo;
          })
        );
        dataObj.LineNo = maxLineNo + 1;

        let x = soDetailsReviewListDataSource.items().filter((i) => {
          return i.ItemCode == e.itemData.data.data.ItemCode;
        });

        dataObj.CopyCode = e.itemData.data.data.ItemCode + "-" + x.length;

        dataObj.SalesUMQty = 0;
        dataObj.CustomerSalesContractCode = null;
        dataObj.CustomerSalesContractLineNo = null;

        // #27700: we want to retain prices
        // dataObj.SalesUMPrice = 0;
        // dataObj.LineTotal = 0;
        // dataObj.AddDiscSalesUMPrice = 0;
        // dataObj.AddDiscStockUMPrice = 0;
        // dataObj.PriceGroupCode = 0;
        // dataObj.PriceGroupSalesUMPrice = 0;
        // dataObj.PriceGroupStockUMPrice = 0;
        // dataObj.SalesUMFXPrice = 0;
        // dataObj.SalesUMNetFXPrice = 0;
        // dataObj.SalesUMNetPrice = 0;
        // dataObj.SalesUMPromotionNetPrice = 0;
        // dataObj.SalesUMStandardPrice = 0;
        // dataObj.StockUMFXPrice = 0;
        // dataObj.StockUMNetFXPrice = 0;
        // dataObj.StockUMNetPrice = 0;
        // dataObj.StockUMPrice = 0;
        // dataObj.StockUMStandardPrice = 0;

        this.setStockPrices(dataObj);
        this.setLineTotals(dataObj);
        this.$logger.debug("copy items ", dataObj);

        if (this.soDetailsCurrentView == "Review") {
          soDetailsReviewListDataSource
            .items()
            .splice(currentRowIndex + 1, 0, dataObj);
        } else if (
          this.soDetailsCurrentView == "ProductList" ||
          this.soDetailsCurrentView == "CustomerList"
        ) {
          soDetailsReviewListDataSource.items().push(dataObj);
          soDetailsProductListDataSource.reload();
        }
      } else if (e.itemData.menuText == "GP Tool") {
        // this.selectedItemIndex = e.itemData.data.rowIndex;
        if (e.itemData.data.data.SalesUMQty == 0) {
          this.displayValidationSummary([]);
          this.addErrorMessage(
            `Quantity cannot be 0. Please enter a quantity to access the GP Tool.`
          );
          this.displayValidationSummary();
        } else {
          this.gpToolPopupVisible = true;
          this.$logger.trackEventOpenPopup("Sales Order GP Tool");
          this.gpTool.data = e.itemData.data.data;

          this.gpTool.model.quantity = e.itemData.data.data.SalesUMQty;
          this.gpTool.model.standardSell =
            e.itemData.data.data.SalesUMStandardPrice * this.model.ExchangeRate;
          this.gpTool.model.currentPrice =
            e.itemData.data.data.SalesUMNetFXPrice;
          this.gpTool.model.gp = calculateGrossProfitPcnt(
            e.itemData.data.data.SalesUMStandardCost,
            e.itemData.data.data.SalesUMNetPrice
          );
          this.gpTool.model.newSalesUMNetPrice =
            e.itemData.data.data.SalesUMNetFXPrice;
        }
      } else if (e.itemData.menuText == "Item Price Update") {
        this.itemPriceUpdateData = e.itemData.data.data;
        // this.selectedItemIndex = e.itemData.data.rowIndex;
        if (!this.model.BranchCode) {
          this.displayValidationSummary([]);
          this.addErrorMessage(
            `Branch cannot be empty.  Please enter a branch for this sales order to access the Item Price Update tool.`
          );
          this.displayValidationSummary();
        } else if (this.itemPriceUpdateData.SalesUMQty == 0) {
          this.displayValidationSummary([]);
          this.addErrorMessage(
            `Quantity cannot be 0.  Please enter a quantity to access the Item Price Update tool.`
          );
          this.displayValidationSummary();
        } else {
          this.visibleItemPriceUpdate = !this.visibleItemPriceUpdate;
        }
      } else {
        this.bestBeforeDatePopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Order Best Before");
        this.bestBeforeDate.data = e.itemData.data.data;
        this.bestBeforeDate.model.bestBeforeDate =
          e.itemData.data.data.BestBeforeDate;
      }
    },
    customItemCreating(data) {
      if (!data.text) {
        data.customItem = null;
        return;
      }

      const newItem = {
        CompanyName: data.text,
        PhysicalAddressCountry: "",
        PhysicalAddressPostcode: "",
        PhysicalAddressState: "",
        PhysicalAddressStreetLine1: "",
        PhysicalAddressStreetLine2: "",
        PhysicalAddressSuburb: "",
      };

      data.customItem = newItem;
    },
    // end validations
    notesToolbarPreparing(e) {
      if (this.baseView.mode != "review") {
        e.toolbarOptions.items.unshift(
          // This is an example of a toolbar button(e.g This code depicts the Grid Refresh button). We may substitute relevant properties to cater for any Toolbar button.
          {
            location: "left",
            widget: "dxButton",
            options: {
              icon: "plus",
              text: "Add Note",
              onClick: this.onAddClickHandler.bind(this),
            },
          }
        );
      }
    },
    itemHistoryToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: "before",
        template: "displayDescription",
      });
    },
    itemHistoryAddGridNoResults(e) {
      let noDataMessageObject = {
        addNew: {
          class: undefined,
          title: "No History Lines",
          message:
            "Products despatched and invoiced to the customer will show here. Head over to the Despatch Order screen to despatch and invoice orders for this customer.",
        },
      };
      this.addGridNoResults(e, noDataMessageObject);
    },
    onDeleteClick(e) {
      // function seems unused
      this.$logger.trackEventButtonClick("Delete Note");
      let grid = this.$refs[this.gridRefName].instance;
      let arr = grid.getDataSource().items();
      arr.splice(e.rowIndex, 1);

      this.orderNotesDataSourceConfig = arr;
    },
    onToolbarPreparingSoDetails(e) {
      // this.$logger.debug("onToolbarPreparingSoDetails , " , e);

      var toolbarItems = e.toolbarOptions.items;

      let detailsViewMenuOptions = [
        {
          value: "Review",
          text: "Review",
        },
        {
          value: "ProductList",
          text: "Product",
        },
        {
          value: "CustomerList",
          text: "Customer",
        },
      ];

      if (this.hasGridViewAccess()) {
        detailsViewMenuOptions.push({
          value: "GridList",
          text: "Grid",
        });
      }

      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      // var columnChooserButton = toolbarItems.find((item) => {
      //   return item.name === "columnChooserButton";
      // });

      let itemsToRemoveFromToolBar = [
        "searchPanel",
        "revertButton",
        "saveButton",
        // "columnChooserButton",
      ];

      e.toolbarOptions.items = toolbarItems.filter(
        (item) => !itemsToRemoveFromToolBar.includes(item.name)
      );

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        {
          options: this.toolbar.gridTotal,
          location: "after",
          widget: "dxButton",
          visible:
            this.hasGridViewAccess() && this.soDetailsCurrentView == "GridList",
        },
        // columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          visible: !this.isTablet,
          options: {
            validationGroup: "formsData",
            icon: this.gridExpanded ? "collapse" : "expand",
            onClick: this.expandGrid,
          },
        },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              // var grid = this.$refs[this.soDetailsGridRefName].instance;
              // grid.refresh(true);
              var item = document.getElementById("details-grid-filter-btn");
              item.classList.add("dx-state-invisible");
            },
            // visible: !this.showRightContainer,
            elementAttr: { id: "details-grid-filter-btn" },
          },
        },
        {
          location: "after",
          template: "statusTemplate",
          visible: this.isTablet,
        },
        {
          options: this.toolbar.audit,
          location: "after",
          widget: "dxButton",
          visible: this.baseView.mode == "review" && this.isTablet,
        },
        {
          location: "after",
          widget: "dxDropDownButton",
          options: this.toolbar.notes,
          locateInMenu: "auto",
          visible: this.isTablet,
        },

        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: this.isTablet ? 130 : 200,
            items: detailsViewMenuOptions,
            displayExpr: "text",
            valueExpr: "value",
            value: this.soDetailsCurrentView,
            onValueChanged: this.detailsViewChanged.bind(this),
          },
        },

        {
          options: this.toolbar.edit,
          location: "after",
          widget: "dxButton",
          visible:
            this.isEditVisible &&
            this.baseView.mode == "review" &&
            this.isTablet,
        },
        {
          options: this.toolbar.menu,
          location: "after",
          widget: "dxDropDownButton",
          visible:
            this.isEditVisible &&
            this.baseView.mode !== "review" &&
            this.isTablet,
          ref: "gridSaveMenu",
        },
        {
          location: "after",
          widget: "dxDropDownButton",
          options: this.toolbar.status,
          locateInMenu: "auto",
          visible:
            (this.baseView.mode == "review" && this.isTablet) ||
            (this.baseView.mode == "create" && this.isTablet),
        }
      );
    },

    mergeItemWithReviewList(currentRow) {
      if (this.soDetailsCurrentView == "Review") {
        let foundIndexInCustomerList = soDetailsCustomerListDataSource
          .items()
          .findIndex(
            (x) =>
              x.ItemCode == currentRow.ItemCode &&
              x.SalesUM.toLowerCase() == currentRow.SalesUM.toLowerCase()
          );
        if (foundIndexInCustomerList > -1)
          soDetailsCustomerListDataSource.items()[
            foundIndexInCustomerList
          ] = currentRow;

        let foundIndexInProductList = soDetailsProductListDataSource
          .items()
          .findIndex(
            (x) =>
              x.ItemCode == currentRow.ItemCode &&
              x.SalesUM == currentRow.SalesUM
          );
        if (foundIndexInProductList > -1)
          soDetailsProductListDataSource.items()[
            foundIndexInProductList
          ] = currentRow;
      }

      if (this.soDetailsCurrentView !== "Review") {
        if (
          !soDetailsReviewListDataSource
            .items()
            .find(
              (x) =>
                x.ItemCode == currentRow.ItemCode &&
                x.SalesUM == currentRow.SalesUM
            )
        )
          soDetailsReviewListDataSource.items().push(currentRow);
        // set the item ordering within the local review list so that we'll pickup the correct record by row index
        soDetailsReviewListDataSource
          .items()
          .sort(compareValues("Description", "asc"));
      }
    },
    mergeFromOrderGrid(
      currentRowIndex,
      cellInfo,
      prevSalesUMQty,
      newSalesUMQty
    ) {
      var currentRow = cellInfo.data;
      let currentItemCode = currentRow[`Size${cellInfo.column.name}ItemCode`];
      let record = {};

      // this.$logger.debug("mergeFromOrderGrid Item Code", currentItemCode);

      record = Object.assign({}, soDetailsBaseRecord);
      record = Object.assign(record, cellInfo.data);
      record.ItemCode = currentItemCode;
      record.ItemType = "S";
      record.SalesUMQty = newSalesUMQty;
      record.CopyCode = record.ItemCode + "-0"; // Copy code used for identifying the correct record within the datasource. Grid View row corresponds to multiple Items within the review list

      let foundIndexInReviewList = soDetailsReviewListDataSource
        .items()
        .findIndex(
          (x) =>
            x.ItemCode == currentItemCode &&
            x.SalesUM.toLowerCase() == currentRow.SalesUM.toLowerCase()
        );
      if (foundIndexInReviewList > -1) {
        record = soDetailsReviewListDataSource.items()[foundIndexInReviewList];
        record.SalesUMQty = newSalesUMQty;
      }

      // ProductSizeCode into review array needed - grid qty field changed
      record.ProductSizeCode = this.getProductSizeCodeBySequence(
        cellInfo.column.name
      );

      soDetailsGridInstance.cellValue(
        currentRowIndex,
        cellInfo.column.dataField,
        newSalesUMQty
      );

      // #27699: Qty Edit Changes
      // WHEN Quantity goes from zero to non-zero AND the line is not a copied line THEN
      // - Perform Price Lookup
      // - Update all fields as it does now

      let qtyZeroToNotZeroNotACopiedLine =
        prevSalesUMQty == 0 && newSalesUMQty != 0 && !record.copiedLine;
      let qtyZeroToNonZeroOnCopiedLine =
        prevSalesUMQty == 0 && newSalesUMQty != 0 && record.copiedLine;

      let qtyNonZeroToNonZeroNotCopiedLine =
        prevSalesUMQty != 0 && newSalesUMQty != 0 && !record.copiedLine;
      let qtyNonZeroToNonZeroCopiedLine =
        prevSalesUMQty != 0 && newSalesUMQty != 0 && record.copiedLine;

      if (qtyZeroToNotZeroNotACopiedLine || qtyNonZeroToNonZeroNotCopiedLine) {
        this.showLoading(true);
        SalesOrderService.setSaleItemPrice(
          // Grid List
          record,
          this.model.SalesOrderTypeCode,
          this.model.BranchCode,
          this.model.CustomerCode,
          this.model.ExchangeRate,
          this.model.DateIn,
          this.model.RequiredByDate,
          false
        ).then((res) => {
          this.$logger.debug("setSaleItemPrice: " + JSON.stringify(res));
          cellInfo.setValue(newSalesUMQty); // Updates the cell value
          this.mergeItemWithReviewList(record);
          this.$logger.debug(
            "qtyZeroToNotZeroNotACopiedLine" + this.soDetailsCurrentView
          );

          this.showLoading(false);
        });
      }

      // WHEN Quantity goes from zero to non-zero AND the line is a copied line THEN OR  WHEN Quantity goes from non-zero to non-zero THEN
      // - Do not perform Price Lookup
      // - Update Net and Totals based on price & discount in screen
      else if (qtyZeroToNonZeroOnCopiedLine || qtyNonZeroToNonZeroCopiedLine) {
        cellInfo.setValue(newSalesUMQty); // Updates the cell value
        this.mergeItemWithReviewList(record);

        if (qtyZeroToNonZeroOnCopiedLine) {
          this.$logger.debug(
            "qtyZeroToNonZeroOnCopiedLine: " + this.soDetailsCurrentView
          );
        } else {
          this.$logger.debug(
            "qtyNonZeroToNonZero: " + this.soDetailsCurrentView
          );
        }

        this.setStockPrices(record);
        this.setLineTotals(record);
      }

      // else {
      // WHEN Quantity goes from non-zero to zero THEN
      // - Price is 0
      // - Discount is 0
      // - Net is 0
      // - Update all other necessary fields

      // remove a qty line when zero
      if (newSalesUMQty === 0) {
        this.$logger.debug("qtyNonZeroToZero: " + this.soDetailsCurrentView);
        record.SalesUMFXPrice = 0;
        record.SalesUMNetFXPrice = 0;
        record.SalesUMPrice = 0;
        record.DiscPcnt = 0;
        record.SalesUMNetPrice = 0;

        this.setStockPrices(record);
        this.setLineTotals(record);

        var itemIndex = undefined;
        soDetailsReviewListDataSource.items().forEach((element, index) => {
          if (element.CopyCode == record.CopyCode) {
            itemIndex = index;
          }
        });

        if (itemIndex != undefined) {
          soDetailsReviewListDataSource.items().splice(itemIndex, 1);
          return;
        }
      }
      // }
    },
    getCurrentSoDetailsDataSource() {
      if (this.soDetailsCurrentView == "Review")
        return soDetailsReviewListDataSource;

      if (this.soDetailsCurrentView == "ProductList")
        return soDetailsProductListDataSource;

      if (this.soDetailsCurrentView == "CustomerList")
        return soDetailsCustomerListDataSource;

      if (this.soDetailsCurrentView == "GridList")
        return this.soDetailsGridListDataSource;

      return [];
    },
    updateDataSource(dataSource, index, field, value) {
      dataSource.items()[index][field] = value;

      var instance = this.$refs[this.soDetailsGridRefName].instance;
      instance.repaintRows([index]);
    },
    isSalesUMValidInCurrentView() {
      if (this.soDetailsCurrentView == "GridList") return false;
      else return true;
    },
    async onEditingStartSoDetails(e) {
      // this.$logger.debug("editing started", e);

      if (this.baseView.mode == "review") {
        if (
          e.column.dataField === "SalesUM" ||
          e.column.dataField === "SalesUMQty"
        ) {
          e.cancel = true;
          return;
        }
      }

      // currentRowIndex = e.component.getRowIndexByKey(e.key);

      // if (this.isTablet) {
      //   if (this.soDetailsCurrentView !== "GridList") {
      //     if (!focusedQtyCellInfo) focusedQtyCellInfo = {};
      //     focusedQtyCellInfo.rowIndex = currentRowIndex;
      //     focusedQtyCellInfo.dataField = e.column.dataField;
      //   }
      // }
    },
    // eslint-disable-next-line no-unused-vars
    setSalesUMQtyCell(newData, value) {
      // this.$logger.debug(
      //   "Items from soDetailsDataSource",
      //   this.getCurrentSoDetailsDataSource().items()[currentRowIndex]
      // );
      // this.$logger.debug(
      //   "Items from soDetailsGridRefName",
      //   this.soDetailsGrid.getDataSource().items()[
      //     currentRowIndex
      //   ]
      // );
    },
    detailsViewChanged(e) {
      if (this.soDetailsCurrentView == e.value) return;
      this.soDetailsCurrentView = e.value;
      this.loadCurrentViewData();
      soDetailsGridInstance.repaint();
    },

    loadGridListViewDataSource() {
      this.salesOrderDetailsDataSourceConfig = [];
      this.defaultFilters.gridListViewFilter = this.defaultFilters.default = [
        ["BranchCode", "=", this.model.BranchCode],
      ];

      if (this.soDetailsGridInstance) {
        if (!soDetailsGridInstance.getCombinedFilter()) {
          this.soDetailsGridListDataSource.filter(
            this.defaultFilters.gridListViewFilter
          );
        }
      } else {
        this.soDetailsGridListDataSource.filter(
          this.defaultFilters.gridListViewFilter
        );
      }

      if (this.soDetailsGridListDataSource._isLoaded) {
        this.salesOrderDetailsDataSourceConfig = this.soDetailsGridListDataSource;
        // this.updateSoGridListViewColumns(validGridListSizeColumns);
      } else {
        this.soDetailsGridListDataSource.load().then(() => {
          this.salesOrderDetailsDataSourceConfig = this.soDetailsGridListDataSource;
          // this.updateSoGridListViewColumns(validGridListSizeColumns);
        });
      }
    },
    // eslint-disable-next-line no-unused-vars
    updateSoGridListViewColumns(validColumns) {
      let cols = [
        {
          caption: "Item",
          minWidth: this.gridColumnMinWidth(300),
          alignment: "left",
          allowEditing: false,
          cellTemplate: "primaryImageGridTemplate",
          allowFixing: true,
          fixedPosition: "left",
          fixed: !this.isTablet, // HACK: Tablet scrolling doesnt worked on fixed columns
          calculateSortValue:
            this.getFactorByCode(639).Factorc == ""
              ? "Description"
              : this.getFactorByCode(639).Factorc,
          allowSorting: true,
          sortOrder: "asc",
          allowReordering: false,
        },
        {
          caption: "Item",
          dataField: "Model",
          alignment: "left",
          allowEditing: false,
          visible: false,
        },
        {
          caption: "Description",
          dataField: "Description",
          alignment: "left",
          minWidth: this.gridColumnMinWidth(230),
          allowEditing: false,
          visible: false,
        },
        {
          caption: "",
          allowEditing: false,
          allowSorting: false,
          alignment: "right",
          width: 50,
          minWidth: this.gridColumnMinWidth(50),
          cellTemplate: "availableLabel",
          cssClass: "gc-grid-qty-container",
        },
      ];

      for (let i = 0; i <= 20; i++) {
        let thisCol = validColumns.find((s) => s.Sequence == i);

        if (thisCol) {
          cols.push({
            width: 100,
            allowHiding: false,
            allowSorting: false,
            allowFiltering: false,
            caption: i == 0 ? "N/A" : thisCol.ColumnLabel,
            dataField: "Size" + i + "Qty",
            alignment: "right",
            name: i,
            minWidth: this.gridColumnMinWidth(50),
            allowEditing: true,
            editCellTemplate: "sizeQtyEditTemplate",
            showEditorAlways: true,
          });
        }
      }
      this.soGridViewColumns = cols;
    },

    loadSizeTotalColumns(validColumns) {
      let sizeTotalCols = [];

      let decimalFormat = this.getDecimalFormatByName("Decimal-6-2");

      sizeTotalCols.push({
        productSizeCode: "",
        sequence: 0,
        caption: "N/A",
        dataField: "Size0",
        alignment: "right",
        allowEditing: false,
        width: decimalFormat.Width,
        format: decimalFormat.Format,
      });

      for (let i = 0; i <= 20; i++) {
        let record = validColumns.find((s) => s.Sequence == i);

        if (record) {
          sizeTotalCols.push({
            productSizeCode: record.Code,
            sequence: record.Sequence,
            caption: record.Code,
            dataField: "Size" + i,
            alignment: "right",
            allowEditing: false,
            width: decimalFormat.Width,
            format: decimalFormat.Format,
          });
        }
      }

      this.sizeTotalGridColumns = sizeTotalCols;
    },
    async loadCurrentViewData() {
      // this.clearAdvanceFilters();
      reviewModeSearchText =
        soDetailsGridInstance._options._optionManager._options.searchPanel.text;
      this.updateSoDetailsGridColumns();
      if (this.isTablet) this.clearFocusedCell();
      this.categorySelectionDisabled = false;

      if (this.soDetailsCurrentView == "Review") {
        this.clearAdvanceFilters(); // clear advanced filters in review mode
        this.categorySelectionDisabled = true;
        this.defaultFilters.default = this.defaultFilters.reviewListViewFilter;
        this.salesOrderDetailsDataSourceConfig = soDetailsReviewListDataSource.items();
        this.getProductPromoDetails();
      } else if (this.soDetailsCurrentView == "ProductList") {
        this.defaultFilters.default = this.defaultFilters.productListViewFilter;
        this.salesOrderDetailsDataSourceConfig = soDetailsProductListDataSource;
      } else if (this.soDetailsCurrentView == "CustomerList") {
        this.defaultFilters.default = this.defaultFilters.customerListViewFilter;
        this.salesOrderDetailsDataSourceConfig = soDetailsCustomerListDataSource;
      } else if (this.soDetailsCurrentView == "GridList") {
        this.defaultFilters.default = this.defaultFilters.gridListViewFilter;
        this.loadGridListViewDataSource();
      }

      if (
        this.soDetailsCurrentView !== "GridList" &&
        this.soDetailsCurrentView !== "Review"
      ) {
        if (this.defaultFilters.setCustomFilter.length != 0) {
          let filter = [];
          filter.push(this.defaultFilters.default);
          filter.push("and");
          filter.push(this.defaultFilters.setCustomFilter);
          this.salesOrderDetailsDataSourceConfig.filter(filter);
        } else {
          this.salesOrderDetailsDataSourceConfig.filter(
            this.defaultFilters.default
          );
        }
      }
      // this.soDetailsGrid && this.soDetailsGrid.refresh();
      // this.refreshView();
    },

    onAddClickHandler() {
      let grid = this.$refs[this.gridRefName].instance;
      grid.addRow();
    },
    handleTabRouteChange() {
      // if (this.baseView.mode == "edit") {
      //   this.customerCodeInstance.$options.propsData.options.value = this.model.CustomerCode;
      //   this.customerCodeInstance.repaint();
      // }

      setTimeout(() => {
        this.setTabSelection();
      }, 100);
    },
    contextItemClick(e) {
      if (!e.itemData.items) {
        if (e.itemData.text == "Order Comments") {
          this.commentsPopupVisible = true;
        } else if (e.itemData.text == "Order Notes") {
          this.notesPopupVisible = true;
        }
      }
    },
    async getRecord() {
      return await SalesOrderService.getByCode(this.baseView.id);
    },
    async getDefaults() {
      return await DefaultCompanyBranchDivisionService.getDefault();
    },
    async getFactor(code) {
      return await FactorService.getByCode(code);
    },
    itemClick(e) {
      this.$router.push({
        path: e.itemData.path,
      });
    },
    async cancelSalesOrder() {
      this.showLoading(true);
      var payload = {
        Code: this.baseView.id,
      };
      await SalesOrderService.cancelSalesOrder(payload)
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          // this.$logger.debug("result ", result);
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-order`,
          });
        })
        .catch((error) => {
          this.displayValidationSummary([]);
          this.showLoading(false);
          // this.$logger.debug("error ", error);

          if (error.data.error.innererror) {
            this.addErrorMessage(error.data.error.innererror.message);
            this.displayValidationSummary();
          } else if (error.data.error.message) {
            this.addErrorMessage(
              JSON.parse(error.data.error.message)[0].ErrorMessage
            );
            this.displayValidationSummary();
          } else {
            this.$notify("Cancel sales order Failed", "error");
          }
        });
    },
    loadCustomerSalesContracts() {
      if (!this.SalesContractDrawdownEnabled) return;
      this.CustomerSalesContracts.loadCustomerContractItems(
        this.model.CustomerCode,
        this.model.Code,
        soDetailsReviewListDataSource.items()
      );
    },
    async saveSalesOrder(status) {
      this.model.SalesOrderDetails = this.getSoDetailsSavePayload();
      if (this.model.SalesOrderDetails.length == 0) {
        this.displayValidationSummary([]);
        this.addErrorMessage(`Sales Order contains no lines`);
        this.displayValidationSummary();

        return;
      }
      // let validationResult = await validationEngine.validateGroup(
      //   this.formsConfig.validationGroup
      // );

      // let vr2 = validationEngine.validateGroup("headerFormData");
      // if (!validationResult.isValid || !vr2.isValid) {
      //   var value = validationResult.brokenRules.concat(vr2.brokenRules);
      //   this.addErrorMessagesFromValidationResult({
      //     brokenRules: value,
      //   });
      //   this.displayCustomValidationSummary();
      //   return;
      // }

      // if (!validationResult.isValid) {
      //   this.displayValidationSummary();
      //   return;
      // }

      var checkAvailability = false;

      soDetailsReviewListDataSource.items().forEach((element) => {
        if (element.SalesUMQty > element.Available && element.SalesUMQty > 0) {
          checkAvailability = true;
        }
      });

      if (checkAvailability) {
        let confirmSaving = await this.$confirm(
          `There is not enough stock to fulfil the order, would you like to continue?`,
          "Stock Levels"
        );

        if (!confirmSaving) {
          return;
        }
      }

      this.showLoading(true);
      await SalesOrderService.saveSalesOrder(
        this.getSoSavePayload(status),
        this.model.Code
      )
        .then((res) => {
          this.showLoading(false);
          let newRecordSaved = false;
          if (this.baseView.mode == "create") {
            newRecordSaved = true;
            this.model.Code = res.data.Code;
          }
          this.$notify(
            `Sales Order ${this.model.Code} Successfully Saved`,
            "success"
          );

          this.loadCustomerSalesContracts();

          if (this.model.isPendingEDIOrder) {
            SalesOrderEDIService.sendSalesOrderEDIPOA(this.model.Code).catch(
              (error) => {
                this.displayServerError(error, "Save sales order Failed");
              }
            );

            this.model.isPendingEDIOrder = false;
            // HACK not having the menu items as computed
            this.toolbar.menu.items[0].disabled = true;
            this.toolbar.menu.items[1].disabled = false;
            this.toolbar.menu.items[2].disabled = true;

            let toolbar = this.$refs["toolbar-header"].instance;
            toolbar.repaint();

            let grid = this.$refs[this.soDetailsGridRefName].instance;
            grid.repaint();
          }

          let destinationMode = this.model.Status == "D" ? "edit" : "review";
          let destinationTab = this.selectedIndex == 0 ? "header" : "details";
          if (this.soDetailsCurrentView != "GridList") {
            if (destinationMode == "review") {
              this.soDetailsCurrentView = "Review";
            }
          }
          if (this.baseView.mode !== destinationMode) {
            screenModeChanged = true;
          }

          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-order-old/${destinationMode}/${this.model.Code}/${destinationTab}`,
          });
          if (newRecordSaved) this.intialize();
        })
        .catch((error) => {
          this.displayServerError(error, "Save sales order Failed");
        });
    },

    getSoSavePayload(status) {
      this.model.Status = status;

      this.model.SalesOrderDetails = this.getSoDetailsSavePayload();

      this.model.ExTaxTotal = this.computedFXExTaxTotal;
      this.model.TaxTotal = this.computedFXTaxTotal;
      this.model.ItemCount = this.computedStockItemCount;
      this.model.Total = this.computedFXTotal;

      if (!this.model.CustomerDeliveryAddressLineNo)
        this.model.CustomerDeliveryAddressLineNo = "1";

      let {
        BranchCode,
        Code,
        CompanyCode,
        ConsignmentNo,
        CurrencyCode,
        CustomerCode,
        CustomerDeliveryAddressLineNo,
        DateIn,
        DeliveryAddressCompanyName,
        DeliveryAddressCountry,
        DeliveryAddressPostcode,
        DeliveryAddressState,
        DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2,
        DeliveryAddressSuburb,
        DivisionCode,
        ExchangeRate,
        ExTaxTotal,
        ItemCount,
        OrderNo,
        RequiredByDate,
        SalesOrderDetails,
        SalesOrderNotes,
        SalesOrderTypeCode,
        SalesRepresentativeCode,
        ShipDate,
        Status,
        TaxTotal,
        Total,
        UserComment1,
        UserComment2,
        UserComment3,
        UserComment4,
        UserComment5,
        UserComment6,
        UserComment7,
        UserComment8,
        UserComment9,
        UserComment10,
        UserComment11,
        UserComment12,
        UserComment13,
        UserComment14,
        UserComment15,
        UserComment16,
        UserComment17,
        UserComment18,
        UserComment19,
        UserComment20,
      } = this.model;

      TaxTotal = this.computedTaxTotal;
      ExTaxTotal = this.computedExTaxTotal;
      Total = this.computedTotal;
      DateIn = DateIn.toSaveDate();
      RequiredByDate = RequiredByDate.toSaveDate();
      ShipDate = ShipDate.toSaveDate();

      let payload = {
        BranchCode,
        Code,
        CompanyCode,
        ConsignmentNo,
        CurrencyCode,
        CustomerCode,
        CustomerDeliveryAddressLineNo,
        DateIn,
        DeliveryAddressCompanyName,
        DeliveryAddressCountry,
        DeliveryAddressPostcode,
        DeliveryAddressState,
        DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2,
        DeliveryAddressSuburb,
        DivisionCode,
        ExchangeRate,
        ExTaxTotal,
        ItemCount,
        OrderNo,
        RequiredByDate,
        SalesOrderDetails,
        SalesOrderNotes,
        SalesOrderTypeCode,
        SalesRepresentativeCode,
        ShipDate,
        Status,
        TaxTotal,
        Total,
        UserComment1,
        UserComment2,
        UserComment3,
        UserComment4,
        UserComment5,
        UserComment6,
        UserComment7,
        UserComment8,
        UserComment9,
        UserComment10,
        UserComment11,
        UserComment12,
        UserComment13,
        UserComment14,
        UserComment15,
        UserComment16,
        UserComment17,
        UserComment18,
        UserComment19,
        UserComment20,
      };

      this.$logger.debug("save payload", JSON.stringify(payload));

      return payload;
    },
    getSoDetailsSavePayload() {
      return (
        soDetailsReviewListDataSource
          .items()
          // .filter((x) => x.SalesUMQty > 0)
          .map((x) => {
            x.LineNo = x.copiedLine ? 0 : x.LineNo;
            x.TaxLineTotal = parseFloat(x.TaxLineTotal).roundNumber(2);

            if (x.RequiredByDate && x.RequiredByDate instanceof Date) {
              x.RequiredByDate = x.RequiredByDate.toSaveDate();
            }

            if (x.ShipDate && x.ShipDate instanceof Date) {
              x.ShipDate = x.ShipDate.toSaveDate();
            }

            let {
              AddDiscPriceGroupCode,
              AddDiscPricingMethod,
              AddDiscPricingMethodValue,
              AddDiscSalesUMPrice,
              AddDiscStockUMPrice,
              CalculatedDiscPcnt,
              Comment,
              CustomerProduct,
              CustomerSalesContractCode,
              CustomerSalesContractLineNo,
              DiscFXLineTotal,
              DiscLineTotal,
              DiscPcnt,
              ExTaxUnitCost,
              FXLineTotal,
              IsCommentVisible,
              IsPrimeCostItem,
              ItemCode,
              ItemType,
              KitVersion,
              LineNo,
              LineTotal,
              NetFXLineTotal,
              NetLineTotal,
              PriceGroupCode,
              PriceGroupSalesUMPrice,
              PriceGroupStockUMPrice,
              PricingMethod,
              PricingMethodValue,
              RecordId,
              RequiredByDate,
              SalesTaxPcnt,
              SalesUM,
              SalesUMConversion,
              SalesUMCost,
              SalesUMFXPrice,
              SalesUMIsVariable,
              SalesUMManufacturedCost,
              SalesUMNetFXPrice,
              SalesUMNetPrice,
              SalesUMPrice,
              SalesUMPromotionNetPrice,
              SalesUMQty,
              SalesUMStandardCost,
              SalesUMStandardPrice,
              ShipDate,
              Status,
              StockUM,
              StockUMFXPrice,
              StockUMManufacturedCost,
              StockUMNetFXPrice,
              StockUMNetPrice,
              StockUMPrice,
              StockUMQty,
              StockUMStandardCost,
              StockUMStandardPrice,
              TaxableFXLineTotal,
              TaxableLineTotal,
              TaxCode,
              TaxFXLineTotal,
              TaxLineTotal,
              WetFreightAdjustment,
              WetFXFreightAdjustment,
              WetFXLineTotal,
              WetLineTotal,
              WetPcnt,
              BestBeforeDate,
            } = x;
            return {
              AddDiscPriceGroupCode,
              AddDiscPricingMethod,
              AddDiscPricingMethodValue,
              AddDiscSalesUMPrice,
              AddDiscStockUMPrice,
              CalculatedDiscPcnt,
              Comment,
              CustomerProduct,
              CustomerSalesContractCode,
              CustomerSalesContractLineNo,
              DiscFXLineTotal,
              DiscLineTotal,
              DiscPcnt,
              ExTaxUnitCost,
              FXLineTotal,
              IsCommentVisible,
              IsPrimeCostItem,
              ItemCode,
              ItemType,
              KitVersion,
              LineNo,
              LineTotal,
              NetFXLineTotal,
              NetLineTotal,
              PriceGroupCode,
              PriceGroupSalesUMPrice,
              PriceGroupStockUMPrice,
              PricingMethod,
              PricingMethodValue,
              RecordId,
              RequiredByDate,
              SalesTaxPcnt,
              SalesUM,
              SalesUMConversion,
              SalesUMCost,
              SalesUMFXPrice,
              SalesUMIsVariable,
              SalesUMManufacturedCost,
              SalesUMNetFXPrice,
              SalesUMNetPrice,
              SalesUMPrice,
              SalesUMPromotionNetPrice,
              SalesUMQty,
              SalesUMStandardCost,
              SalesUMStandardPrice,
              ShipDate: ShipDate,
              Status,
              StockUM,
              StockUMFXPrice,
              StockUMManufacturedCost,
              StockUMNetFXPrice,
              StockUMNetPrice,
              StockUMPrice,
              StockUMQty,
              StockUMStandardCost,
              StockUMStandardPrice,
              TaxableFXLineTotal,
              TaxableLineTotal,
              TaxCode,
              TaxFXLineTotal,
              TaxLineTotal,
              WetFreightAdjustment,
              WetFXFreightAdjustment,
              WetFXLineTotal,
              WetLineTotal,
              WetPcnt,
              BestBeforeDate,
            };
          })
      );
    },
    backButtonFunction() {
      this.$router.push({
        path: "/sales-order",
      });
    },
    branchCodeExistsRuleCallback(params) {
      // this.$logger.debug("+++++++++++++++++++++++ ", params);
      return new Promise((resolve) => {
        BranchService.getByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.BranchCode = response.data.value[0].Code;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    divisionCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        DivisionService.getByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.DivisionCode = response.data.value[0].Code;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    soTypeCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        SalesOrderTypeService.getByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.SalesOrderTypeCode = response.data.value[0].Code;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },

    customerCodeExistsRuleCallback(params) {
      return new Promise((resolve) => {
        CustomerService.getByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.CustomerCode = response.data.value[0].Code;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },

    salesRepExistsRuleCallback(params) {
      return new Promise((resolve) => {
        SalesRepresentativeService.getByCode(params.value).then((response) => {
          if (response.data.value.length > 0) {
            this.model.SalesRepresentativeCode = response.data.value[0].Code;
            this.model.FirstName = response.data.value[0].FirstName;
            this.model.Surname = response.data.value[0].Surname;
            this.model.SalesRepresentativeName = `${this.model.FirstName} ${this.model.Surname}`;
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    // deliveryAddressExistsRuleCallback(params) {
    //   return new Promise((resolve) => {
    //     CustomerDeliveryAddressService.getByName(params.value).then(
    //       (response) => {
    //         if (response.data.value.length > 0) {
    //           this.model.DeliveryAddressCompanyName =
    //             response.data.value[0].CompanyName;
    //           // this.model.DeliveryAddressStreetLine1 =
    //           //   response.data.value[0].PhysicalAddressStreetLine1;
    //           // this.model.DeliveryAddressStreetLine2 =
    //           //   response.data.value[0].PhysicalAddressStreetLine2;
    //           // this.model.DeliveryAddressSuburb =
    //           //   response.data.value[0].PhysicalAddressSuburb;
    //           // this.model.DeliveryAddressState =
    //           //   response.data.value[0].PhysicalAddressState;
    //           // this.model.DeliveryAddressPostcode =
    //           //   response.data.value[0].PhysicalAddressPostcode;
    //           // this.model.DeliveryAddressCountry =
    //           //   response.data.value[0].PhysicalAddressCountry;
    //           resolve(true);
    //         } else {
    //           resolve(true);
    //         }
    //       }
    //     );
    //   });
    // },
    preSelectDeliveryAddress(Code) {
      this.$logger.debug("zzzzzz ", Code);
      if (!Code) {
        this.model.DeliveryAddressCompanyName = "";
        this.model.DeliveryAddressStreetLine1 = "";
        this.model.DeliveryAddressStreetLine2 = "";
        this.model.DeliveryAddressSuburb = "";
        this.model.DeliveryAddressState = "";
        this.model.DeliveryAddressPostcode = "";
        this.model.DeliveryAddressCountry = "";
        return;
      }

      // CustomerDeliveryAddressService.getCustomRequest({
      //   url: "api/CustomerDeliveryAddress",
      //   select: [
      //     "CompanyName",
      //     "PhysicalAddressStreetLine1",
      //     "PhysicalAddressStreetLine2",
      //     "PhysicalAddressSuburb",
      //     "PhysicalAddressState",
      //     "PhysicalAddressPostcode",
      //     "PhysicalAddressCountry",
      //   ],
      //   // filter: [["CustomerCode","=",Code], "and" ,["LineNo","=",'1']],
      //   filter: `CustomerCode eq '${Code}' and LineNo eq 1`,
      // })
      //   .then((response) => {
      //     this.$logger.debug("preSelectDeliveryAddress result ", response);
      //     this.model.DeliveryAddressCompanyName =
      //       response.data.value[0].CompanyName;
      //     this.model.DeliveryAddressStreetLine1 =
      //       response.data.value[0].PhysicalAddressStreetLine1;
      //     this.model.DeliveryAddressStreetLine2 =
      //       response.data.value[0].PhysicalAddressStreetLine2;
      //     this.model.DeliveryAddressSuburb =
      //       response.data.value[0].PhysicalAddressSuburb;
      //     this.model.DeliveryAddressState =
      //       response.data.value[0].PhysicalAddressState;
      //     this.model.DeliveryAddressPostcode =
      //       response.data.value[0].PhysicalAddressPostcode;
      //     this.model.DeliveryAddressCountry =
      //       response.data.value[0].PhysicalAddressCountry;

      //     let form = this.$refs[this.gridRefName].instance;
      //     form.repaint();
      //   })
      //   // eslint-disable-next-line no-unused-vars
      //   .catch((err) => {
      //     // this.$logger.debug("preSelectDeliveryAddress err ", err);
      //   });
    },
    popUpBackButtonClick() {
      this.popupVisible = false;
      this.gridTotalsVisible = false;
      this.notesPopupVisible = false;
      this.commentsPopupVisible = false;
      this.itemHistoryPopupVisible = false;
      this.productDetailsPopupVisible = false;
      this.gpToolPopupVisible = false;
      this.bestBeforeDatePopupVisible = false;

      this.tabletModeSelectPopupVisible = false;

      // this.$refs["itemHistoryGrid"].instance.clearFilter("row");

      this.$logger.debug("########################");
    },
    popupLineCommentBackButtonClick() {
      this.updateDataSource(
        this.getCurrentSoDetailsDataSource(),
        currentRowIndex,
        "Comment",
        this.lineCommentModel.Comment
      );
      this.updateDataSource(
        this.getCurrentSoDetailsDataSource(),
        currentRowIndex,
        "IsCommentVisible",
        this.lineCommentModel.IsCommentVisible
      );
      this.lineCommentsPopupVisible = false;
    },
    // onToolbarPreparing(e) {
    //   e.toolbarOptions.items.unshift({
    //     location: "before",
    //     template: "totalOutstanding"
    //   });
    // },

    setMaxLength(e) {
      // this.$logger.debug('******************* ', e);
      if (e.parentType == "dataRow" && e.dataField == "Note") {
        e.editorOptions.maxLength = 1000;
      }
    },
    // eslint-disable-next-line no-unused-vars

    onRowClick(e) {
      if (this.baseView.mode != "review") {
        // this.$logger.debug("row click", e);
        let grid = this.$refs[this.gridRefName].instance;
        grid.editRow(e.rowIndex);
      }
    },

    setSaleItemPriceAllLines() {
      if (soDetailsReviewListDataSource.items().length > 0) {
        var promises = [];

        for (var i = 0; i < soDetailsReviewListDataSource.items().length; i++) {
          var record = soDetailsReviewListDataSource.items()[i];
          promises.push(
            SalesOrderService.setSaleItemPrice(
              // REPRICE ALL
              record,
              this.model.SalesOrderTypeCode,
              this.model.BranchCode,
              this.model.CustomerCode,
              this.model.ExchangeRate,
              this.model.DateIn,
              new Date(this.model.RequiredByDate),
              false
            )
          );
        }

        var that = this;

        Promise.all(promises).then(function() {
          // this.$logger.debug("All SO details line prices are set");
          that.refreshView();
        });

        // // update the promotion state of line items in the Sales Order Detail List
        // var primaryList = window.ViewModel.getListByName("Sales Order Detail List");
        // var currentActiveViewListRecords = primaryList.getActiveAlternateViewListRecords();

        // new SalesItemPromotionHelper().loadSalesItemPromotion(primaryList.ListRecords, currentActiveViewListRecords);
      }
    },
    async clickOnImage(data) {
      this.showLoading(true);
      this.productDetails.data = data.data;
      this.productDetailsPopupVisible = true;
      this.$logger.trackEventOpenPopup("Sales Order Product Details");

      this.productDetails.model.itemCode = data.data.ItemCode;
      this.productDetails.model.salesUM = data.data.SalesUM;
      this.getProductUnitOfMeasure(data.data);

      this.$logger.debug("data :", data);
      this.$logger.debug(
        "this.productDetails.data :",
        this.productDetails.data
      );
      this.$logger.debug(
        "this.productDetails.data :",
        this.productDetails.data["Description"]
      );
      this.$logger.debug(
        "this.productDetails.data :",
        this.productDetails.data["ItemCode"]
      );

      if (this.productDetails.data.HasPrimaryImage) {
        let itemCode = data.data.ItemCode;
        if (this.soDetailsCurrentView == "GridList") {
          itemCode = data.data.PrimaryImageItemCode;
        }
        await ApiService.get(
          "/api/ProductPrimaryImage?itemCode=" + itemCode
        ).then((res) => {
          var src = "data:image;base64," + res.data.value;
          this.productDetails.imageURL = src;
          // // eslint-disable-next-line no-console
          // this.$logger.debug("res ::", res);
        });
      }
    },
    async getProductUnitOfMeasure(data) {
      var that = this;
      that.productDetails.hasPromotion = false;
      that.productDetails.model.promotionStartDate = null;
      that.productDetails.model.promotionEndDate = null;
      that.$refs["product-details-form"].instance.repaint();

      await SalesOrderProductDetails.getProductUnitOfMeasure(
        data.ItemCode,
        this.model.BranchCode
      )
        .then((result) => {
          // this.$logger.debug("result  :", result);

          if (data.PriceGroupCode != 0 && data.PriceGroupCode != null) {
            PriceGroupService.getByCode(data.PriceGroupCode).then((result1) => {
              that.productDetails.hasPromotion =
                result1.data.value[0].DateControlled;
              that.productDetails.model.promotionStartDate =
                result1.data.value[0].SellStartDate;
              that.productDetails.model.promotionEndDate =
                result1.data.value[0].SellEndDate;

              that.$refs["product-details-form"].instance.repaint();
            });
          }

          this.productDetails.model.apn = result.data.value[0].Product.APN;
          this.productDetails.model.cartonQty =
            result.data.value[0].Product.PackSize;
          this.productDetails.model.standardSell =
            result.data.value[0].StandardSell;
          if (data.SalesUMQty == 0) {
            this.productDetails.model.customerSell =
              result.data.value[0].StandardSell;
          } else {
            this.productDetails.model.customerSell = this.productDetails.data.SalesUMPrice;
          }

          this.showLoading(false);
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          // this.$logger.debug("err  :", err);
          this.showLoading(false);
        });
    },
  },
};
</script>

<style lang="scss">
.hyper-link {
  cursor: pointer;
}

.hyper-link.color {
  color: #03a9f4;
}
</style>
